
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4luml", function(module, exports) {
/**
 * @generated SignedSource<<8d268486129eb83432e8c8e123e9918d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a8e9106aebd1e6da$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateReactionInCacheFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "ari"
        },
        {
            "kind": "ScalarField",
            "name": "containerAri"
        },
        {
            "kind": "ScalarField",
            "name": "reactionsCount"
        },
        {
            "concreteType": "ReactionsSummaryForEmoji",
            "kind": "LinkedField",
            "name": "reactionsSummaryForEmoji",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "emojiId"
                },
                {
                    "kind": "ScalarField",
                    "name": "count"
                },
                {
                    "kind": "ScalarField",
                    "name": "reacted"
                },
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        }
    ],
    "type": "ReactionsSummaryResponse"
};
$a8e9106aebd1e6da$var$node.hash = "94bb7aa669a3f8af9f245251eef1cc84";
var $a8e9106aebd1e6da$export$2e2bcd8739ae039 = $a8e9106aebd1e6da$var$node;



var $42omo = parcelRequire("42omo");


var $ij4CE = parcelRequire("ij4CE");


var $fFmJj = parcelRequire("fFmJj");


// reactionsSummary is not supported in the normal Comment fragment cache update functions because
// GQL fragments do not support nested arguments in fragments. However, while the reactionsSummary
// objects do not have an explicit ID field, they are uniquely identified in the cache by the
// combination of its arguments. So in this file we create a separate fragment and associated
// function to update just comment reactions in cache (where the arguments effectively become a
// first-level arguments to the fragment and not a nested ones). And this is okay, because the
// reactionsSummary is (so far) always updated separately from the rest of the comment data.
const $e3927c03ed2b5188$var$updateReactionInCacheFragment = (0, $a8e9106aebd1e6da$export$2e2bcd8739ae039);
/**
 * Adds a new reaction to the cached reactions summary.
 * @param props
 * @param props.reactionMutationPayload - The payload result of the add reaction mutation.
 * @param props.cachedReactionsSummary - The current cached reactions summary.
 * @param props.emojiId - The ID of the emoji being added.
 * @returns
 */ const $e3927c03ed2b5188$var$addReaction = ({ reactionMutationPayload: reactionMutationPayload, cachedReactionsSummary: cachedReactionsSummary, emojiId: emojiId })=>{
    const { reactionsCount: reactionsCount, reactionsSummaryForEmoji: reactionsSummaryForEmoji } = cachedReactionsSummary || {};
    const newReactionsAri = reactionMutationPayload.ari;
    const newReactionsContainerAri = reactionMutationPayload.containerAri;
    // (Use passed-in emojiId rather than mutationResult data as it's possible that it's not in the result)
    // Manually create a deep copy of the cached reactions, as the Relay-style readFragment types
    // are read-only objects and properties cannot be modified directly.  updatedReactions is a mutable
    // array of readonly reaction objects.
    const updatedReactions = [
        ...reactionsSummaryForEmoji || []
    ];
    let updatedReactionsCount = reactionsCount || 0;
    // Try to find the emojiId in the existing reactionsSummary
    const foundReactionIdx = updatedReactions.findIndex((reaction)=>reaction && reaction?.emojiId === emojiId);
    // If the reaction already exists, update its attributes.  If not, create a new one.
    const foundReaction = foundReactionIdx !== -1 ? updatedReactions[foundReactionIdx] : undefined;
    if (foundReaction && !foundReaction.reacted) {
        // Create an immutable new updated reaction object so typescript is happy
        const updatedReaction = {
            ...foundReaction,
            count: foundReaction.count ? foundReaction.count + 1 : 1,
            reacted: true
        };
        updatedReactions[foundReactionIdx] = updatedReaction;
        updatedReactionsCount += 1;
    } else if (!foundReaction) {
        // Otherwise, create a new reaction
        const newReaction = {
            emojiId: emojiId,
            count: 1,
            reacted: true,
            id: `${newReactionsContainerAri}|${newReactionsAri}|${emojiId}`,
            __typename: 'ReactionsSummaryForEmoji'
        };
        updatedReactions.push(newReaction);
        updatedReactionsCount += 1;
    }
    return {
        ...cachedReactionsSummary,
        reactionsSummaryForEmoji: updatedReactions,
        reactionsCount: updatedReactionsCount
    };
};
/**
 * deletes an existing reaction to the cached reactions summary.
 * @param props
 * @param props.reactionMutationPayload - The payload result of the add reaction mutation.
 * @param props.cachedReactionsSummary - The current cached reactions summary.
 * @param props.emojiId - The ID of the emoji being removed.
 * @returns
 */ const $e3927c03ed2b5188$var$deleteReaction = ({ cachedReactionsSummary: cachedReactionsSummary, emojiId: emojiId })=>{
    const { reactionsCount: reactionsCount, reactionsSummaryForEmoji: reactionsSummaryForEmoji } = cachedReactionsSummary || {};
    // (Use passed-in emojiId rather than mutationResult data as it's posible that it's not in the result)
    // Manually create a deep copy of the cached creactions, as the Relay-style readFragment types
    // are read-only objects and properties cannot be modified directly. updatedReactions is an mutable
    // array of readonly reaction objects.
    const updatedReactions = [
        ...reactionsSummaryForEmoji || []
    ];
    let updatedReactionsCount = reactionsCount || 1;
    // Try to find the emojiId in the existing reactionsSummary
    const foundReactionIdx = updatedReactions.findIndex((reaction)=>reaction && reaction?.emojiId === emojiId);
    // If reaction exists, update its attributes
    const foundReaction = foundReactionIdx !== -1 ? updatedReactions[foundReactionIdx] : undefined;
    if (foundReaction) {
        if (foundReaction.count > 1 && foundReaction.reacted) {
            // Create an immutable new updated reaction object so typescript is happy
            const updatedReaction = {
                ...foundReaction,
                count: (updatedReactions[foundReactionIdx]?.count ?? 0) - 1,
                reacted: false
            };
            updatedReactions[foundReactionIdx] = updatedReaction;
            updatedReactionsCount -= 1;
        } else if (foundReaction.count == 1 && foundReaction.reacted) {
            // Otherwise, remove the reaction entirely
            updatedReactions.splice(foundReactionIdx, 1);
            updatedReactionsCount -= 1;
        }
    }
    return {
        ...cachedReactionsSummary,
        reactionsSummaryForEmoji: updatedReactions,
        reactionsCount: updatedReactionsCount
    };
};
const $e3927c03ed2b5188$export$c06964678bc6148c = ()=>{
    const readFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: $e3927c03ed2b5188$var$updateReactionInCacheFragment,
        __callerPackage__: "@confluence/comments-data-manager"
    });
    const writeFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $a8e9106aebd1e6da$export$2e2bcd8739ae039),
        fragmentSpec: $e3927c03ed2b5188$var$updateReactionInCacheFragment,
        __callerPackage__: "@confluence/comments-data-manager"
    });
    /**
   * Function to update a comment in the Apollo cache.
   * @param mutationResult - The result of the mutation that triggered the cache update
   * @param commentId - ID of the comment to update
   * @param	pageId - ID of the page containing the comment
   * @param contentType - The content type ('page' or 'blogpost', etc.)
   * @param	emojiId - The emoji for the reaction being added or deleted
   * @param actionType - The type of action being performed ('add' or 'delete')
   * @param onError - Optional error callback to handle errors during the update process
   */ const updateReactionInCache = (0, $42omo.useCallback)(({ mutationResult: mutationResult, commentId: commentId, pageId: pageId, contentType: contentType, actionType: actionType, emojiId: emojiId, onError: onError })=>{
        if (!commentId) {
            onError?.(new Error('Cannot update comment reactions in cache: comment ID is missing'));
            return;
        }
        if (!pageId) {
            onError?.(new Error('Cannot update comment reactions in cache: page ID is missing'));
            return;
        }
        try {
            // The fragment ID format for Apollo cache
            const fragmentId = `$Comment:${commentId}.reactionsSummary({"childType":"comment","contentType":"${contentType}","pageId":"${pageId}"})`;
            // Read the comment's reaction from cache
            const cachedReactionsSummary = readFragment({
                id: fragmentId
            });
            if (!cachedReactionsSummary) {
                // (There is a slight chance the reactionsSummary is not in cache - but the mutation that
                // calls this function would have to completed successfully to call us, so presumably the
                // reactionsSummary existed then. Even if another user deleted the owning comment, its item
                // in the cache remains. So not being in the cache is unlikely, so let's log this as an
                // error and return. If in the future we find the legit use case is happening more often, we
                // can change to a warning instead.)
                onError?.(new Error(`Cannot update comment reactions in cache: comment reactions with ID ${commentId} and page ID ${pageId} not found in cache`));
                return;
            }
            const payload = mutationResult.data ?? undefined;
            let reactionMutationPayload;
            if (payload) {
                if ('confluence_addReaction' in payload) reactionMutationPayload = payload.confluence_addReaction || undefined;
                else if ('deleteReaction' in payload) reactionMutationPayload = payload.deleteReaction || undefined;
            }
            if (!reactionMutationPayload) {
                onError?.(new Error('Cannot update comment reactions in cache: mutation result data is missing'));
                return;
            }
            let updatedReactionsSummary;
            const reactionActionProps = {
                reactionMutationPayload: reactionMutationPayload,
                cachedReactionsSummary: cachedReactionsSummary,
                emojiId: emojiId
            };
            switch(actionType){
                case 'add':
                    updatedReactionsSummary = $e3927c03ed2b5188$var$addReaction(reactionActionProps);
                    break;
                case 'delete':
                    updatedReactionsSummary = $e3927c03ed2b5188$var$deleteReaction(reactionActionProps);
                    break;
                default:
                    onError?.(new Error(`Unknown comment reactions cache operation specified: ${actionType}`));
                    return;
            }
            // Write the updated comment back to cache
            writeFragment({
                fragmentId: fragmentId,
                data: updatedReactionsSummary
            });
        } catch (err) {
            onError?.(new Error(`An error occurred when updating cached comment reactions data: ${err}`));
            return;
        }
    }, [
        readFragment,
        writeFragment
    ]);
    return {
        updateReactionInCache: updateReactionInCache
    };
};
module.exports["useUpdateReactionInCache"] = $e3927c03ed2b5188$export$c06964678bc6148c;

});

parcelRegister("6Ebso", function(module, exports) {
/**
 * @generated SignedSource<<ff054c809fe6b0fbd9bbf70e637687dc>>
 * @relayHash a9d90e15ebce13405ca919353f45763b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aed3d5f7bfb7c2dbcf6552f34205d78e31581555221514979a1f6dd3be14943a
const $b3f7eb06d9ddc8f8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentIdToDelete"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "deleteFrom"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentIdToDelete",
                    "variableName": "commentIdToDelete"
                },
                {
                    "kind": "Variable",
                    "name": "deleteFrom",
                    "variableName": "deleteFrom"
                }
            ],
            "kind": "ScalarField",
            "name": "deleteComment"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "DeleteInlineCommentMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "DeleteInlineCommentMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a9d90e15ebce13405ca919353f45763b",
            "id": "aed3d5f7bfb7c2dbcf6552f34205d78e31581555221514979a1f6dd3be14943a",
            "metadata": {},
            "name": "DeleteInlineCommentMutation",
            "operationKind": "mutation",
            "text": "mutation DeleteInlineCommentMutation($commentIdToDelete:ID!,$deleteFrom:CommentDeletionLocation){deleteComment(commentIdToDelete:$commentIdToDelete,deleteFrom:$deleteFrom)}"
        }
    };
}();
$b3f7eb06d9ddc8f8$var$node.hash = "e53519cb9cddfbbbedc1b66e8a4b57ee";
var $b3f7eb06d9ddc8f8$export$2e2bcd8739ae039 = $b3f7eb06d9ddc8f8$var$node;


const $9d5f2b2aa1f9b17f$export$549cff8431cdc668 = (0, $b3f7eb06d9ddc8f8$export$2e2bcd8739ae039);
module.exports["DeleteInlineCommentMutation"] = $9d5f2b2aa1f9b17f$export$549cff8431cdc668;

});

parcelRegister("8z9UY", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 *
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $651b67533e11f043$export$26bc7a3bb70e176c = /*#__PURE__*/ function(CommentDeletionLocation) {
    CommentDeletionLocation["EDITOR"] = "EDITOR";
    CommentDeletionLocation["LIVE"] = "LIVE";
    return CommentDeletionLocation;
}({});
module.exports["CommentDeletionLocation"] = $651b67533e11f043$export$26bc7a3bb70e176c;

});

parcelRegister("7qvmT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $caRYB = parcelRequire("caRYB");


var $bAT9l = parcelRequire("bAT9l");


var $2FFuS = parcelRequire("2FFuS");


var $aoDcQ = parcelRequire("aoDcQ");


var $irVI7 = parcelRequire("irVI7");


var $aJPUt = parcelRequire("aJPUt");


var $aGjYc = parcelRequire("aGjYc");


var $cQCqE = parcelRequire("cQCqE");


var $ag51I = parcelRequire("ag51I");


var $9FoVw = parcelRequire("9FoVw");


var $gtj7V = parcelRequire("gtj7V");


var $g0DaR = parcelRequire("g0DaR");

var $8dA1U = parcelRequire("8dA1U");


var $cD1qu = parcelRequire("cD1qu");


var $87CZC = parcelRequire("87CZC");


var $8i27m = parcelRequire("8i27m");


var $ibqdE = parcelRequire("ibqdE");

/**
 * @generated SignedSource<<8d0925016cb505d7856227fcee0bc937>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $fa7a458b6cf5b633$export$f4016897b165b6d5 = /*#__PURE__*/ function(ContentRepresentation) {
    ContentRepresentation["ATLAS_DOC_FORMAT"] = "ATLAS_DOC_FORMAT";
    ContentRepresentation["EDITOR"] = "EDITOR";
    ContentRepresentation["EDITOR2"] = "EDITOR2";
    ContentRepresentation["EXPORT_VIEW"] = "EXPORT_VIEW";
    ContentRepresentation["PLAIN"] = "PLAIN";
    ContentRepresentation["RAW"] = "RAW";
    ContentRepresentation["STORAGE"] = "STORAGE";
    ContentRepresentation["STYLED_VIEW"] = "STYLED_VIEW";
    ContentRepresentation["VIEW"] = "VIEW";
    ContentRepresentation["WIKI"] = "WIKI";
    return ContentRepresentation;
}({});
var $fa7a458b6cf5b633$export$2dffd0b5373a4389 = /*#__PURE__*/ function(Platform) {
    Platform["ANDROID"] = "ANDROID";
    Platform["IOS"] = "IOS";
    Platform["WEB"] = "WEB";
    return Platform;
}({});
var $fa7a458b6cf5b633$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});



var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $8067e644a2744f7c$export$1d3bc594360cbf99 = 0;
const $8067e644a2744f7c$export$36062d4a94e50365 = 2;
const $8067e644a2744f7c$export$d7989e622f70691f = 5;
const $8067e644a2744f7c$var$shouldTriggerCommentScroll = (event, id)=>{
    if (!id) return false;
    const target = event.target;
    const isContainer = target === event.currentTarget;
    const isCommentBody = Boolean(target.closest(`[data-testid="comment-thread-${id}-parent"]`));
    const isCommentReplyBody = Boolean(target.closest(`[data-testid="comment-thread-${id}-reply-list"]`));
    const replyToggler = Boolean(target.closest('[data-testid="replies-toggler-container"]'));
    // Don't trigger if clicking on specific interactive elements
    const isInteractiveElement = Boolean(target.closest('button, a, input, textarea, [role="button"]'));
    const isEmojiElement = Boolean(target.closest('[data-testid="emoji-add-icon"], [data-emoji-short-name]'));
    const isGeneralReplyScroller = Boolean(target.closest('[data-testid="comments-panel-reply-scroller-container"]'));
    const isFooterCommentThreadLoaded = Boolean(typeof document !== 'undefined' && document.getElementById(`footer-comment-thread-${id}-container`));
    // NOTE - handles scrolling in place of the general reply scroller when the footer comment thread is not yet in the DOM
    // This is a temporary solution until we update our data loading patterns. Once they're updated, this will always be false and can be removed.
    const scrollInPlaceOfGeneralReplyScroller = isGeneralReplyScroller && !isFooterCommentThreadLoaded;
    return (isContainer || isCommentBody || isCommentReplyBody || replyToggler || isGeneralReplyScroller) && (!isInteractiveElement || scrollInPlaceOfGeneralReplyScroller) && !isEmojiElement;
};
const $8067e644a2744f7c$export$8648ea63d9b37934 = (numberOfReplies, isStandaloneComment = false, isParentCommentClosedOrDangling = false)=>{
    if (isParentCommentClosedOrDangling && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux')) return $8067e644a2744f7c$export$1d3bc594360cbf99;
    if (isStandaloneComment && numberOfReplies <= $8067e644a2744f7c$export$d7989e622f70691f) return $8067e644a2744f7c$export$d7989e622f70691f;
    return $8067e644a2744f7c$export$36062d4a94e50365;
};
const $8067e644a2744f7c$export$4ce0bedef4e84bb7 = (isInlineComment)=>isInlineComment ? (0, $irVI7.REPLY_TO_INLINE_COMMENT_PUBLISH_EXPERIENCE) : (0, $irVI7.REPLY_TO_PAGE_COMMENT_PUBLISH_EXPERIENCE);
const $8067e644a2744f7c$export$cda46aad7dff898a = ({ parentComment: parentComment, pageMode: pageMode, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, event: event, handleSelectThread: handleSelectThread })=>{
    const threadKey = parentComment.type === (0, $8i27m.CommentType).INLINE ? parentComment.location.inlineMarkerRef : parentComment.id;
    const isResolved = !parentComment.isOpen;
    // Send a message via bridge api if applicable
    if (threadKey && handleSelectThread) handleSelectThread(threadKey);
    $8067e644a2744f7c$export$e80247d0f3d89e0({
        threadKey: threadKey ?? null,
        isResolved: isResolved,
        pageMode: pageMode,
        setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey,
        commentType: parentComment.type,
        event: event,
        id: parentComment.id
    });
};
const $8067e644a2744f7c$export$e80247d0f3d89e0 = ({ threadKey: threadKey, isResolved: isResolved, pageMode: pageMode, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, commentType: commentType, event: event, id: id })=>{
    // We only scroll the document for non-resolved inline comments or page comments
    if (threadKey && !isResolved) {
        if (event && !$8067e644a2744f7c$var$shouldTriggerCommentScroll(event, id)) setCurrentlySelectedThreadKey(threadKey);
        else setCurrentlySelectedThreadKey(threadKey, commentType);
        if (commentType === (0, $8i27m.CommentType).INLINE && typeof document !== 'undefined') {
            const commentElement = document.getElementById(threadKey);
            if (commentElement) {
                // Determine navigation context based on page mode
                const navigationContext = pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE ? (0, $9FoVw.NavigationContext).EDITOR : (0, $9FoVw.NavigationContext).RENDERER;
                (0, $9FoVw.handleInlineAnnotationNavigation)({
                    scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                    context: navigationContext,
                    block: 'center',
                    inline: 'nearest',
                    markElement: commentElement,
                    annotationId: threadKey
                });
            }
        } else if (commentType === (0, $8i27m.CommentType).GENERAL) (0, $9FoVw.handleFooterCommentsNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            inline: 'nearest',
            commentId: threadKey
        });
    }
};
const $8067e644a2744f7c$var$getEditorCommentType = (commentType, pageMode)=>{
    if (commentType === (0, $8i27m.CommentType).INLINE) return pageMode === (0, $cD1qu.PageMode).VIEW ? 'inline' : 'edit-inline';
    else // i.e. commentType === CommentType.GENERAL
    return 'page';
};
const $8067e644a2744f7c$export$35e3b83b71d833cd = ({ pageId: pageId, parentCommentId: parentCommentId, adf: adf, isEditor: isEditor, pageMode: pageMode, threadKey: threadKey, includeReactionsFlag: includeReactionsFlag, userId: // Below are only used when both CSM and optimistic reply are enabled
userId, displayName: displayName })=>({
        variables: {
            input: {
                containerId: pageId,
                parentCommentId: parentCommentId,
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: (0, $fa7a458b6cf5b633$export$f4016897b165b6d5).ATLAS_DOC_FORMAT
                },
                createdFrom: (0, $g0DaR.getCommentCreationLocation)(isEditor, pageMode === (0, $cD1qu.PageMode).LIVE)
            },
            pageId: pageId,
            includeReactions: includeReactionsFlag
        },
        update: (0, $g0DaR.updateApolloCacheCallback)('create', {
            pageId: pageId,
            contentStatus: [
                'CURRENT',
                'DRAFT'
            ],
            annotationId: threadKey
        }, parentCommentId),
        optimisticResponse: (0, $aGjYc.shouldUseCommentDraftForOptimisticSave)($8067e644a2744f7c$var$getEditorCommentType((0, $8i27m.CommentType).INLINE, pageMode), 'reply') ? (0, $cQCqE.getOptimisticResponse)({
            userId: userId ?? '',
            displayName: displayName ?? '',
            adf: adf,
            pageId: pageId,
            parentCommentId: parentCommentId,
            parentCommentAnnotationId: threadKey
        }) : undefined
    });
const $8067e644a2744f7c$var$buildGeneralReplyOptions = ({ pageId: pageId, cloudId: cloudId, parentCommentId: parentCommentId, adf: adf, includeReactionsFlag: includeReactionsFlag, isReactionsEnabled: isReactionsEnabled })=>({
        variables: {
            pageId: pageId,
            cloudId: cloudId,
            input: {
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: (0, $fa7a458b6cf5b633$export$f4016897b165b6d5).ATLAS_DOC_FORMAT
                },
                commentSource: (0, $fa7a458b6cf5b633$export$2dffd0b5373a4389).WEB,
                containerId: pageId,
                parentCommentId: parentCommentId
            },
            includeReactions: includeReactionsFlag
        },
        update: (0, $87CZC.updateApolloCacheReplyCallback)('create', {
            pageId: pageId,
            contentStatus: [
                'CURRENT',
                'DRAFT'
            ],
            type: [
                'FOOTER'
            ]
        }, parentCommentId, isReactionsEnabled)
    });
const $8067e644a2744f7c$export$e898411b6bdaedf3 = ({ pageId: pageId, cloudId: cloudId, parentCommentId: parentCommentId, adf: adf, addCommentInCommentsDataManagerCacheFn: addCommentInCommentsDataManagerCacheFn, experienceTracker: experienceTracker, isInlineComment: isInlineComment, userId: userId, displayName: displayName })=>({
        variables: {
            cloudId: cloudId,
            input: {
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: (0, $fa7a458b6cf5b633$export$f4016897b165b6d5).ATLAS_DOC_FORMAT
                },
                commentSource: (0, $fa7a458b6cf5b633$export$2dffd0b5373a4389).WEB,
                containerId: pageId,
                parentCommentId: parentCommentId
            },
            pageId: pageId,
            includeReactionsSummary: !(0, $6mKj3.expValEquals)('confluence_fe_use_create_comment_exclude_reactions', 'isEnabled', true)
        },
        update: (...params)=>{
            const [_dataProxy, mutationResult] = params;
            addCommentInCommentsDataManagerCacheFn?.({
                newComment: (0, $ag51I.addEmptyObjectRepliesAndReactions)(mutationResult.data.createFooterComment),
                onError: (error)=>{
                    (0, $8dA1U.handleMutationFailure)({
                        experienceTracker: experienceTracker,
                        experienceName: $8067e644a2744f7c$export$4ce0bedef4e84bb7(isInlineComment),
                        error: error,
                        commentId: parentCommentId,
                        shouldReturnError: true
                    });
                }
            });
        },
        optimisticResponse: (0, $aGjYc.shouldUseCommentDraftForOptimisticSave)('page', 'reply') ? (0, $ag51I.getOptimisticResponse)({
            userId: userId ?? '',
            displayName: displayName ?? '',
            adf: adf,
            pageId: pageId,
            parentCommentId: parentCommentId
        }) : undefined
    });
const $8067e644a2744f7c$var$buildFooterReplyOptions = ({ pageId: pageId, cloudId: cloudId, parentCommentId: parentCommentId, adf: adf, isReactionsEnabled: isReactionsEnabled })=>({
        variables: {
            pageId: pageId,
            cloudId: cloudId,
            input: {
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: (0, $fa7a458b6cf5b633$export$f4016897b165b6d5).ATLAS_DOC_FORMAT
                },
                commentSource: (0, $fa7a458b6cf5b633$export$2dffd0b5373a4389).WEB,
                containerId: pageId,
                parentCommentId: parentCommentId
            }
        },
        update: (0, $87CZC.updateApolloCacheReplyCallback)('create', {
            pageId: pageId,
            contentStatus: [
                'CURRENT',
                'DRAFT'
            ],
            type: [
                'FOOTER'
            ]
        }, parentCommentId, isReactionsEnabled)
    });
const $8067e644a2744f7c$export$56ed0d504fa641dd = async ({ pageId: pageId, parentCommentId: parentCommentId, cloudId: cloudId, adf: adf, onSuccess: onSuccess, pageMode: pageMode, editCommentQueryId: editCommentQueryId, setCommentForEdit: setCommentForEdit, createAnalyticsEvent: createAnalyticsEvent, pageType: pageType, experienceTracker: experienceTracker, createInlineReplyFn: createInlineReplyFn, createGeneralReplyFn: createGeneralReplyFn, createObjectReplyFn: createObjectReplyFn, addCommentInCommentsDataManagerCacheFn: // Create reply via Comments Data Manager
addCommentInCommentsDataManagerCacheFn, createFooterReplyFn: // Add comment to Comments Data Manager cache, passed in because it comes from a hook
createFooterReplyFn, selectedAnnotation: selectedAnnotation, addReplyToCommentThread: addReplyToCommentThread, threadKey: threadKey, commentType: commentType, searchSessionId: searchSessionId, isReactionsEnabled: isReactionsEnabled, analyticsSource: analyticsSource, contentTypesCommentService: contentTypesCommentService, isFooterComment: isFooterComment, setReplyToCommentId: setReplyToCommentId, resetContentChanged: resetContentChanged, setReplyView: setReplyView, userId: userId, displayName: displayName })=>{
    const isInlineComment = commentType === (0, $8i27m.CommentType).INLINE;
    const isEditor = pageMode === (0, $cD1qu.PageMode).EDIT;
    const startExperienceName = $8067e644a2744f7c$export$4ce0bedef4e84bb7(isInlineComment);
    experienceTracker.start({
        name: startExperienceName,
        timeout: (0, $aJPUt.ExperienceTimeout).EDITOR_PUBLISH,
        attributes: (0, $gtj7V.getCommentsDataManagerExperimentAttributes)()
    });
    let createReplyPromise = undefined;
    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
        // New path - improved logic + Comments Data Manager support
        if (isInlineComment) createReplyPromise = createInlineReplyFn?.($8067e644a2744f7c$export$35e3b83b71d833cd({
            pageId: pageId,
            parentCommentId: parentCommentId,
            adf: adf,
            isEditor: isEditor,
            pageMode: pageMode,
            threadKey: threadKey,
            includeReactionsFlag: false,
            userId: userId,
            displayName: displayName
        }), (error)=>{
            (0, $8dA1U.handleMutationFailure)({
                experienceTracker: experienceTracker,
                experienceName: $8067e644a2744f7c$export$4ce0bedef4e84bb7(isInlineComment),
                error: error,
                commentId: parentCommentId,
                shouldReturnError: true
            });
        });
        else if (createObjectReplyFn) // The createObjectReplyFn takes precedence over other non-inline (footer or general) reply
        // functions, if it was provided
        createReplyPromise = createObjectReplyFn($8067e644a2744f7c$export$e898411b6bdaedf3({
            pageId: pageId,
            cloudId: cloudId,
            parentCommentId: parentCommentId,
            adf: adf,
            addCommentInCommentsDataManagerCacheFn: addCommentInCommentsDataManagerCacheFn,
            experienceTracker: experienceTracker,
            isInlineComment: isInlineComment,
            userId: userId,
            displayName: displayName
        }));
        else if (isFooterComment) createReplyPromise = createFooterReplyFn?.($8067e644a2744f7c$var$buildFooterReplyOptions({
            pageId: pageId,
            cloudId: cloudId,
            parentCommentId: parentCommentId,
            adf: adf,
            isReactionsEnabled: isReactionsEnabled
        }));
        else createReplyPromise = createGeneralReplyFn?.($8067e644a2744f7c$var$buildGeneralReplyOptions({
            pageId: pageId,
            cloudId: cloudId,
            parentCommentId: parentCommentId,
            adf: adf,
            includeReactionsFlag: false,
            isReactionsEnabled: isReactionsEnabled
        }));
    } else // Legacy path - use old logic
    createReplyPromise = isInlineComment ? createInlineReplyFn && createInlineReplyFn($8067e644a2744f7c$export$35e3b83b71d833cd({
        pageId: pageId,
        parentCommentId: parentCommentId,
        adf: adf,
        isEditor: isEditor,
        pageMode: pageMode,
        threadKey: threadKey,
        includeReactionsFlag: false
    }), ()=>{}) : isFooterComment ? createFooterReplyFn && createFooterReplyFn($8067e644a2744f7c$var$buildFooterReplyOptions({
        pageId: pageId,
        cloudId: cloudId,
        parentCommentId: parentCommentId,
        adf: adf,
        isReactionsEnabled: isReactionsEnabled
    })) : createGeneralReplyFn && createGeneralReplyFn($8067e644a2744f7c$var$buildGeneralReplyOptions({
        pageId: pageId,
        cloudId: cloudId,
        parentCommentId: parentCommentId,
        adf: adf,
        includeReactionsFlag: false,
        isReactionsEnabled: isReactionsEnabled
    }));
    const isOptimisticReplyEnabled = (0, $aGjYc.shouldUseCommentDraftForOptimisticSave)($8067e644a2744f7c$var$getEditorCommentType(commentType, pageMode), 'reply');
    if (isOptimisticReplyEnabled) {
        // Immediately reset reply state before the createReplyPromise resolves
        setReplyToCommentId({
            parentCommentId: undefined
        });
        setReplyView((0, $ibqdE.ViewReplyOptions).ALL);
    }
    return createReplyPromise && createReplyPromise.then(({ data: data })=>{
        const replyResult = isInlineComment ? data.replyInlineComment : data.createFooterComment;
        const reply = {
            type: isInlineComment ? (0, $8i27m.CommentType).INLINE : (0, $8i27m.CommentType).GENERAL,
            ...replyResult
        };
        if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) addReplyToCommentThread(threadKey, reply, commentType);
        // Update content types comments if we are creating a reply on a different content type
        contentTypesCommentService?.onUpdateComment?.(threadKey, 'reply');
        if (!isOptimisticReplyEnabled) {
            // Reset reply state after successful creation - already done if optimistic reply is enabled
            setReplyToCommentId({
                parentCommentId: undefined
            });
            setReplyView((0, $ibqdE.ViewReplyOptions).ALL);
        }
        resetContentChanged();
        if (isInlineComment) (0, $g0DaR.handleCreateReplySuccess)({
            onSuccess: onSuccess,
            editCommentQueryId: editCommentQueryId,
            setCommentForEdit: setCommentForEdit,
            data: data,
            createAnalyticsEvent: createAnalyticsEvent,
            pageId: pageId,
            pageType: pageType,
            analyticsSource: analyticsSource,
            commentId: parentCommentId,
            pageMode: pageMode,
            selectedAnnotation: selectedAnnotation,
            getInlineNodeTypes: undefined,
            experienceTracker: experienceTracker,
            isEditor: isEditor
        });
        else (0, $87CZC.handleCreateReplySuccess)({
            onSuccess: onSuccess,
            editCommentQueryId: editCommentQueryId,
            setCommentForEdit: setCommentForEdit,
            data: data,
            createAnalyticsEvent: createAnalyticsEvent,
            pageId: pageId,
            pageType: pageType,
            analyticsSource: analyticsSource,
            commentId: parentCommentId,
            pageMode: pageMode,
            experienceTracker: experienceTracker,
            searchSessionId: searchSessionId,
            isFooterComment: isFooterComment
        });
    }).catch((error)=>{
        let failExperienceName;
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) failExperienceName = $8067e644a2744f7c$export$4ce0bedef4e84bb7(isInlineComment);
        else {
            failExperienceName = (0, $irVI7.REPLY_TO_INLINE_COMMENT_PUBLISH_EXPERIENCE);
            if (!isInlineComment) failExperienceName = (0, $irVI7.REPLY_TO_PAGE_COMMENT_PUBLISH_EXPERIENCE);
        }
        return (0, $8dA1U.handleMutationFailure)({
            experienceTracker: experienceTracker,
            experienceName: failExperienceName,
            error: error,
            commentId: parentCommentId,
            shouldReturnError: true
        });
    });
};
const $8067e644a2744f7c$export$1f10dc4c6b2440d5 = (comments, passThroughProps, CommentThreadComponent, transitionIndexWithinBatch)=>comments.map((parentComment, index)=>{
        const shouldRenderCommentTypeSeparator = index === transitionIndexWithinBatch;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CommentThreadComponent, {
            // Note: Cannot let `key` use `parentComment.id`, which, when optimistic save
            // (COMMENTS-6792) is enabled, is the fake optimistic id first and then gets updated
            // to the actual new comment id after mutation succeeds.
            // When mutation succeeds, DOM tree is updated. If `key` stays the same, the update
            // is recognized as multiple individual "mutation:attribute" for known attributes
            // excluded from VC calculation (e.g. data-testid); if key changes, the update is
            // recognized as a replacement of the entire element tree and counted in VC.
            // Unlike `parentComment.id`, `index` is stable as long as the comment thread's
            // position on the page does not change.
            key: `comment-thread-${index}`,
            parentComment: parentComment,
            shouldRenderCommentTypeSeparator: shouldRenderCommentTypeSeparator,
            ...passThroughProps
        });
    });
const $8067e644a2744f7c$export$d69a37e7380b7ce5 = (reply, hiddenReplies)=>{
    return hiddenReplies.some((hiddenReply)=>hiddenReply.id === reply.id);
};
const $8067e644a2744f7c$export$8f7e06942eb2440 = (numberOfReplies, isParentCommentResolvedOrDangling, isStandaloneComment = false)=>{
    if (isParentCommentResolvedOrDangling) return (0, $ibqdE.ViewReplyOptions).HIDDEN;
    if (isStandaloneComment || numberOfReplies <= $8067e644a2744f7c$export$8648ea63d9b37934(numberOfReplies, isStandaloneComment)) return (0, $ibqdE.ViewReplyOptions).ALL;
    return (0, $ibqdE.ViewReplyOptions).LIMITED;
};
const $8067e644a2744f7c$export$f72e9aa74d51c544 = (replyToCommentUser)=>{
    if (!replyToCommentUser || !replyToCommentUser.displayName || !replyToCommentUser.accountId) return undefined;
    return (0, $caRYB.doc)((0, $2FFuS.paragraph)((0, $bAT9l.mention)({
        id: replyToCommentUser.accountId,
        text: `@${replyToCommentUser.displayName}`
    }), (0, $aoDcQ.text)(' ')));
};
const $8067e644a2744f7c$export$b4ad053d7b401447 = (contributors)=>{
    const seenAccountIds = new Set();
    const contributorUsers = contributors?.reduce((users, contributor)=>{
        if (!contributor?.accountId || !contributor.displayName) return users;
        if (seenAccountIds.has(contributor.accountId)) return users;
        seenAccountIds.add(contributor.accountId);
        users.push({
            accountId: contributor.accountId,
            displayName: contributor.displayName
        });
        return users;
    }, []);
    if (!contributorUsers?.length) return undefined;
    return contributorUsers;
};
const $8067e644a2744f7c$export$64472a7a39490e1b = (commentUser, contributorUsers)=>{
    const mentionNodes = contributorUsers?.flatMap((contributorUser)=>{
        if (!contributorUser.displayName || !contributorUser.accountId) return [];
        return [
            (0, $bAT9l.mention)({
                id: contributorUser.accountId,
                text: `@${contributorUser.displayName}`
            }),
            (0, $aoDcQ.text)(' ')
        ];
    }) ?? [];
    if (!mentionNodes.length) return undefined;
    if (commentUser?.accountId && commentUser?.displayName) mentionNodes.push((0, $bAT9l.mention)({
        id: commentUser.accountId,
        text: `@${commentUser.displayName}`
    }), (0, $aoDcQ.text)(' '));
    return (0, $caRYB.doc)((0, $2FFuS.paragraph)(...mentionNodes));
};
const $8067e644a2744f7c$export$d47d856a5a134619 = ({ replyToCommentUser: replyToCommentUser, replyToContributorUsers: replyToContributorUsers })=>{
    if ((0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)) return $8067e644a2744f7c$export$64472a7a39490e1b(replyToCommentUser, replyToContributorUsers) ?? $8067e644a2744f7c$export$f72e9aa74d51c544(replyToCommentUser);
    return $8067e644a2744f7c$export$f72e9aa74d51c544(replyToCommentUser);
};
module.exports["getDefaultNumVisibleReplies"] = $8067e644a2744f7c$export$8648ea63d9b37934;
module.exports["handleCommentThreadSelection"] = $8067e644a2744f7c$export$cda46aad7dff898a;
module.exports["onSaveReply"] = $8067e644a2744f7c$export$56ed0d504fa641dd;
module.exports["getCommentThreadsToBatch"] = $8067e644a2744f7c$export$1f10dc4c6b2440d5;
module.exports["getDefaultReplyView"] = $8067e644a2744f7c$export$8f7e06942eb2440;
module.exports["getReplyToContributorUsers"] = $8067e644a2744f7c$export$b4ad053d7b401447;
module.exports["getReplyEditorContent"] = $8067e644a2744f7c$export$d47d856a5a134619;

});

parcelRegister("bAT9l", function(module, exports) {
const $6b7e17532fed1b16$export$db83999c14438df4 = (attrs)=>({
        type: 'mention',
        attrs: {
            accessLevel: '',
            ...attrs
        }
    });
module.exports["mention"] = $6b7e17532fed1b16$export$db83999c14438df4;

});

parcelRegister("cQCqE", function(module, exports) {
/**
 * @generated SignedSource<<99c373d4a9c5d5bad15d28813bfe5743>>
 * @relayHash 251686a61db1160888478730ff3239b3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6faea90f9b58d45b5664d99ac3cdecf7908886ec22a01b3b93a5a295ab4fec9
const $fb6961718abb1299$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeReactionsSummary"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v8 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v10 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v11 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v12 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v13 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "replyInlineComment",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        v7 /*: any*/ 
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "representation",
                            "value": "ATLAS_DOC_FORMAT"
                        }
                    ],
                    "concreteType": "DocumentBody",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": v8 /*: any*/ ,
                    "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "container",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ 
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "contentStatus"
                },
                {
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "createdAt",
                    "plural": false,
                    "selections": v8 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "createdAtNonLocalized"
                },
                {
                    "concreteType": "Map_LinkType_String",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "commentResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "FooterComment"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineMarkerRef"
                                },
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "inlineResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDangling"
                                        },
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineText"
                                }
                            ],
                            "type": "InlineComment"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "parentId"
                },
                {
                    "concreteType": "CommentPermissions",
                    "kind": "LinkedField",
                    "name": "permissions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEditable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isRemovable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isResolvable"
                        }
                    ]
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "by",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                v5 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "friendlyWhen"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "when"
                        }
                    ]
                },
                {
                    "condition": "includeReactionsSummary",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "childType",
                                    "value": "comment"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "contentType",
                                    "value": "page"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "pageId",
                                    "variableName": "pageId"
                                }
                            ],
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "reactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCreateInlineReplyMutation",
            "selections": v13 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCreateInlineReplyMutation",
            "selections": v13 /*: any*/ 
        },
        "params": {
            "cacheID": "251686a61db1160888478730ff3239b3",
            "id": "a6faea90f9b58d45b5664d99ac3cdecf7908886ec22a01b3b93a5a295ab4fec9",
            "metadata": {},
            "name": "useCreateInlineReplyMutation",
            "operationKind": "mutation",
            "text": "mutation useCreateInlineReplyMutation($input:ReplyInlineCommentInput!,$pageId:ID!,$includeReactionsSummary:Boolean!){replyInlineComment(input:$input){id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeReactionsSummary){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}"
        }
    };
}();
$fb6961718abb1299$var$node.hash = "2b7f67eb2971040c4fc787ed5990c49d";
var $fb6961718abb1299$export$2e2bcd8739ae039 = $fb6961718abb1299$var$node;



var $42omo = parcelRequire("42omo");


var $308Wd = parcelRequire("308Wd");


var $6mKj3 = parcelRequire("6mKj3");


var $kgNLQ = parcelRequire("kgNLQ");


var $NYiei = parcelRequire("NYiei");

// This hook returns a mutation function to create a new inline comment reply. Because the new
// Comments Data Manager caches all the data for comments in Relay, we need to define the mutation
// here so that the cache can be updated fully when a new reply is created - and that means the
// mutation needs to return the full comment data structure that we are using in the returned query
// part of the mutation.  Since that returned query is quite large, we define it here in its own
// hook to avoid having it in many places in the codebase - which makes the code harder to read and
// could lead to the multiple copies getting out of sync.
// Data Mutation Definition:
// Unfortunately our Relay-friendly type generation tools don't support using GQL fragments yet -
// but in order to keep the definition of the comment fields in sync (so the cache update fragment
// is always in sync with the full query) we will need to manually make any changes to one
// definition in any others as well, until our tooling supports fragments and then we move to a
// more fragmented-based approach.  Note there are also comment queries or fragments in the
// following files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data/src/hooks/useCommentById.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
const $f9d242b7b867bd0c$var$CreateInlineReplyMutation = (0, $fb6961718abb1299$export$2e2bcd8739ae039);
const $f9d242b7b867bd0c$export$e30f6438d916be51 = ({ userId: userId, displayName: displayName, adf: adf, pageId: pageId, parentCommentId: parentCommentId, parentCommentAnnotationId: parentCommentAnnotationId })=>{
    const nowISOString = new Date().toISOString();
    return {
        replyInlineComment: {
            author: {
                __typename: 'KnownUser',
                accountId: userId,
                displayName: displayName,
                permissionType: null,
                profilePicture: {
                    path: userId ? `/wiki/aa-avatar/${userId}` : '',
                    __typename: 'Icon'
                },
                type: 'known'
            },
            body: {
                value: JSON.stringify(adf),
                __typename: 'DocumentBody'
            },
            container: {
                id: pageId,
                __typename: 'Content'
            },
            contentStatus: 'current',
            createdAt: {
                value: '',
                __typename: 'ConfluenceDate'
            },
            createdAtNonLocalized: nowISOString,
            // this is required to correctly sort comments
            id: (0, $kgNLQ.OPTIMISTIC_SAVE_COMMENT_ID),
            links: {
                editui: null,
                webui: null,
                __typename: 'Map_LinkType_String'
            },
            location: {
                __typename: 'InlineComment',
                type: 'INLINE',
                inlineMarkerRef: parentCommentAnnotationId,
                inlineResolveProperties: {
                    isDangling: false,
                    resolved: false,
                    resolvedFriendlyDate: null,
                    resolvedTime: null,
                    resolvedUser: null,
                    __typename: 'InlineCommentResolveProperties'
                },
                inlineText: ''
            },
            parentId: parentCommentId,
            permissions: {
                isEditable: true,
                isRemovable: true,
                isResolvable: true,
                __typename: 'CommentPermissions'
            },
            version: {
                by: {
                    __typename: 'KnownUser',
                    accountId: userId,
                    displayName: displayName,
                    type: 'user'
                },
                friendlyWhen: '',
                when: nowISOString,
                // this is required to show the creation time and tooltip correctly
                number: 1,
                __typename: 'Version'
            },
            __typename: 'Comment'
        }
    };
};
const $f9d242b7b867bd0c$export$9cc5e5ba32b058b7 = ({ contentId: contentId })=>{
    const { addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    const [createInlineReplyFn] = (0, $308Wd.useMutationInterop)($f9d242b7b867bd0c$var$CreateInlineReplyMutation, {
        ...(0, $kgNLQ.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "@confluence/comments-data-manager"
    });
    const addEmptyInlineRepliesAndReactions = (0, $42omo.useCallback)((commentData)=>{
        return commentData ? {
            ...commentData,
            contributors: [],
            replies: [],
            reactionsSummary: (0, $6mKj3.expValEquals)('confluence_fe_use_create_comment_exclude_reactions', 'isEnabled', true) ? (0, $kgNLQ.emptyReactionsSummary) : commentData.reactionsSummary ?? (0, $kgNLQ.emptyReactionsSummary)
        } : // @ts-expect-error - FIXME: This error was surfaced after enabling the `typescriptExcludeUndefinedFromNullableUnion`
        // Relay compiler option. Previously, `undefined` was incorrectly included in nullable unions in generated types; this option removes it. The owning team should fix this properly.
        undefined;
    }, []);
    // This is the interop mutation function that will be used by components that need to create
    // inline comment replies. It will either call the new Comments Data Manager path or the old
    // Apollo mutation path depending on whether the relevant experiment is enabled.
    const createInlineReplyInterop = (0, $42omo.useCallback)(({ originalMutationFn: originalMutationFn, options: options, onCacheUpdateError: onCacheUpdateError })=>{
        const updateNewCommentReplyInCache = (_dataProxy, mutationResult)=>{
            addCommentInCache({
                newComment: addEmptyInlineRepliesAndReactions(mutationResult.data.replyInlineComment),
                onError: onCacheUpdateError
            });
        };
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            // strip old update function and other options and adjust variables as needed
            const { variables: variables } = options;
            const { includeReactionsAndReplies: _includeReactionsAndReplies, ...newVariables } = variables;
            return createInlineReplyFn({
                variables: {
                    ...newVariables,
                    includeReactionsSummary: !(0, $6mKj3.expValEquals)('confluence_fe_use_create_comment_exclude_reactions', 'isEnabled', true)
                },
                update: updateNewCommentReplyInCache,
                optimisticResponse: options.optimisticResponse ?? undefined
            });
        } else return originalMutationFn(options);
    }, [
        addCommentInCache,
        addEmptyInlineRepliesAndReactions,
        createInlineReplyFn
    ]);
    return {
        createInlineReplyInterop: createInlineReplyInterop
    };
};
module.exports["getOptimisticResponse"] = $f9d242b7b867bd0c$export$e30f6438d916be51;
module.exports["useCreateInlineReplyMutation"] = $f9d242b7b867bd0c$export$9cc5e5ba32b058b7;

});

parcelRegister("g0DaR", function(module, exports) {

var $7CLBv = parcelRequire("7CLBv");


var $afGoD = parcelRequire("afGoD");


var $3B9cR = parcelRequire("3B9cR");


var $1C8XP = parcelRequire("1C8XP");


var $9rE3H = parcelRequire("9rE3H");


var $b1hSc = parcelRequire("b1hSc");


var $irVI7 = parcelRequire("irVI7");


var $24amZ = parcelRequire("24amZ");


var $7W8i8 = parcelRequire("7W8i8");


var $56QzY = parcelRequire("56QzY");


var $en1dX = parcelRequire("en1dX");


var $gtj7V = parcelRequire("gtj7V");


var $asNlu = parcelRequire("asNlu");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");

const $31423c43076595b5$var$logger = (0, $7W8i8.getLogger)('inline-comments-common');
const $31423c43076595b5$var$removeReplyFromCache = (parentComment, replyId)=>{
    if (parentComment) {
        // Remove the returned commentId from the cache and reset it
        const idxToRemove = parentComment.replies.findIndex((reply)=>reply?.id === replyId);
        if (idxToRemove !== -1) parentComment.replies.splice(idxToRemove, 1);
    }
};
const $31423c43076595b5$var$addReplyToCache = (parentComment, newData)=>{
    if (!parentComment) return;
    const mutationResult = newData.replyInlineComment;
    // Ensure reactionsSummary exists to satisfy queries that select it
    if (!mutationResult?.reactionsSummary) mutationResult.reactionsSummary = $31423c43076595b5$export$21125dfd5f6a0f20;
    // Temporary workaround since ActiveCommentsQuery was migrated to Relay and InlineCommentQuery is still using Apollo
    // as such, there is a mismatch in types until InlineCommentQuery is also migrated to Relay
    parentComment.replies.push(mutationResult);
};
const $31423c43076595b5$export$483f44f07b46ed25 = (actionType, queryVariables, parentCommentId, commentId)=>(_cache, result)=>{
        // If the mutation fails, don't do anything
        if (!result || !result.data) return;
        try {
            const commentsPanelVariables = (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
                pageId: queryVariables.pageId
            });
            const commentsPanelResponse = (0, $l1uFv.readQueryInterop)({
                query: (0, $b1hSc.default),
                variables: commentsPanelVariables,
                __callerPackage__: "@confluence/inline-comments-common"
            });
            if (commentsPanelResponse) {
                const commentsPanelData = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(commentsPanelResponse);
                const commentsPanelParentComment = commentsPanelData?.comments?.nodes?.find((comment)=>comment?.id === parentCommentId);
                if (commentsPanelParentComment) {
                    if (actionType === 'delete') $31423c43076595b5$var$removeReplyFromCache(commentsPanelParentComment, commentId);
                    else $31423c43076595b5$var$addReplyToCache(commentsPanelParentComment, result.data);
                }
                // Update the comments panel query
                (0, $fEmGS.writeQueryInterop)({
                    query: (0, $b1hSc.default),
                    variables: commentsPanelVariables,
                    data: commentsPanelData,
                    __callerPackage__: "@confluence/inline-comments-common"
                });
            }
        } catch (err) {
            $31423c43076595b5$var$logger.error`An Error occurred when updating comments panel cache for ${actionType} reply - ${err}`;
        }
        try {
            const inlineQueryVariables = {
                ...queryVariables
            };
            const inlineCommentResponse = (0, $l1uFv.readQueryInterop)({
                query: (0, $3B9cR.InlineCommentQuery),
                variables: inlineQueryVariables,
                __callerPackage__: "@confluence/inline-comments-common"
            });
            if (inlineCommentResponse) {
                const inlineCommentData = {
                    ...inlineCommentResponse
                };
                const inlineCommentsParentComment = inlineCommentData?.comments?.nodes?.find((comment)=>comment?.id === parentCommentId);
                if (inlineCommentsParentComment) {
                    if (actionType === 'delete') $31423c43076595b5$var$removeReplyFromCache(inlineCommentsParentComment, commentId);
                    else $31423c43076595b5$var$addReplyToCache(inlineCommentsParentComment, result.data);
                }
                // Update the inline comments
                (0, $fEmGS.writeQueryInterop)({
                    query: (0, $3B9cR.InlineCommentQuery),
                    variables: inlineQueryVariables,
                    data: inlineCommentData,
                    __callerPackage__: "@confluence/inline-comments-common"
                });
            }
        } catch (err) {
            $31423c43076595b5$var$logger.error`An Error occurred when updating inline comments cache for ${actionType} reply - ${err}`;
        }
    };
const $31423c43076595b5$export$ad43a67c7ab9a6d6 = (actionType, queryVariables, parentCommentId, commentId)=>(_cache, result)=>{
        // If the mutation fails, don't do anything
        if (!result || !result.data) return;
        try {
            const standaloneCommentVariables = {
                pageId: queryVariables.pageId,
                contentStatus: queryVariables.contentStatus,
                inlineMarkerRefList: [
                    queryVariables.annotationId
                ]
            };
            const standaloneCommentResponse = (0, $l1uFv.readQueryInterop)({
                query: (0, $1C8XP.ActiveInlineCommentsQuery),
                variables: standaloneCommentVariables,
                __callerPackage__: "@confluence/inline-comments-common"
            });
            if (standaloneCommentResponse) {
                const standaloneCommentData = {
                    ...standaloneCommentResponse
                };
                const standaloneParentComment = standaloneCommentData?.comments?.nodes?.find((comment)=>comment?.id === parentCommentId);
                if (standaloneParentComment) {
                    if (actionType === 'delete') $31423c43076595b5$var$removeReplyFromCache(standaloneParentComment, commentId);
                    else $31423c43076595b5$var$addReplyToCache(standaloneParentComment, result.data);
                }
                // Update the comments panel query
                (0, $fEmGS.writeQueryInterop)({
                    query: (0, $1C8XP.ActiveInlineCommentsQuery),
                    variables: standaloneCommentVariables,
                    data: standaloneCommentData,
                    __callerPackage__: "@confluence/inline-comments-common"
                });
            }
        } catch (err) {
            $31423c43076595b5$var$logger.error`An Error occurred when updating comments panel cache for ${actionType} reply - ${err}`;
        }
    };
const $31423c43076595b5$export$1859da3357bd460e = (isEditor, isLivePage)=>{
    if (isLivePage) return (0, $afGoD.CommentCreationLocation).LIVE;
    if (isEditor) return (0, $afGoD.CommentCreationLocation).EDITOR;
    return (0, $afGoD.CommentCreationLocation).RENDERER;
};
const $31423c43076595b5$export$c94bffbead878776 = ({ onSuccess: onSuccess, editCommentQueryId: editCommentQueryId, setCommentForEdit: setCommentForEdit, data: data, createAnalyticsEvent: createAnalyticsEvent, pageId: pageId, pageType: pageType, analyticsSource: analyticsSource, commentId: commentId, pageMode: pageMode, selectedAnnotation: selectedAnnotation, getInlineNodeTypes: getInlineNodeTypes, experienceTracker: experienceTracker, isEditor: isEditor })=>{
    onSuccess?.();
    if (editCommentQueryId) setCommentForEdit('');
    const replyCommentInfo = data?.replyInlineComment;
    const markerRef = replyCommentInfo?.location?.inlineMarkerRef;
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'created',
            actionSubject: 'comment',
            actionSubjectId: replyCommentInfo?.id,
            // The newly created comment ID
            objectType: pageType,
            objectId: pageId,
            source: analyticsSource,
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                source: analyticsSource,
                commentType: (0, $en1dX.CommentType).INLINE,
                parentCommentId: commentId ?? null,
                // analytics event schema type expects string or null
                isReply: true,
                pageMode: pageMode,
                framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                navdexPointType: (0, $56QzY.END),
                inlineNodeTypes: selectedAnnotation && getInlineNodeTypes ? getInlineNodeTypes(selectedAnnotation.id) : undefined,
                targetNodeType: (0, $asNlu.getTargetNodeType)(markerRef, isEditor)
            }
        }
    }).fire();
    experienceTracker.updateAttributes({
        name: (0, $irVI7.REPLY_TO_INLINE_COMMENT_EXPERIENCE),
        attributes: {
            replyCommentId: replyCommentInfo?.id
        }
    });
    experienceTracker.succeed({
        name: (0, $irVI7.REPLY_TO_INLINE_COMMENT_PUBLISH_EXPERIENCE),
        attributes: {
            replyCommentId: replyCommentInfo?.id
        }
    });
};
const $31423c43076595b5$export$ca43168d5a4c3bfd = (allAnnotations, commentMarkerRef, previousOrderedActiveAnnotations, setOrderedActiveAnnotationIdList)=>{
    const indexInAnnotations = allAnnotations.indexOf(commentMarkerRef);
    if (indexInAnnotations === -1) throw new Error('Marker ref is not present in the annotations list');
    const insertIndex = previousOrderedActiveAnnotations.findIndex((annotation)=>allAnnotations.indexOf(annotation) > indexInAnnotations);
    const finalInsertIndex = insertIndex === -1 ? previousOrderedActiveAnnotations.length : insertIndex;
    const updatedOrderedActiveAnnotations = [
        ...previousOrderedActiveAnnotations.slice(0, finalInsertIndex),
        commentMarkerRef,
        ...previousOrderedActiveAnnotations.slice(finalInsertIndex)
    ];
    setOrderedActiveAnnotationIdList(updatedOrderedActiveAnnotations);
};
const $31423c43076595b5$export$cad0f7f0aeb719e7 = (inlineMarkerRef)=>{
    const tiny = `.inline-comment-marker[data-ref="${inlineMarkerRef}"]`;
    const fabricEditorAnnotation = `[id="${inlineMarkerRef}"][data-mark-annotation-type="inlineComment"]`;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    return Boolean(document.querySelector(`${tiny}, ${fabricEditorAnnotation}`));
};
const $31423c43076595b5$export$21125dfd5f6a0f20 = {
    ari: '',
    containerAri: '',
    reactionsCount: 0,
    reactionsSummaryForEmoji: [],
    __typename: 'ReactionsSummaryResponse'
};
const $31423c43076595b5$export$a5988be2401625e8 = (emojiId, actionType, objectId, pageId, selectedAnnotation, isArchived)=>{
    try {
        const queryVariables = {
            pageId: pageId,
            inlineMarkerRefList: [
                selectedAnnotation.id
            ],
            contentStatus: [
                isArchived ? 'ARCHIVED' : 'DRAFT',
                'CURRENT'
            ]
        };
        const response = (0, $l1uFv.readQueryInterop)({
            query: (0, $1C8XP.ActiveInlineCommentsQuery),
            variables: queryVariables,
            __callerPackage__: "@confluence/inline-comments-common"
        });
        if (!response?.comments?.nodes?.[0]) return;
        const comment = response.comments.nodes[0];
        let cacheReactionsSummary;
        let reply;
        // If the comment matches the comment ID, use it's reactionsSummary
        if (comment.id === objectId) cacheReactionsSummary = comment.reactionsSummary ? {
            ...comment.reactionsSummary
        } : $31423c43076595b5$export$21125dfd5f6a0f20;
        else {
            // Otherwise, find the reply that matches
            reply = comment.replies.find((r)=>r?.id === objectId);
            if (reply) cacheReactionsSummary = reply.reactionsSummary ? {
                ...reply.reactionsSummary
            } : $31423c43076595b5$export$21125dfd5f6a0f20;
        }
        if (!cacheReactionsSummary) return;
        const reactionsAri = cacheReactionsSummary.ari || '';
        const reactionsContainerAri = cacheReactionsSummary.containerAri || '';
        let reactionsCount = cacheReactionsSummary.reactionsCount || 0;
        const updatedReactionsSummary = {
            ...cacheReactionsSummary
        };
        const updatedReactionsNodes = [
            ...cacheReactionsSummary.reactionsSummaryForEmoji || []
        ];
        if (actionType === 'add') {
            const reaction = updatedReactionsNodes.find((item)=>item?.emojiId === emojiId);
            // If reaction exists, update its attributes
            if (reaction && !reaction.reacted) {
                reaction.count++;
                reaction.reacted = true;
            } else {
                // Otherwise, create a new reaction
                const newReaction = {
                    emojiId: emojiId,
                    count: 1,
                    reacted: true,
                    id: `${reactionsContainerAri}|${reactionsAri}|${emojiId}`,
                    __typename: 'ReactionsSummaryForEmoji'
                };
                updatedReactionsNodes.push(newReaction);
            }
            ++reactionsCount;
        } else if (actionType === 'delete') {
            const reactionIdx = updatedReactionsNodes.findIndex((item)=>item?.emojiId === emojiId);
            // If reaction exists, update its attributes
            if (reactionIdx !== -1) {
                const reaction = updatedReactionsNodes[reactionIdx];
                // If we have more than one reaction, remove our user from it and decrement the count
                if (reaction && reaction.count > 1) {
                    reaction.count--;
                    reaction.reacted = false;
                } else // Otherwise, remove the reaction entirely
                updatedReactionsNodes.splice(reactionIdx, 1);
                --reactionsCount;
            }
        }
        updatedReactionsSummary.reactionsSummaryForEmoji = updatedReactionsNodes;
        updatedReactionsSummary.reactionsCount = reactionsCount ?? 0;
        // Create a deep copy of the comment to ensure Apollo detects the change
        const updatedComment = {
            ...comment,
            replies: comment.replies.map((r)=>{
                if (r?.id === objectId) return {
                    ...r,
                    reactionsSummary: updatedReactionsSummary
                };
                return r;
            })
        };
        // Update the comment's reactionsSummary if it's the target comment
        if (comment.id === objectId) updatedComment.reactionsSummary = updatedReactionsSummary;
        const newData = {
            comments: {
                nodes: [
                    updatedComment
                ],
                __typename: 'PaginatedCommentList'
            }
        };
        (0, $fEmGS.writeQueryInterop)({
            query: (0, $1C8XP.ActiveInlineCommentsQuery),
            variables: queryVariables,
            data: newData,
            __callerPackage__: "@confluence/inline-comments-common"
        });
    } catch (err) {
        $31423c43076595b5$var$logger.error`An error occurred when updating reactions cache for ${actionType} - ${err}`;
    }
};
module.exports["defaultReactionsSummary"] = $31423c43076595b5$export$21125dfd5f6a0f20;
module.exports["updateApolloCacheCallback"] = $31423c43076595b5$export$483f44f07b46ed25;
module.exports["updateApolloCacheCallbackForGA"] = $31423c43076595b5$export$ad43a67c7ab9a6d6;
module.exports["getCommentCreationLocation"] = $31423c43076595b5$export$1859da3357bd460e;
module.exports["handleCreateReplySuccess"] = $31423c43076595b5$export$c94bffbead878776;
module.exports["insertReopenedCommentAnnotation"] = $31423c43076595b5$export$ca43168d5a4c3bfd;
module.exports["inlineCommentExists"] = $31423c43076595b5$export$cad0f7f0aeb719e7;
module.exports["updateReactionsCacheCallbackForGA"] = $31423c43076595b5$export$a5988be2401625e8;

});

parcelRegister("asNlu", function(module, exports) {

var $ag6aQ = parcelRequire("ag6aQ");

const $bbb444f37a1f1f7f$export$2f9714b3e1fdd309 = (annotationId, isEditor)=>{
    if (!annotationId) return 'unknown';
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const elementWithAnnotationWrapper = document.querySelector(`[id="${annotationId}"]`);
    if (!elementWithAnnotationWrapper) return 'unknown';
    const captionNode = elementWithAnnotationWrapper.closest('[data-media-caption]');
    if (captionNode) return 'caption';
    if (isEditor) {
        const mediaNode = elementWithAnnotationWrapper.querySelector(`.${(0, $ag6aQ.ClassNames).MEDIA_CONTAINER}`);
        if (mediaNode) return 'media';
        // If no node is detected, return "text" as the default node type for now
        return 'text';
    } else {
        const targetNode = elementWithAnnotationWrapper.querySelector('[data-node-type]');
        if (targetNode) return targetNode.dataset.nodeType;
        // If no node is detected, return "text" as the default node type for now
        return 'text';
    }
};
module.exports["getTargetNodeType"] = $bbb444f37a1f1f7f$export$2f9714b3e1fdd309;

});

parcelRegister("8dA1U", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $21K7m = parcelRequire("21K7m");


var $cUycv = parcelRequire("cUycv");


var $7Sm4c = parcelRequire("7Sm4c");

const $8237d31e7e86c8c4$export$ae89b6b0e7b50e02 = {
    TASK_FAIL: 'taskFail',
    TASK_SUCCESS: 'taskSuccess',
    TASK_ABORT: 'taskAbort'
};



var $cD1qu = parcelRequire("cD1qu");


var $56QzY = parcelRequire("56QzY");


var $gtj7V = parcelRequire("gtj7V");


var $en1dX = parcelRequire("en1dX");


var $isdzP = parcelRequire("isdzP");


var $kmHPt = parcelRequire("kmHPt");


var $asNlu = parcelRequire("asNlu");

const $ec302ec1fafac461$export$4c0ea2f40582e756 = ({ commentId: commentId, parentCommentMarkerRef: parentCommentMarkerRef, pageId: pageId, pageMode: pageMode, eventEmitter: eventEmitter, source: source, commentType: commentType, removeUnresolvedInlineComment: removeUnresolvedInlineComment, createAnalyticsEvent: createAnalyticsEvent, getInlineNodeTypes: getInlineNodeTypes, setEditorViewProps: setEditorViewProps })=>{
    // Update the unresolved inline comments count
    removeUnresolvedInlineComment && removeUnresolvedInlineComment(parentCommentMarkerRef);
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'resolved',
            actionSubject: 'comment',
            actionSubjectId: commentId,
            objectType: 'page',
            objectId: pageId,
            source: source,
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                source: source,
                commentType: commentType,
                pageMode: pageMode,
                framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                navdexPointType: (0, $56QzY.END),
                inlineNodeTypes: parentCommentMarkerRef && getInlineNodeTypes ? getInlineNodeTypes(parentCommentMarkerRef) : undefined,
                targetNodeType: (0, $asNlu.getTargetNodeType)(parentCommentMarkerRef, pageMode !== (0, $cD1qu.PageMode).VIEW)
            }
        }
    }).fire();
    // Emit the event to mark the annotation as resolved
    if (pageMode === (0, $cD1qu.PageMode).VIEW) eventEmitter?.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
        [parentCommentMarkerRef]: {
            id: parentCommentMarkerRef,
            annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT,
            state: (0, $cUycv.AnnotationMarkStates).RESOLVED
        }
    });
    else {
        eventEmitter?.emit('resolve', parentCommentMarkerRef);
        setEditorViewProps && setEditorViewProps(null);
    }
};
const $ec302ec1fafac461$export$6df9d2fc03993824 = ({ commentId: commentId, annotationId: annotationId, pageId: pageId, pageMode: pageMode, isReply: isReply, source: source, inlineNodeTypes: inlineNodeTypes, removeUnresolvedInlineComment: removeUnresolvedInlineComment, createAnalyticsEvent: createAnalyticsEvent, onSuccess: onSuccess })=>{
    if (!annotationId) throw new Error('No annotationId for delete');
    // Update the unresolved inline comments count
    removeUnresolvedInlineComment(annotationId);
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'deleted',
            actionSubject: 'comment',
            actionSubjectId: commentId,
            objectType: 'page',
            objectId: pageId,
            source: source,
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                commentType: (0, $en1dX.CommentType).INLINE,
                source: source,
                pageMode: pageMode,
                framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                inlineNodeTypes: inlineNodeTypes,
                isReply: isReply,
                targetNodeType: (0, $asNlu.getTargetNodeType)(annotationId, pageMode !== (0, $cD1qu.PageMode).VIEW)
            }
        }
    }).fire();
    // Call the function passed in to do success specific things for each iteration
    onSuccess(annotationId);
};
const $ec302ec1fafac461$export$f2f4dc3fd9171ad8 = ({ experienceTracker: experienceTracker, experienceName: experienceName, error: error, commentId: commentId, shouldReturnError: shouldReturnError = false, shouldAbortForExpectedError: shouldAbortForExpectedError = false, compoundExperienceName: compoundExperienceName })=>{
    // get a truncated graphql error message
    const { message: message } = (0, $isdzP.parseError)(error);
    const translatedError = (0, $isdzP.getTranslatedError)(message, commentId);
    if ((0, $isdzP.isUnexpectedError)(translatedError)) {
        experienceTracker.stopOnError({
            name: experienceName,
            error: error
        });
        /*
     * stopOnError will fail the experience unless it's a session or network error, then it will be aborted.
     * If the experience is failed and is a sub-experience, the compound experience will be failed automatically.
     * If the experience is aborted and is a sub-experience, we need to abort the compound experience.
     */ if (compoundExperienceName) {
            const experienceState = experienceTracker.getExperienceState(experienceName);
            if (experienceState?.stopState === (0, $8237d31e7e86c8c4$export$ae89b6b0e7b50e02).TASK_ABORT) experienceTracker.stopOnError({
                name: compoundExperienceName,
                error: error
            });
        }
    } else {
        // we currently display a generic message to the user whenever an error occurs
        // These errors will not be reported to splunk/signalfx through experience tracking as they are expected
        (0, $7Sm4c.markErrorAsHandled)(error);
        if (shouldAbortForExpectedError) {
            // Ensure reason is always a string
            const reason = typeof translatedError.defaultMessage === 'string' ? translatedError.defaultMessage : message;
            experienceTracker.abort({
                name: experienceName,
                reason: reason
            });
            // If a compound experience is also running, we need to abort it
            if (compoundExperienceName) experienceTracker.abort({
                name: compoundExperienceName,
                reason: reason
            });
        }
    }
    if (shouldReturnError) // CommentEditor expects a translated error message otherwise it fails
    // TODO: CommentEditor should likely just receive the translated message
    // rather than expect the object needed for FormattedMessage
    return Promise.reject({
        error: translatedError
    });
};
module.exports["handleResolveSuccess"] = $ec302ec1fafac461$export$4c0ea2f40582e756;
module.exports["handleDeleteSuccess"] = $ec302ec1fafac461$export$6df9d2fc03993824;
module.exports["handleMutationFailure"] = $ec302ec1fafac461$export$f2f4dc3fd9171ad8;

});

parcelRegister("ibqdE", function(module, exports) {

var $3mVfX = parcelRequire("3mVfX");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $5dbc03d9e41dd9c7$export$36062d4a94e50365 = 2;
var $5dbc03d9e41dd9c7$export$8a64eadc3c5e2e9a = /*#__PURE__*/ function(ViewReplyOptions) {
    ViewReplyOptions["ALL"] = "ALL";
    ViewReplyOptions["DEFAULT"] = "DEFAULT";
    ViewReplyOptions["HIDDEN"] = "HIDDEN";
    ViewReplyOptions["LIMITED"] = "LIMITED";
    return ViewReplyOptions;
}({});
const $5dbc03d9e41dd9c7$export$564e359a57aeb34a = ({ currentReplyView: currentReplyView, setVisibleReplies: setVisibleReplies, allReplies: allReplies, isParentCommentOpen: isParentCommentOpen, latestReplies: latestReplies, parentCommentId: parentCommentId, currentView: currentView, allowNestedReplies: allowNestedReplies = false })=>{
    if (!isParentCommentOpen && currentView !== (0, $3mVfX.ViewValues).RESOLVED) {
        setVisibleReplies([]);
        return;
    }
    switch(currentReplyView){
        case "ALL":
            if (allowNestedReplies) setVisibleReplies(allReplies);
            else {
                const topLevelReplies = $5dbc03d9e41dd9c7$export$e9719a1dca3c9c9(allReplies, parentCommentId);
                // Make all direct replies to the parent comment visible, excluding any nested replies.
                setVisibleReplies(topLevelReplies);
            }
            break;
        case "HIDDEN":
            setVisibleReplies([]);
            break;
        case "LIMITED":
            setVisibleReplies(latestReplies);
            break;
    }
};
const $5dbc03d9e41dd9c7$export$8dc53daba2bd52b3 = ({ currentReplyView: currentReplyView, allReplies: allReplies, isParentCommentOpen: isParentCommentOpen, latestReplies: latestReplies, parentCommentId: parentCommentId, currentView: currentView, allowNestedReplies: allowNestedReplies = false })=>{
    if (!isParentCommentOpen && currentView !== (0, $3mVfX.ViewValues).RESOLVED) return [];
    switch(currentReplyView){
        case "ALL":
            return allowNestedReplies ? allReplies : $5dbc03d9e41dd9c7$export$e9719a1dca3c9c9(allReplies, parentCommentId);
        case "HIDDEN":
            return [];
        case "LIMITED":
            return latestReplies;
        default:
            return [];
    }
};
const $5dbc03d9e41dd9c7$export$e9719a1dca3c9c9 = (replies, parentCommentId)=>replies.filter(({ parentId: parentId })=>parentId === parentCommentId);
const $5dbc03d9e41dd9c7$export$94e4f6e86c2cc22f = ({ replies: replies, latestReplyIds: latestReplyIds, currentReplyView: currentReplyView })=>{
    switch(currentReplyView){
        case "HIDDEN":
            return replies.length;
        case "LIMITED":
            return replies.length - latestReplyIds.size;
        default:
            return 0;
    }
};
const $5dbc03d9e41dd9c7$export$e5bfa4c04a9e4b5c = ({ replies: replies, isParentOpen: isParentOpen, latestReplyIds: latestReplyIds })=>replies.filter((reply)=>{
        if ((0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux')) return !latestReplyIds.has(reply.id);
        return !isParentOpen ? true : !latestReplyIds.has(reply.id);
    });
const $5dbc03d9e41dd9c7$export$9445637fea268c7c = (repliesToFilter)=>{
    const uniqueAccountsMap = new Map();
    // Start from the end of the list and move backwards
    for(let i = repliesToFilter.length - 1; i >= 0; i--){
        const reply = repliesToFilter[i];
        const { displayName: displayName, profilePicture: profilePicture } = reply.author;
        // Determine if the author has an accountId, anonymous users don't have accountId
        let uniqueKey;
        if ('accountId' in reply.author && reply.author.accountId) uniqueKey = reply.author.accountId;
        else // Fallback for anonymous users or if accountId is not present
        uniqueKey = `anonymous-${i}`;
        if (!uniqueAccountsMap.has(uniqueKey)) uniqueAccountsMap.set(uniqueKey, {
            displayName: displayName ?? '',
            profilePicturePath: profilePicture?.path
        });
    }
    return Array.from(uniqueAccountsMap.values());
};
const $5dbc03d9e41dd9c7$export$a949713ee36203b3 = ({ replies: replies = [], isEditorExpanded: isEditorExpanded })=>replies.length >= 1 || isEditorExpanded || !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true);
module.exports["DEFAULT_NUM_VISIBLE_REPLIES"] = $5dbc03d9e41dd9c7$export$36062d4a94e50365;
module.exports["ViewReplyOptions"] = $5dbc03d9e41dd9c7$export$8a64eadc3c5e2e9a;
module.exports["updateVisibleReplies"] = $5dbc03d9e41dd9c7$export$564e359a57aeb34a;
module.exports["getCommentReplies"] = $5dbc03d9e41dd9c7$export$e9719a1dca3c9c9;
module.exports["computeVisibleReplies"] = $5dbc03d9e41dd9c7$export$8dc53daba2bd52b3;
module.exports["getNumOfHiddenReplies"] = $5dbc03d9e41dd9c7$export$94e4f6e86c2cc22f;
module.exports["getDefaultHiddenReplies"] = $5dbc03d9e41dd9c7$export$e5bfa4c04a9e4b5c;
module.exports["getProfilePicturesOfHiddenReplies"] = $5dbc03d9e41dd9c7$export$9445637fea268c7c;
module.exports["getShouldShowRepliesSection"] = $5dbc03d9e41dd9c7$export$a949713ee36203b3;

});

parcelRegister("aNRAP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $6FXhW = parcelRequire("6FXhW");


var $cvIm8 = parcelRequire("cvIm8");

// Stable empty map so the initial provider value keeps referential equality across renders.
const $c42401cd0848ac74$var$EMPTY_SESSIONS = new Map();
// A content signature so we only push a new map into context when the data actually
// changes — buildSessionMap returns a fresh Map instance on every render even when
// unchanged, so we can't compare by reference.
function $c42401cd0848ac74$var$sessionsSignature(map) {
    return Array.from(map.entries()).map(([id, session])=>`${id}:${session.conversationId}:${session.state ?? ''}`).sort().join('|');
}
/**
 * Inner loader — calls useLazyLoadQuery (may suspend or throw). It renders nothing;
 * its only job is to push the resolved session map up to the provider via onLoaded.
 * Because it lives in a Suspense sibling (not wrapping the children), suspending here
 * never blanks the surrounding comment UI.
 */ function $c42401cd0848ac74$var$AgentSessionsLoader({ pageId: pageId, onLoaded: onLoaded }) {
    const sessionMap = (0, $cvIm8.usePageCommentAgentSessionsInner)(pageId);
    const signature = $c42401cd0848ac74$var$sessionsSignature(sessionMap);
    // This surface fetches eagerly and does NOT read the per-user `cc-agent-mention-sessions`
    // marker (only the footer's AgentSessionsFetcher gates on it). We deliberately do not
    // delete that marker here: this provider mounts right after a comment is saved, when the
    // query is briefly empty because the backend hasn't created the session association yet —
    // deleting on that transient empty result would race the post-save refetch and wrongly
    // strip the marker the footer relies on. The footer owns the marker's cleanup.
    (0, $42omo.useEffect)(()=>{
        onLoaded(sessionMap);
    // Depend on `signature` (content) rather than `sessionMap` (new ref every render).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        signature,
        onLoaded
    ]);
    return null;
}
function $c42401cd0848ac74$export$e05d67ad9e1928ba({ pageId: pageId, children: children, onSessionMapChange: onSessionMapChange }) {
    const [sessionMap, setSessionMap] = (0, $42omo.useState)($c42401cd0848ac74$var$EMPTY_SESSIONS);
    const handleLoaded = (0, $42omo.useCallback)((map)=>{
        setSessionMap(map);
        onSessionMapChange?.(map);
    }, [
        onSessionMapChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FXhW.AgentSessionsContext).Provider, {
        value: sessionMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COMMENTS,
        renderOnError: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c42401cd0848ac74$var$AgentSessionsLoader, {
        pageId: pageId,
        onLoaded: handleLoaded
    }))), children);
}
module.exports["AgentSessionsProvider"] = $c42401cd0848ac74$export$e05d67ad9e1928ba;

});

parcelRegister("6FXhW", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $b07d8c9d22f2f251$export$3550862aa0bdc052 = (0, $42omo.createContext)(new Map());
function $b07d8c9d22f2f251$export$83879714422b787c() {
    return (0, $42omo.useContext)($b07d8c9d22f2f251$export$3550862aa0bdc052);
}
module.exports["AgentSessionsContext"] = $b07d8c9d22f2f251$export$3550862aa0bdc052;
module.exports["useAgentSessionsContext"] = $b07d8c9d22f2f251$export$83879714422b787c;

});

parcelRegister("cvIm8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $6FXhW = parcelRequire("6FXhW");


var $gXKuh = parcelRequire("gXKuh");

/**
 * @generated SignedSource<<d85f7af04a5df3e069f9d654b3d4be7f>>
 * @relayHash db99425b11e2357285d4f7e870838705
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1e6a67890f5506cf19d670f84fdf2ffaf41d857ea6c0a0e6278d28e738cd8c16
const $d3972552115b8cca$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "pageId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "conversationId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "subEntityId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "state"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentAgentSessionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "AgentSessionAssociationConnection",
                                    "kind": "LinkedField",
                                    "name": "allCommentAgentSessions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AgentSessionAssociationEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AgentSessionAssociation",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "concreteType": "AgentSession",
                                                            "kind": "LinkedField",
                                                            "name": "agentSession",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "agent",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v2 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        v7 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentAgentSessionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "AgentSessionAssociationConnection",
                                    "kind": "LinkedField",
                                    "name": "allCommentAgentSessions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AgentSessionAssociationEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AgentSessionAssociation",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "concreteType": "AgentSession",
                                                            "kind": "LinkedField",
                                                            "name": "agentSession",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "agent",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "__typename"
                                                                        },
                                                                        v2 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        v7 /*: any*/ 
                                                                    ]
                                                                },
                                                                v2 /*: any*/ 
                                                            ]
                                                        },
                                                        v2 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "db99425b11e2357285d4f7e870838705",
            "id": "1e6a67890f5506cf19d670f84fdf2ffaf41d857ea6c0a0e6278d28e738cd8c16",
            "metadata": {},
            "name": "CommentAgentSessionsQuery",
            "operationKind": "query",
            "text": "query CommentAgentSessionsQuery($pageId:ID!){content(id:$pageId){nodes{id,allCommentAgentSessions{edges{node{conversationId,subEntityId,agentSession{state,agent{__typename,id,name,picture},id},id}}}}}}"
        }
    };
}();
$d3972552115b8cca$var$node.hash = "0931b246a9d33ad16dc8e58269908386";
var $d3972552115b8cca$export$2e2bcd8739ae039 = $d3972552115b8cca$var$node;


const $f539051e975c360c$export$b506abc5596c50d5 = (0, $d3972552115b8cca$export$2e2bcd8739ae039);


const $2a48f77aafd2c021$export$a9d01a6e83b02ecf = [
    2000,
    5000,
    10000
];
const $2a48f77aafd2c021$var$VALID_CONVERSATION_STATES = new Set([
    'WORKING',
    'ARTEFACT_READY',
    'INPUT_REQUIRED',
    'FAILED'
]);
// Terminal snapshot state the backend reports once the agent has finished its task (the
// ConvoAiAgentSessionState `COMPLETED` value). Per design, a completed session shows NO
// agent-status row, so buildSessionMap skips these sessions entirely (see below).
const $2a48f77aafd2c021$var$COMPLETED_STATE = 'COMPLETED';
/**
 * Builds a CommentAgentSessionMap from a Relay query result.
 * Pure data transformation — no hooks, no side effects.
 */ function $2a48f77aafd2c021$var$buildSessionMap(data) {
    const sessionMap = new Map();
    // Both loops are bounded: content.nodes is always a single page node, and
    // allCommentAgentSessions is bounded by the number of agent-mentioned comments
    // on the page — a small, user-driven number in practice.
    // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    for (const node of data?.content?.nodes ?? [])// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    for (const edge of node?.allCommentAgentSessions?.edges ?? []){
        const session = edge?.node;
        if (session?.conversationId && session?.subEntityId) {
            // subEntityId format: "ari:cloud:confluence:<cloudId>:comment/<commentId>"
            // Extract the numeric comment ID from the end so map keys match comment.id
            // used in ObjectComment / ObjectCommentThread.
            const lastSlash = session.subEntityId.lastIndexOf('/');
            const commentId = lastSlash >= 0 ? session.subEntityId.slice(lastSlash + 1) : session.subEntityId;
            const rawState = session.agentSession?.state;
            // The agent has finished its task (COMPLETED): render no status row at all. Skip the
            // session entirely — keeping it with a null state would fall back to WORKING in
            // useCommentAgentSession and leave a stray connector branch. COMPLETED arrives via
            // this snapshot once the backend transitions the session terminal (after the agent's
            // planned action runs); the live subscription union has no terminal "done" member.
            if (rawState === $2a48f77aafd2c021$var$COMPLETED_STATE) continue;
            const agent = session.agentSession?.agent;
            sessionMap.set(commentId, {
                conversationId: session.conversationId,
                state: rawState != null && $2a48f77aafd2c021$var$VALID_CONVERSATION_STATES.has(rawState) ? rawState : null,
                agentId: agent?.id ?? null,
                agentName: agent?.name ?? null,
                avatarUrl: agent?.picture ?? null
            });
        }
    }
    return sessionMap;
}
function $2a48f77aafd2c021$export$5da222818b77d6d2(pageId, options = {}) {
    const { refetchOnMount: refetchOnMount = false } = options;
    const environment = (0, $irOoi.useRelayEnvironment)();
    const data = (0, $irOoi.useLazyLoadQuery)((0, $f539051e975c360c$export$b506abc5596c50d5), {
        pageId: pageId
    });
    // Close the loop on newly-mentioned agents: when an agent-mention comment is saved
    // (AGENT_MENTION_COMMENT_SAVED_EVENT, also used to open the CwR sidebar), refetch the
    // sessions into the Relay store so the new comment's session connects without a reload.
    // fetchQuery updates the store imperatively and useLazyLoadQuery re-reads it reactively,
    // so this never re-suspends or blanks the comment UI. We poll a few bounded times to
    // absorb the backend's async creation of the SessionAssociationPublic.
    const refetchTimersRef = (0, $42omo.useRef)([]);
    const clearRefetchTimers = (0, $42omo.useCallback)(()=>{
        refetchTimersRef.current.forEach(clearTimeout);
        refetchTimersRef.current = [];
    }, []);
    const scheduleSessionRefetches = (0, $42omo.useCallback)(()=>{
        // Supersede any in-flight poll from a previous save so timers don't pile up.
        clearRefetchTimers();
        refetchTimersRef.current = $2a48f77aafd2c021$export$a9d01a6e83b02ecf.map((delay)=>setTimeout(()=>{
                (0, $irOoi.fetchQuery)(environment, (0, $f539051e975c360c$export$b506abc5596c50d5), {
                    pageId: pageId
                }, {
                    fetchPolicy: 'network-only'
                }).subscribe({
                    error: ()=>{}
                });
            }, delay));
    }, [
        clearRefetchTimers,
        environment,
        pageId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!refetchOnMount) return;
        scheduleSessionRefetches();
        return clearRefetchTimers;
    }, [
        clearRefetchTimers,
        refetchOnMount,
        scheduleSessionRefetches
    ]);
    (0, $42omo.useEffect)(()=>{
        const handleAgentMentionCommentSaved = ()=>scheduleSessionRefetches();
        window.addEventListener((0, $gXKuh.AGENT_MENTION_COMMENT_SAVED_EVENT), handleAgentMentionCommentSaved);
        return ()=>{
            window.removeEventListener((0, $gXKuh.AGENT_MENTION_COMMENT_SAVED_EVENT), handleAgentMentionCommentSaved);
            clearRefetchTimers();
        };
    }, [
        clearRefetchTimers,
        scheduleSessionRefetches
    ]);
    return $2a48f77aafd2c021$var$buildSessionMap(data);
}
function $2a48f77aafd2c021$export$fd2a40a7613a5378() {
    // When experiment is off, return immediately — zero queries, zero Suspense.
    // AgentSessionsFetcher (the component that calls useLazyLoadQuery) is never
    // mounted in ObjectCommentContainer when the gate is off, so this context
    // will always be the default empty Map in that case.
    return (0, $6FXhW.useAgentSessionsContext)();
}
module.exports["SESSION_REFETCH_DELAYS_MS"] = $2a48f77aafd2c021$export$a9d01a6e83b02ecf;
module.exports["usePageCommentAgentSessionsInner"] = $2a48f77aafd2c021$export$5da222818b77d6d2;

});

parcelRegister("b5IrT", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $4ae6e3545e6a5bd0$export$35f9117a1502db69 = (prev, next)=>{
    if (!(0, $6mKj3.expValEquals)('confluence_comments_panel_memo_rows', 'isEnabled', true)) return false;
    if (prev === next) return true;
    const prevKeys = Object.keys(prev);
    const nextKeys = Object.keys(next);
    if (prevKeys.length !== nextKeys.length) return false;
    for (const key of prevKeys){
        if (!Object.prototype.hasOwnProperty.call(next, key)) return false;
        if (prev[key] !== next[key]) return false;
    }
    return true;
};
module.exports["arePropsShallowEqualWhenMemoRowsEnabled"] = $4ae6e3545e6a5bd0$export$35f9117a1502db69;

});

parcelRegister("4Svbr", function(module, exports) {
/**
 * @generated SignedSource<<5b0367a06411b485f0b6215329909ceb>>
 * @relayHash dbfe00fb39056eb3a0f24ae626006e70
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 37e0b01331c6dcada462d07f7764d7a34a182c06b9c730308a9449086d63c78c
const $a077863dd44c9913$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeReactions"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v10 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v11 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v10 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v12 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v13 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v10 /*: any*/ 
    }, v14 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v15 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "type"
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v17 /*: any*/ ,
                    v18 /*: any*/ ,
                    v19 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v22 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v17 /*: any*/ ,
                    v18 /*: any*/ ,
                    v19 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v23 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v24 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v25 = {
        "condition": "includeReactions",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "childType",
                        "value": "comment"
                    },
                    {
                        "kind": "Literal",
                        "name": "contentType",
                        "value": "page"
                    },
                    {
                        "kind": "Variable",
                        "name": "pageId",
                        "variableName": "pageId"
                    }
                ],
                "concreteType": "ReactionsSummaryResponse",
                "kind": "LinkedField",
                "name": "reactionsSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "containerAri"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reactionsCount"
                    },
                    {
                        "concreteType": "ReactionsSummaryForEmoji",
                        "kind": "LinkedField",
                        "name": "reactionsSummaryForEmoji",
                        "plural": true,
                        "selections": [
                            v5 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "emojiId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "reacted"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "when"
    }, v27 = {
        "kind": "ScalarField",
        "name": "number"
    }, v28 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CommentRepliesCreateGeneralReplyMutation",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "createFooterComment",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ 
                            ]
                        },
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ 
                                    ]
                                },
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CommentRepliesCreateGeneralReplyMutation",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "createFooterComment",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v28 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                v28 /*: any*/ ,
                                v16 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ 
                            ]
                        },
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                },
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "dbfe00fb39056eb3a0f24ae626006e70",
            "id": "37e0b01331c6dcada462d07f7764d7a34a182c06b9c730308a9449086d63c78c",
            "metadata": {},
            "name": "CommentRepliesCreateGeneralReplyMutation",
            "operationKind": "mutation",
            "text": "mutation CommentRepliesCreateGeneralReplyMutation($pageId:ID!,$cloudId:ID!,$input:CreateCommentInput!,$includeReactions:Boolean!){createFooterComment(cloudId:$cloudId,input:$input){id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}},version{by{__typename,displayName},when,number}}}"
        }
    };
}();
$a077863dd44c9913$var$node.hash = "42751e8cecbdf3c515d561bda37d1e47";
var $a077863dd44c9913$export$2e2bcd8739ae039 = $a077863dd44c9913$var$node;


/**
 * @generated SignedSource<<668b3edf93002cfe526b15e75a40b23c>>
 * @relayHash 0da891ebc91832bab75be58319e47f10
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dcb0effecbd4ee333f8bbc40dbf593d0618ba3236edd5007050f7f719441833d
const $bd04856e92610f9a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeReactions"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v6 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v5 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v7 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v8 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v5 /*: any*/ 
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v10 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v18 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v19 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v21 = {
        "kind": "ScalarField",
        "name": "when"
    }, v22 = {
        "kind": "ScalarField",
        "name": "number"
    }, v23 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v26 = {
        "condition": "includeReactions",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "childType",
                        "value": "comment"
                    },
                    {
                        "kind": "Literal",
                        "name": "contentType",
                        "value": "page"
                    },
                    {
                        "kind": "Variable",
                        "name": "pageId",
                        "variableName": "pageId"
                    }
                ],
                "concreteType": "ReactionsSummaryResponse",
                "kind": "LinkedField",
                "name": "reactionsSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "containerAri"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reactionsCount"
                    },
                    {
                        "concreteType": "ReactionsSummaryForEmoji",
                        "kind": "LinkedField",
                        "name": "reactionsSummaryForEmoji",
                        "plural": true,
                        "selections": [
                            v4 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "emojiId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "reacted"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CommentRepliesCreateInlineReplyMutation",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "replyInlineComment",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ 
                            ]
                        },
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v20 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ 
                            ]
                        },
                        v26 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CommentRepliesCreateInlineReplyMutation",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "replyInlineComment",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                v27 /*: any*/ ,
                                v11 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ 
                            ]
                        },
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v27 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v27 /*: any*/ ,
                                v20 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ 
                            ]
                        },
                        v26 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "0da891ebc91832bab75be58319e47f10",
            "id": "dcb0effecbd4ee333f8bbc40dbf593d0618ba3236edd5007050f7f719441833d",
            "metadata": {},
            "name": "CommentRepliesCreateInlineReplyMutation",
            "operationKind": "mutation",
            "text": "mutation CommentRepliesCreateInlineReplyMutation($input:ReplyInlineCommentInput!,$pageId:ID!,$includeReactions:Boolean!){replyInlineComment(input:$input){id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}"
        }
    };
}();
$bd04856e92610f9a$var$node.hash = "3ec5c8e50962a5f1e44c0682ca61f71f";
var $bd04856e92610f9a$export$2e2bcd8739ae039 = $bd04856e92610f9a$var$node;



var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $7EEGh = parcelRequire("7EEGh");


var $inPa6 = parcelRequire("inPa6");


var $21K7m = parcelRequire("21K7m");


var $ccHMk = parcelRequire("ccHMk");


var $3ejfs = parcelRequire("3ejfs");


var $fHAwL = parcelRequire("fHAwL");


var $hXzKU = parcelRequire("hXzKU");


var $666Tc = parcelRequire("666Tc");


var $8i27m = parcelRequire("8i27m");


var $bSvtO = parcelRequire("bSvtO");


var $8SCD6 = parcelRequire("8SCD6");


var $emtVP = parcelRequire("emtVP");


var $gurMq = parcelRequire("gurMq");


var $4rKYp = parcelRequire("4rKYp");


var $NYiei = parcelRequire("NYiei");


var $ag51I = parcelRequire("ag51I");


var $cQCqE = parcelRequire("cQCqE");


var $cD1qu = parcelRequire("cD1qu");


var $ep3mz = parcelRequire("ep3mz");


var $1ggpj = parcelRequire("1ggpj");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $6faGq = parcelRequire("6faGq");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $6FXhW = parcelRequire("6FXhW");


var $8aF6s = parcelRequire("8aF6s");


var $cMvMc = parcelRequire("cMvMc");


var $1Sjzs = parcelRequire("1Sjzs");


var $bQm3c = parcelRequire("bQm3c");


var $hl1Kw = parcelRequire("hl1Kw");


var $58Zuw = parcelRequire("58Zuw");


var $lLpk8 = parcelRequire("lLpk8");


var $ibqdE = parcelRequire("ibqdE");


var $8gR6k = parcelRequire("8gR6k");


var $jVIRU = parcelRequire("jVIRU");

/* GeneralReplyScroller.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $ecnYn = parcelRequire("ecnYn");


var $bUlM5 = parcelRequire("bUlM5");


var $2W0qg = parcelRequire("2W0qg");


var $2Pg7f = parcelRequire("2Pg7f");


var $gdv5Z = parcelRequire("gdv5Z");








var $fURMF = parcelRequire("fURMF");

const $2e558da207609fcd$var$replyScrollerStyles = {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    height: '24px',
    marginTop: "var(--ds-space-150, 12px)",
    left: 0
};
const $2e558da207609fcd$var$replyScrollerStylesV2 = {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    height: '24px',
    left: 0
};
const $2e558da207609fcd$var$replyScrollerBranchingStyle = null;
const $2e558da207609fcd$var$replyWrapperWithSpacingStyles = {
    paddingTop: "var(--ds-space-100, 8px)"
};
const $2e558da207609fcd$var$leftMargin = null;
const $2e558da207609fcd$var$unreadIndicatorStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center'
}); // This snippet is being used in CommentBody.tsx
const $2e558da207609fcd$var$dotStyles = null;
const $2e558da207609fcd$var$pressableStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle',
    backgroundColor: 'color.background.neutral.subtle',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    borderRadius: 'radius.small',
    userSelect: 'none',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    ':hover': {
        cursor: 'pointer',
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $2e558da207609fcd$var$styles = {
    generalReplyScrollerWrapperStyles: "_1kl71h4i _ca0qutpp"
};
const $2e558da207609fcd$var$i18n = (0, $aXWIB.defineMessages)({
    commentsPanelShowGeneralNestedReplies: {
        id: "comments-common.comment-thread.go.to.nested.general.reply",
        defaultMessage: "Go to more replies"
    },
    commentsPanelGeneralNestedRepliesHasUnread: {
        id: "comments-common.comment-thread.general.nested.replies.has.unread",
        defaultMessage: "There are unread replies"
    }
});
const $2e558da207609fcd$export$a0769df2292690a8 = ({ nestedReplies: nestedReplies, unreadReplyIds: unreadReplyIds, targetCommentIdForScroll: targetCommentIdForScroll, isLastUnnestableReply: isLastUnnestableReply })=>(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2e558da207609fcd$var$GeneralReplyScrollerWrapperComponent, {
        nestedReplies: nestedReplies,
        unreadReplyIds: unreadReplyIds,
        targetCommentIdForScroll: targetCommentIdForScroll,
        isLastUnnestableReply: isLastUnnestableReply
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2e558da207609fcd$var$GeneralReplyScrollerComponent, {
        nestedReplies: nestedReplies,
        unreadReplyIds: unreadReplyIds,
        targetCommentIdForScroll: targetCommentIdForScroll
    });
const $2e558da207609fcd$var$GeneralReplyScrollerComponent = ({ nestedReplies: nestedReplies, unreadReplyIds: unreadReplyIds, targetCommentIdForScroll: targetCommentIdForScroll })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const maxProfilePicturesToShow = 3; // If any of the nestedReplies match an ID in unreadReplyIds, render the blue dot indicator
    const unreadReplyIdsSet = new Set(unreadReplyIds);
    const shouldRenderBlueDotIndicator = nestedReplies.some((reply)=>unreadReplyIdsSet.has(reply.id));
    const avatarsToShow = (0, $42omo.useMemo)(()=>{
        const uniqueAccountsMap = new Map(); // Start from the end of the list and move backwards
        for(let i = nestedReplies.length - 1; i >= 0; i--){
            const reply = nestedReplies[i];
            const { displayName: displayName, profilePicture: profilePicture } = reply.author; // Determine if the author has an accountId, anonymous users don't have accountId
            let uniqueKey;
            if ('accountId' in reply.author && reply.author.accountId) uniqueKey = reply.author.accountId;
            else // Fallback for anonymous users or if accountId is not present
            uniqueKey = `anonymous-${i}`;
            if (!uniqueAccountsMap.has(uniqueKey)) uniqueAccountsMap.set(uniqueKey, {
                displayName: displayName ?? '',
                profilePicturePath: profilePicture?.path
            });
        }
        const avatars = Array.from(uniqueAccountsMap.values());
        const mappedAvatars = avatars.map((profilePicturesInfo)=>({
                name: profilePicturesInfo.displayName,
                src: profilePicturesInfo.profilePicturePath
            }));
        return mappedAvatars;
    }, [
        nestedReplies
    ]); // NOTE: This component replicates a lot of the code in RepliesToggler.tsx
    // However, GeneralReplyScroller is only used for multi nested general comment replies for pages created before the single threading general comments feature was introduced
    // All new pages created after this time will use RepliesScroller instead of GeneralReplyScroller
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswh2mm _18u01jfw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
        testId: "comments-panel-reply-scroller-container",
        showDefaultStyles: true,
        customStyles: {
            ...(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? $2e558da207609fcd$var$replyScrollerStylesV2 : $2e558da207609fcd$var$replyScrollerStyles,
            ...$2e558da207609fcd$var$replyWrapperWithSpacingStyles
        },
        disableLeftProp: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_18u0utpp"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        onClick: ()=>{
            const targetElementId = `footer-comment-thread-${targetCommentIdForScroll}-replies`; // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const commentElement = document.getElementById(targetElementId); // NOTE - redesigned footer comments don't yet all load when the panel is opened, so may not be in the DOM
            // In cases where this is not yet in the DOM, we treat it like clicking the comment body in commentThreadHelper#shouldTriggerCommentScroll
            if (commentElement) {
                const offset = -60;
                (0, $fURMF.scrollToElement)(commentElement, offset, 'smooth');
            }
        },
        testId: "comments-panel-thread-show-nested-general-replies",
        xcss: $2e558da207609fcd$var$pressableStyles,
        interactionName: "comments-panel-thread-show-nested-general-replies"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.050"
    }, avatarsToShow.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
        data: avatarsToShow,
        maxCount: maxProfilePicturesToShow,
        appearance: "stack",
        size: "small",
        shouldPopupRenderToParent: true,
        testId: "comments-panel-replies-scroller-profile-pictures"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: $2e558da207609fcd$var$unreadIndicatorStyle
    }, formatMessage($2e558da207609fcd$var$i18n.commentsPanelShowGeneralNestedReplies), shouldRenderBlueDotIndicator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "comments-panel-unread-nested-general-replies-indicator",
        "aria-label": formatMessage($2e558da207609fcd$var$i18n.commentsPanelGeneralNestedRepliesHasUnread),
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _18s81b66 _4t3iu2gc _1bsbu2gc _bfhk1856"
        ])
    }))))))));
};
const $2e558da207609fcd$var$GeneralReplyScrollerWrapperComponent = ({ nestedReplies: nestedReplies, unreadReplyIds: unreadReplyIds, targetCommentIdForScroll: targetCommentIdForScroll, isLastUnnestableReply: isLastUnnestableReply })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: `general-reply-scroller-wrapper-${isLastUnnestableReply ? 'without-border' : 'with-border'}`,
        xcss: isLastUnnestableReply ? undefined : $2e558da207609fcd$var$styles.generalReplyScrollerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2e558da207609fcd$var$GeneralReplyScrollerComponent, {
        nestedReplies: nestedReplies,
        unreadReplyIds: unreadReplyIds,
        targetCommentIdForScroll: targetCommentIdForScroll
    }));



var $i6UMJ = parcelRequire("i6UMJ");


var $3mVfX = parcelRequire("3mVfX");


var $en1dX = parcelRequire("en1dX");


var $6tkbf = parcelRequire("6tkbf");


var $cZa7r = parcelRequire("cZa7r");


var $6hmtW = parcelRequire("6hmtW");


var $308Wd = parcelRequire("308Wd");


var $7qvmT = parcelRequire("7qvmT");


var $b5IrT = parcelRequire("b5IrT");


var $9tfnI = parcelRequire("9tfnI");

const $ff4f83a3b963012b$var$CommentRepliesCreateInlineReplyMutation = (0, $bd04856e92610f9a$export$2e2bcd8739ae039);
const $ff4f83a3b963012b$var$CommentRepliesCreateGeneralReplyMutation = (0, $a077863dd44c9913$export$2e2bcd8739ae039);
const $ff4f83a3b963012b$var$commentThreadRepliesBoxStyles = null;
const $ff4f83a3b963012b$var$commentThreadRepliesBoxStylesV2 = null;
const $ff4f83a3b963012b$var$commentThreadRepliesBoxStandaloneStyleOverrides = null;
const $ff4f83a3b963012b$var$commentThreadRepliesBoxStandaloneStyleOverridesV2 = null;
const $ff4f83a3b963012b$var$commentHandlesPaddingReplyBoxOverrides = null;
const $ff4f83a3b963012b$var$replyBoxStyles = null;
const $ff4f83a3b963012b$var$translucentStyle = null;
const $ff4f83a3b963012b$var$replyActionButtonStyles = {
    marginLeft: "var(--ds-space-150, 12px)",
    width: '62px',
    height: '24px',
    left: '-12px',
    paddingTop: "var(--ds-space-100, 8px)",
    paddingBottom: "var(--ds-space-100, 8px)"
};
const $ff4f83a3b963012b$var$customizedReplyButtonStyles = null;
const $ff4f83a3b963012b$var$commentEditorCustomStyles = {
    marginLeft: "var(--ds-space-300, 24px)",
    height: '24px',
    // 24px = 16px offset + 8px of padding
    marginRight: "var(--ds-space-050, 4px)",
    paddingTop: "var(--ds-space-100, 8px)"
};
const $ff4f83a3b963012b$var$i18n = (0, $aXWIB.defineMessages)({
    replyAction: {
        id: "comments-panel.reply.action",
        defaultMessage: "Reply"
    },
    threadReplyButtonAriaLabelWithName: {
        id: "comments-panel.reply.button.aria-label.with-name",
        defaultMessage: "Reply to {name}\u2019s thread"
    },
    replyAriaLabel: {
        id: "comments-panel.reply.aria-label",
        defaultMessage: "Reply by {authorName}, {timestamp}"
    }
});
const $ff4f83a3b963012b$var$CommentRepliesComponent = ({ parentComment: parentComment, pageInfo: pageInfo, hoveredCommentId: hoveredCommentId, pageMode: pageMode, editCommentQueryId: editCommentQueryId, selectedAnnotation: selectedAnnotation, parentCommentId: parentCommentId, handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, canAddComments: canAddComments, isStandaloneComment: isStandaloneComment, deleteStandaloneComment: deleteStandaloneComment, replyToComment: replyToComment, updateReactionsCacheFn: updateReactionsCacheFn, onRendered: onRendered, eventEmitter: eventEmitter, isEditorExpanded: isEditorExpanded = false, hasParentMaxHeight: hasParentMaxHeight = false, flags: flags, hideReactions: hideReactions = false, isCommentSummaryPopup: isCommentSummaryPopup = false })=>{
    const [createInlineReplyFn] = (0, $308Wd.useMutationInterop)($ff4f83a3b963012b$var$CommentRepliesCreateInlineReplyMutation, {
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "@confluence/comments-panel"
    });
    const [createGeneralReplyFn] = (0, $308Wd.useMutationInterop)($ff4f83a3b963012b$var$CommentRepliesCreateGeneralReplyMutation, {
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "@confluence/comments-panel"
    });
    const { isReactionsEnabled: isReactionsEnabled } = (0, $42omo.useContext)((0, $8SCD6.ReactionsContext)); // A reply renders its agent-session status row below itself; read the page's agent-session
    // map so we can keep the connector line visible for such a reply (mirrors the footer's
    // ObjectCommentNestableReplies), otherwise the status floats when the reply is last.
    const agentSessions = (0, $6FXhW.useAgentSessionsContext)();
    const pageId = pageInfo?.id ?? '';
    const pageType = pageInfo?.type ?? '';
    const { createInlineReplyInterop: createInlineReplyInterop } = (0, $cQCqE.useCreateInlineReplyMutation)({
        contentId: pageId
    });
    const { addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: pageId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    const createObjectCommentMutationFn = (0, $ag51I.useCreateObjectCommentMutation)();
    const intl = (0, $aXWIB.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { cloudId: cloudId, userId: userId, displayName: displayName } = (0, $bQm3c.useSessionData)();
    const { showFyi: showFyi, agent: agent, onContentChange: onAgentMentionContentChange } = (0, $gurMq.useAgentMentionFyiNudge)({
        cloudId: cloudId,
        enabled: (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)
    }); // Track whether the FYI component has ever been shown, so we only load the
    // chunk on first mention but keep it mounted for the collapse animation.
    const hasShownFyiRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (showFyi) hasShownFyiRef.current = true;
    }, [
        showFyi
    ]);
    const handleContentChangeWithData = (0, $42omo.useCallback)((_hasChanges, adf)=>{
        onAgentMentionContentChange(adf);
    }, [
        onAgentMentionContentChange
    ]);
    const [{ searchSessionId: searchSessionId }] = (0, $hl1Kw.useSearchSessionId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { addReplyToCommentThread: addReplyToCommentThread } = (0, $8i27m.useCommentsDataActions)();
    const [{ replyToCommentId: replyToCommentId, location: location, replyToCommentUser: replyToCommentUser, replyToContributorUsers: replyToContributorUsers }, { setReplyToCommentId: setReplyToCommentId }] = (0, $3mVfX.useCommentsPanel)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const isOffline = (0, $cZa7r.useAnnotationsIsOffline)();
    const { commentService: commentService } = (0, $6hmtW.useCommentService)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const allReplies = (0, $42omo.useMemo)(()=>parentComment.replies.filter((r)=>r !== null && parentComment.location.inlineMarkerRef === r.location.inlineMarkerRef), [
        parentComment.replies,
        parentComment.location
    ]);
    const numOfReplies = allReplies.length;
    const unreadReplyIds = (0, $42omo.useMemo)(()=>{
        return allReplies.filter((r)=>unreadCommentIDSet.has(r.id)).map((r)=>r.id);
    }, [
        allReplies,
        unreadCommentIDSet
    ]);
    const [legacyVisibleReplies, setVisibleReplies] = (0, $42omo.useState)(undefined);
    const [, setCommentForEdit] = (0, $42omo.useState)('');
    const [commentIsFocused, setCommentIsFocused] = (0, $42omo.useState)(null);
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const commentType = parentComment.type;
    const inlineCommentLocation = parentComment?.location;
    const isDanglingComment = commentType === (0, $8i27m.CommentType).INLINE && inlineCommentLocation?.inlineResolveProperties?.isDangling && !isStandaloneComment && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux');
    const isParentCommentOpen = parentComment.isOpen;
    const isParentCommentResolvedOrDangling = !isParentCommentOpen || Boolean(isDanglingComment);
    const [currentReplyView, setReplyView] = (0, $42omo.useState)(// Determine the reply view by counting the total number of top-level replies to the parent comment.
    // This excludes any nested replies.
    (0, $7qvmT.getDefaultReplyView)((0, $ibqdE.getCommentReplies)(allReplies, parentCommentId).length, isParentCommentResolvedOrDangling, isStandaloneComment)); // User page permissions
    const operations = pageInfo?.operations || []; // User space permissions - only access when feature gate is on
    const spaceOperations = (0, $9wGTI.fg)('confluence_comments_space_operations_permissions') ? pageInfo?.space?.operations || [] : [];
    const canAddComment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment');
    const canAddAttachment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment') || spaceOperations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment'); // The user can upload media only if they have update permissions for the page if confluence_comment_use_comment_media_endpoint FG is off
    const hasMediaUploadPermissions = (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? canAddComment && canAddAttachment : operations.some((op)=>op?.operation === 'update' && op?.targetType === pageType);
    const threadKey = commentType === (0, $8i27m.CommentType).INLINE ? (parentComment?.location).inlineMarkerRef || '' : parentCommentId; // When in summarizer popup, force empty actions on replies.
    // reopen won't be rendered for reply, but we are using it to render disabled reaction summary for replies
    //
    // When the confluence_comments_panel_memo_rows experiment is enabled,
    // memoise supportedTopLevelActions so the array literal is stable across
    // renders for a given (isCommentSummaryPopup, isParentCommentOpen) pair.
    // Without this, this `let`-reassigned array is fresh on every render and
    // flows down to every reply <Comment> as a changed prop, defeating the
    // React.memo wrapper. When the experiment is disabled, fall back to the
    // legacy inline branch so behaviour is unchanged.
    const memoisedSupportedTopLevelActions = (0, $42omo.useMemo)(()=>{
        if (isCommentSummaryPopup) return [];
        if (isParentCommentOpen) return [
            'edit',
            'resolve',
            'delete'
        ];
        return [
            'reopen'
        ];
    }, [
        isCommentSummaryPopup,
        isParentCommentOpen
    ]);
    let supportedTopLevelActions;
    if ((0, $6mKj3.expValEquals)('confluence_comments_panel_memo_rows', 'isEnabled', true)) supportedTopLevelActions = memoisedSupportedTopLevelActions;
    else if (isCommentSummaryPopup) supportedTopLevelActions = [];
    else if (isParentCommentOpen) supportedTopLevelActions = [
        'edit',
        'resolve',
        'delete'
    ];
    else supportedTopLevelActions = [
        'reopen'
    ];
     // When inside the summarizer popup, never expand the reply editor inline.
    let expandReplyEditor = false;
    if (isCommentSummaryPopup) expandReplyEditor = false;
    else if ((0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true)) expandReplyEditor = isEditorExpanded;
    else expandReplyEditor = location === (0, $i6UMJ.LocationValue).PANEL && (replyToCommentId === parentCommentId || allReplies.some((reply)=>reply.id === replyToCommentId) && (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true));
     // Track if we've already fired the analytics event for current visibleReplies state
    const hasFiredForVisibleRepliesRef = (0, $42omo.useRef)('');
    const topLevelReplyToNestedChildrenMap = (0, $42omo.useMemo)(()=>{
        const topLevelReplyIds = new Set(allReplies.filter((reply)=>reply.parentId === parentCommentId).map((reply)=>reply.id)); // We need to get all replies that are nested to any depth under a top level reply.
        // This will help us render the GeneralReplyScroller component for each reply (mainly, we need to show user icons and the blue dot indicator)
        const topLevelReplyToNestedChildrenMapInternal = Array.from(topLevelReplyIds).reduce((acc, replyId)=>{
            acc[replyId] = [];
            return acc;
        }, {});
        const replyIdToReplyMap = allReplies.reduce((acc, reply)=>{
            acc[reply.id] = reply;
            return acc;
        }, {}); // Map all replies to their top level parent. Replies can be nested to any depth, so we need to traverse the tree.
        const filteredReplies = allReplies.filter((reply)=>!topLevelReplyIds.has(reply.id));
        for (const filteredReply of filteredReplies){
            let replyParentId = filteredReply.parentId; // Add a circuit breaker to prevent infinite loops if we get really wonky data
            let circuitBreaker = 0;
            while(replyParentId && circuitBreaker < 100 && !topLevelReplyIds.has(replyParentId)){
                replyParentId = replyIdToReplyMap[replyParentId]?.parentId;
                circuitBreaker++;
            }
            if (replyParentId && replyParentId in topLevelReplyToNestedChildrenMapInternal) // Second condition will always be true, unless we somehow hit circuit breaker above
            topLevelReplyToNestedChildrenMapInternal[replyParentId].push(filteredReply);
        }
        return topLevelReplyToNestedChildrenMapInternal;
    }, [
        allReplies,
        parentCommentId
    ]); // Determine the latest top level replies to show on the thread's initial load
    const latestReplies = (0, $42omo.useMemo)(()=>{
        const replies = [];
        const topLevelReplies = allReplies.filter((reply)=>reply.id in topLevelReplyToNestedChildrenMap); // Sort by createdAtNonLocalized value
        topLevelReplies.sort((a, b)=>{
            // Safely handle missing or invalid dates
            const dateA = (0, $6faGq.getValidDate)(a?.createdAtNonLocalized);
            const dateB = (0, $6faGq.getValidDate)(b?.createdAtNonLocalized);
            return dateA.getTime() - dateB.getTime();
        }); // Add the latest replies to the replies array
        for(let i = 0; i < (0, $7qvmT.getDefaultNumVisibleReplies)(numOfReplies, isStandaloneComment, isParentCommentResolvedOrDangling); i++)if (topLevelReplies.length > 0) {
            const reply = topLevelReplies.pop();
            if (reply) // Unshift to maintain reply chronological order
            replies.unshift(reply);
        }
        return replies;
    }, [
        allReplies,
        isStandaloneComment,
        numOfReplies,
        topLevelReplyToNestedChildrenMap,
        isParentCommentResolvedOrDangling
    ]); /*
                                                                                                                             * Determine the latest top level reply IDs and their nested reply IDs.
                                                                                                                             * This is passed to RepliesToggler to determine the hidden replies.
                                                                                                                             */ 
    const latestReplyIds = (0, $42omo.useMemo)(()=>{
        const latestAndNestedReplyIds = new Set();
        for (const reply of latestReplies){
            latestAndNestedReplyIds.add(reply.id);
            for (const nestedReply of topLevelReplyToNestedChildrenMap[reply.id])latestAndNestedReplyIds.add(nestedReply.id);
        }
        return latestAndNestedReplyIds;
    }, [
        latestReplies,
        topLevelReplyToNestedChildrenMap
    ]); // Wrapper for setVisibleReplies to match the expected type signature
    const setVisibleRepliesWrapper = (0, $42omo.useCallback)((value)=>{
        if (typeof value === 'function') setVisibleReplies((prev)=>{
            const prevArray = prev === undefined ? [] : prev;
            return value(prevArray);
        });
        else setVisibleReplies(value);
    }, []);
    (0, $8gR6k.useUpdateVisibleReplies)({
        allReplies: allReplies,
        isParentCommentOpen: isParentCommentOpen,
        currentReplyView: currentReplyView,
        latestReplies: latestReplies,
        parentCommentId: parentCommentId,
        setVisibleReplies: setVisibleRepliesWrapper
    }); // Render-time derivation of visible replies. Computed unconditionally to
    // satisfy the rules of hooks; the experiment gate below selects which value
    // is consumed. Computing during render (rather than syncing state in a
    // layout effect) lets visible replies appear in SSR HTML and removes a
    // post-mount re-render on the client.
    const derivedVisibleReplies = (0, $jVIRU.useVisibleReplies)({
        allReplies: allReplies,
        isParentCommentOpen: isParentCommentOpen,
        currentReplyView: currentReplyView,
        latestReplies: latestReplies,
        parentCommentId: parentCommentId
    });
    const visibleReplies = (0, $6mKj3.expValEquals)('confluence_fe_ssr_top_footer_comments', 'isEnabled', true) ? derivedVisibleReplies : legacyVisibleReplies; // Track replies rendered state in experience tracker
    // Extract visibleReplies length to avoid complex expression in dependency array
    const visibleRepliesLength = visibleReplies?.length ?? -1;
    (0, $42omo.useEffect)(()=>{
        if (visibleReplies === undefined) return;
        const repliesRendered = currentReplyView === (0, $ibqdE.ViewReplyOptions).ALL && visibleReplies.length > 0; // Fire GASV3 event only when in ALL view with replies and we haven't fired for this state yet
        if (currentReplyView === (0, $ibqdE.ViewReplyOptions).ALL && visibleReplies.length > 0) {
            const stateKey = `${currentReplyView}-${visibleReplies.length}`; // Only fire if we haven't already fired for this exact state
            if (hasFiredForVisibleRepliesRef.current !== stateKey && numOfReplies !== 0) {
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'repliesRenderedStateChanged',
                        actionSubject: 'comment',
                        actionSubjectId: parentCommentId,
                        objectType: pageType,
                        objectId: pageId,
                        source: isStandaloneComment ? (0, $en1dX.AnalyticsSource).STANDALONE : (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                        attributes: {
                            commentType: commentType === (0, $8i27m.CommentType).GENERAL ? 'page' : 'inline',
                            repliesRendered: repliesRendered,
                            currentReplyView: currentReplyView,
                            numOfReplies: numOfReplies,
                            visibleRepliesCount: visibleReplies.length
                        }
                    }
                }).fire(); // Mark this state as fired
                hasFiredForVisibleRepliesRef.current = stateKey;
            }
        }
    }, [
        currentReplyView,
        visibleReplies,
        visibleRepliesLength,
        numOfReplies,
        commentType,
        experienceTracker,
        createAnalyticsEvent,
        parentCommentId,
        pageType,
        pageId,
        isStandaloneComment
    ]);
    const removeAnnotationHighlight = (0, $42omo.useCallback)(()=>{
        if (pageMode === (0, $cD1qu.PageMode).VIEW) eventEmitter?.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
        else eventEmitter?.emit('setselectedannotation', null);
    }, [
        pageMode,
        eventEmitter
    ]); // Track whether this CommentReplies is inside the comment summary popup.
    const isInsidePopupRef = (0, $42omo.useRef)(isCommentSummaryPopup);
    isInsidePopupRef.current = isCommentSummaryPopup; // Reset ref on component unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            hasFiredForVisibleRepliesRef.current = ''; // When inside the popup, skip resetting the panel's reply state on unmount.
            if (isInsidePopupRef.current) return;
             //TODO: Remove once https://product-fabric.atlassian.net/browse/COMMENTS-5857 is resolved
            const isDatabaseOrWhiteboard = contentType === 'database' || (0, $1ggpj.isCanvasContentType)(contentType);
            if (!isDatabaseOrWhiteboard && (0, $6mKj3.expValEquals)('confluence_comment_reset_reply_options', 'isEnabled', true)) {
                setReplyToCommentId();
                removeAnnotationHighlight();
            }
        };
    }, [
        removeAnnotationHighlight,
        setReplyToCommentId,
        contentType
    ]);
    const handleReplyButtonClick = ()=>{
        // When inside the summarizer popup, delegate to the popup's reply handler
        // so it can explicitly close the popup and then open the reply editor in the panel.
        // Check for unsaved draft first so the user can choose to keep it.
        if (isCommentSummaryPopup && replyToComment) {
            if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged();
                    replyToComment(parentCommentId, parentComment);
                }
            });
            else replyToComment(parentCommentId, parentComment);
            return;
        } // Skip if there is no active inline comment annotation and currentlySelectedComment is not general
        const shouldRemoveAnnotationHighlight = commentType === (0, $8i27m.CommentType).GENERAL && selectedAnnotation.id;
        if (hasContentChanged) // if the content has changed and the user has clicked reply button to another comment thread, warn the user
        showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                setReplyToCommentId({
                    parentCommentId: parentCommentId,
                    location: (0, $i6UMJ.LocationValue).PANEL
                });
                shouldRemoveAnnotationHighlight && eventEmitter && removeAnnotationHighlight();
            }
        });
        else {
            setReplyToCommentId({
                parentCommentId: parentCommentId,
                location: (0, $i6UMJ.LocationValue).PANEL
            });
            shouldRemoveAnnotationHighlight && eventEmitter && removeAnnotationHighlight();
        }
    };
    const handleFocus = (0, $42omo.useCallback)((event, replyId)=>{
        event.stopPropagation();
        setCommentIsFocused(replyId);
    }, [
        setCommentIsFocused
    ]);
    const handleBlur = (0, $42omo.useCallback)((event)=>{
        if (!event.relatedTarget || !event.currentTarget.contains(event.relatedTarget)) setCommentIsFocused(null);
    }, [
        setCommentIsFocused
    ]);
    const renderReplyButton = ()=>{
        return isParentCommentOpen && canAddComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
            showDefaultStyles: true,
            customStyles: $ff4f83a3b963012b$var$replyActionButtonStyles,
            testId: "comments-panel-reply-comment-action",
            onClick: handleReplyButtonClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            "data-cy": "comments-panel-reply-comment-action",
            appearance: "subtle",
            isDisabled: !isParentCommentOpen,
            analyticsContext: {
                attributes: {
                    name: 'replyToCommentButton',
                    source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL
                }
            },
            interactionName: "start-reply-comment-action",
            "aria-label": formatMessage($ff4f83a3b963012b$var$i18n.threadReplyButtonAriaLabelWithName, {
                name: parentComment.author?.displayName || formatMessage((0, $3ejfs.commentsi18n).anonymous)
            }),
            className: (0, $gMc0m.default)([
                "_1tv3glyw"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $ff4f83a3b963012b$var$i18n.replyAction)));
    }; // Helper function to check if the reply editor is visible in the comments panel
    const isReplyEditorVisible = ()=>{
        const currentDocument = typeof document !== 'undefined' ? document : undefined;
        if (!currentDocument) return false;
         // Use combined selector to find the specific reply editor for this comment thread
        const replyEditorContainer = currentDocument.querySelector(`[data-testid="comment-thread-${parentCommentId}-replies"] [data-testid="comments-panel-new-reply-container"]`);
        const panelContainer = currentDocument.querySelector('[data-testid="comments-panel-list-container"]');
        if (!replyEditorContainer || !panelContainer) return false;
        const replyEditorRect = replyEditorContainer.getBoundingClientRect();
        const panelRect = panelContainer.getBoundingClientRect(); // Check if the bottom of the reply editor container is visible within the panel
        return replyEditorRect.bottom <= panelRect.bottom;
    };
    const editorChangeHandler = ()=>{
        let experienceName = (0, $irVI7.REPLY_TO_INLINE_COMMENT_LOAD_EXPERIENCE);
        if (commentType === (0, $8i27m.CommentType).GENERAL) experienceName = (0, $irVI7.REPLY_TO_PAGE_COMMENT_LOAD_EXPERIENCE);
        experienceTracker.succeed({
            name: experienceName
        }); // Check if we need to scroll to show the reply editor
        // Only scroll if the reply editor is for this specific comment thread
        if (replyToCommentId === parentCommentId && !isReplyEditorVisible() && (0, $6mKj3.expValEquals)('confluence_comment_bring_replyeditor_intoview', 'isEnabled', true)) {
            // Use combined selector to find the specific reply editor for this comment thread
            const replyEditorContainer = typeof document !== 'undefined' ? document.querySelector(`[data-testid="comment-thread-${parentCommentId}-replies"] [data-testid="comments-panel-new-reply-container"]`) : null;
            if (replyEditorContainer) replyEditorContainer.scrollIntoView({
                behavior: 'smooth',
                block: 'end'
            });
        }
    }; // Wrap the createInlineReplyFn mutation with the interop logic that handles both the direct
    // Apollo mutation path and the new hook-based path for the Comments Data Manager
    const replyCreationInteropWrapper = (0, $42omo.useCallback)((options, onCacheUpdateError)=>createInlineReplyInterop({
            originalMutationFn: createInlineReplyFn,
            options: options,
            onCacheUpdateError: onCacheUpdateError
        }), [
        createInlineReplyInterop,
        createInlineReplyFn
    ]); // We need to intercept the raw mutation result to extract the new comment ID for agent mention
    // tagging. We can't chain .then() on onSaveReply() directly because onSaveReply's internal
    // .then() consumes the mutation data and returns undefined. Instead, we wrap the mutation fn
    // before passing it in, so we can tap the result before onSaveReply processes it.
    const buildAgentMentionCreateInlineReplyFn = (adf)=>(0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? (...args)=>{
            const promise = replyCreationInteropWrapper(...args);
            promise?.then(({ data: data })=>{
                const commentId = data?.replyInlineComment?.id ?? parentCommentId;
                (0, $emtVP.handleAgentMentionInComment)(adf, cloudId, pageId, commentId, userId ?? undefined);
            });
            return promise;
        } : replyCreationInteropWrapper; // Same pattern as buildAgentMentionCreateInlineReplyFn but for footer/general comments.
    const buildAgentMentionCreateGeneralReplyFn = (adf)=>(0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? (...args)=>{
            const promise = createGeneralReplyFn(...args);
            promise?.then(({ data: data })=>{
                const commentId = data?.createFooterComment?.id ?? parentCommentId;
                (0, $emtVP.handleAgentMentionInComment)(adf, cloudId, pageId, commentId, userId ?? undefined);
            });
            return promise;
        } : createGeneralReplyFn;
    const renderCommentEditor = ()=>{
        const editor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXzKU.LazyCommentEditor), {
            pageId: pageId,
            pageType: pageType,
            content: (0, $7qvmT.getReplyEditorContent)({
                replyToCommentUser: replyToCommentUser,
                replyToContributorUsers: replyToContributorUsers
            }),
            appearance: "chromeless",
            EditorComponent: (0, $7EEGh.ChromelessEditor),
            onSaveComment: (adf, onSuccess)=>{
                return (0, $7qvmT.onSaveReply)({
                    pageId: pageId,
                    parentCommentId: parentCommentId,
                    cloudId: cloudId,
                    adf: adf,
                    onSuccess: onSuccess,
                    pageMode: pageMode,
                    editCommentQueryId: editCommentQueryId,
                    setCommentForEdit: setCommentForEdit,
                    createAnalyticsEvent: createAnalyticsEvent,
                    pageType: pageType,
                    experienceTracker: experienceTracker,
                    createInlineReplyFn: buildAgentMentionCreateInlineReplyFn(adf),
                    createGeneralReplyFn: buildAgentMentionCreateGeneralReplyFn(adf),
                    createObjectReplyFn: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? createObjectCommentMutationFn : undefined,
                    addCommentInCommentsDataManagerCacheFn: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? addCommentInCache : undefined,
                    setReplyToCommentId: setReplyToCommentId,
                    resetContentChanged: resetContentChanged,
                    setReplyView: setReplyView,
                    selectedAnnotation: selectedAnnotation,
                    addReplyToCommentThread: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? ()=>{} : addReplyToCommentThread,
                    threadKey: threadKey,
                    commentType: commentType,
                    searchSessionId: searchSessionId,
                    isReactionsEnabled: isReactionsEnabled,
                    analyticsSource: isStandaloneComment ? (0, $en1dX.AnalyticsSource).STANDALONE : (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                    contentTypesCommentService: commentService,
                    userId: userId,
                    displayName: displayName
                });
            },
            onContentChange: onChange,
            onContentChangeWithData: handleContentChangeWithData,
            onEditorReady: editorChangeHandler,
            commentMode: "reply",
            commentType: commentType === (0, $8i27m.CommentType).GENERAL ? 'page' : 'inline',
            spaceId: "",
            showCancelButton: true,
            useNewWarningModal: true,
            hideWatchCheckbox: true,
            expandEditor: expandReplyEditor,
            pageMode: "view",
            hasMediaUploadPermissions: hasMediaUploadPermissions,
            topLevelCommentId: parentComment.id,
            shouldWarnOnInternalNavigation: true,
            onCancelComment: ({ destroy: destroy = false } = {})=>{
                // when the transition happens the
                // other reply list item is clicked
                // and we need to reset ssetReplyToCommentId
                if (!destroy || replyToCommentId !== parentCommentId) setReplyToCommentId();
            },
            isCommentsPanel: true,
            wasRemovedByAnotherUser: parentComment.wasRemovedByAnotherUser,
            isOffline: isOffline
        });
        const editorWithFyi = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (showFyi || hasShownFyiRef.current) && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4rKYp.AgentMentionFyiNudgeAsync), {
            visible: showFyi,
            agent: agent
        }), editor);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.NewReplyContainer), {
            mode: "view",
            isCommentsPanel: true,
            isFabricPage: true,
            "data-testid": "comments-panel-new-reply-container"
        }, (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? editorWithFyi : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
            showDefaultStyles: true,
            customStyles: $ff4f83a3b963012b$var$commentEditorCustomStyles
        }, editorWithFyi));
    };
    const renderUpdatedLowerAction = ()=>{
        if (expandReplyEditor) return renderCommentEditor();
        else if (!isStandaloneComment) return renderReplyButton();
        else return null;
    }; // Make reply containers tabbable for accessibility
    (0, $42omo.useEffect)(()=>{
        if (visibleReplies && visibleReplies.length > 0) // Find all reply containers and make them tabbable
        visibleReplies.forEach((reply)=>{
            const replyContainer = document.querySelector(`[data-testid="comment-thread-${parentComment.id}-replies-${reply.id}"]`);
            if (replyContainer instanceof HTMLElement) replyContainer.setAttribute('tabIndex', '0');
        });
    }, [
        visibleReplies,
        parentComment.id
    ]);
    const renderRepliesToggler = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $58Zuw.RepliesToggler), {
            replies: allReplies,
            unreadReplyIds: unreadReplyIds,
            setReplyView: setReplyView,
            currentReplyView: currentReplyView,
            commentType: commentType,
            parentCommentId: parentCommentId,
            isParentOpen: isParentCommentOpen,
            canAddComments: canAddComments,
            latestReplyIds: latestReplyIds,
            isStandaloneComment: isStandaloneComment,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            analyticsSource: isStandaloneComment ? (0, $en1dX.AnalyticsSource).STANDALONE : (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
            expandReplyEditor: expandReplyEditor
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, numOfReplies > 0 && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && renderRepliesToggler(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": `comment-thread-${parentComment.id}-replies`,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _19bvpxbi _u5f3u2gc",
            (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_19bvutpp",
            parentComment.wasRemovedByAnotherUser && "_tzy41ssb",
            isStandaloneComment && "_u5f3pxbi",
            isStandaloneComment && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_u5f3utpp"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, numOfReplies > 0 && !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && renderRepliesToggler(), visibleReplies && visibleReplies.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": `comment-thread-${parentComment.id}-reply-list`
    }, visibleReplies.map((reply, idx)=>{
        const isLastUnnestableReply = idx === visibleReplies.length - 1; // Keep the connector line visible when this reply has an agent-session status
        // row below it. Gate inlined, ordered last per feature-gating rules.
        const replyHasAgentSession = Boolean(agentSessions.get(reply.id)) && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            key: `comment-thread-${parentComment.id}-replies-${idx}`,
            "data-testid": `comment-thread-${parentComment.id}-replies-${reply.id}`,
            onMouseEnter: ()=>handleMouseEnter(reply.id),
            onMouseLeave: handleMouseLeave,
            onFocus: (event)=>handleFocus(event, reply.id),
            onBlur: handleBlur,
            "aria-label": formatMessage($ff4f83a3b963012b$var$i18n.replyAriaLabel, {
                authorName: reply.author?.displayName || formatMessage((0, $3ejfs.commentsi18n).anonymous),
                timestamp: (0, $6faGq.formatTimestampForAriaLabel)({
                    intl: intl,
                    dateString: reply.createdAtNonLocalized,
                    isReply: true
                })
            }),
            className: (0, $gMc0m.default)([
                "_qtt8glyw _kqswh2mm _ca0qu2gc _n3tdu2gc _19bv1ejb",
                "_ca0qze3t _19bvze3t _n3tdze3t"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9tfnI.Comment), {
            flags: flags,
            comment: reply,
            supportedTopLevelActions: supportedTopLevelActions,
            hideReactions: hideReactions,
            pageInfo: pageInfo,
            pageMode: pageMode,
            isUnread: unreadCommentIDSet.has(reply.id),
            isHovered: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? false : hoveredCommentId === reply.id || commentIsFocused === reply.id,
            threadKey: threadKey,
            // but keep them when the reply has an agent-session row so the line reaches it.
            hideBranchingStyle: !replyHasAgentSession && (!canAddComments && isLastUnnestableReply || isStandaloneComment && isLastUnnestableReply || isLastUnnestableReply && !expandReplyEditor && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true)),
            adjustForNestedReplies: commentType === (0, $8i27m.CommentType).GENERAL && reply.id in topLevelReplyToNestedChildrenMap && topLevelReplyToNestedChildrenMap[reply.id]?.length > 0,
            canAddComments: canAddComments,
            isParentCommentOpen: isParentCommentOpen,
            deleteStandaloneComment: deleteStandaloneComment,
            isStandaloneComment: isStandaloneComment,
            replyToComment: replyToComment,
            updateReactionsCacheFn: updateReactionsCacheFn,
            onRendered: onRendered,
            isLastUnnestableReply: isLastUnnestableReply,
            isReplyEditorOpen: expandReplyEditor,
            commentHandlesPadding: true,
            hasParentMaxHeight: hasParentMaxHeight
        }), commentType === (0, $8i27m.CommentType).GENERAL && reply.id in topLevelReplyToNestedChildrenMap && topLevelReplyToNestedChildrenMap[reply.id]?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2e558da207609fcd$export$a0769df2292690a8), {
            nestedReplies: topLevelReplyToNestedChildrenMap[reply.id],
            unreadReplyIds: unreadReplyIds,
            targetCommentIdForScroll: reply.id,
            isLastUnnestableReply: isLastUnnestableReply
        }));
    }))), (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lLpk8.RepliesFooter), {
        replyView: currentReplyView,
        setReplyView: setReplyView,
        isEditorExpanded: !isCommentSummaryPopup && isEditorExpanded,
        isParentCommentOpen: isParentCommentOpen,
        isStandaloneComment: isStandaloneComment,
        handleReplyButtonClick: handleReplyButtonClick,
        numOfVisibleReplies: visibleReplies ? visibleReplies.length : 0,
        isOffline: isOffline,
        scrollToId: threadKey,
        location: (0, $i6UMJ.LocationValue).PANEL
    }, renderCommentEditor()) : renderUpdatedLowerAction()));
};
const $ff4f83a3b963012b$export$c38311e545a763a = /*#__PURE__*/ (0, $42omo.memo)($ff4f83a3b963012b$var$CommentRepliesComponent, (0, $b5IrT.arePropsShallowEqualWhenMemoRowsEnabled));
module.exports["CommentReplies"] = $ff4f83a3b963012b$export$c38311e545a763a;

});

parcelRegister("1Sjzs", function(module, exports) {
/* WithCurvedBranchingStyle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");

'use no memo';
const $182916127499e17b$var$replyBranchStyles = null;
const $182916127499e17b$var$replyBranchStylesUpdated = null;
const $182916127499e17b$export$855243800ee94bad = ({ showDefaultStyles: showDefaultStyles, children: children, customStyles: customStyles, onClick: onClick, testId: testId, disableLeftProp: disableLeftProp })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...(()=>{
                const { height: height, left: left, ...rest } = customStyles || {};
                return rest;
            })(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customStyles?.height && {
                '--customHeight': customStyles.height
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customStyles?.left ? {
                '--customBeforeLeft': customStyles.left
            } : {
                '--customBeforeLeft': disableLeftProp ? '0px' : '-24px'
            }
        },
        onClick: onClick,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            showDefaultStyles && "_kqswh2mm _1n1j11qs _4k1c11qs _1kt9b3bt _1cs8stnw _qnec1gkm _1aukidpf _1mp41skh _kfgt1pfq _fik81mok",
            showDefaultStyles && (0, $9wGTI.fg)('confluence_comment_border_migration') && "_kqswh2mm _1n1j1h4i _4k1c1h4i _1kt9b3bt _1cs8stnw _qnec1gkm _1aukidpf _1mp41skh _kfgt1pfq _fik81mok"
        ])
    }, children);
};
module.exports["WithCurvedBranchingStyle"] = $182916127499e17b$export$855243800ee94bad;

});

parcelRegister("58Zuw", function(module, exports) {
/* RepliesToggler.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $2W0qg = parcelRequire("2W0qg");


var $ecnYn = parcelRequire("ecnYn");


var $5dK2X = parcelRequire("5dK2X");


var $bUlM5 = parcelRequire("bUlM5");


var $6f0Oj = parcelRequire("6f0Oj");


var $2Pg7f = parcelRequire("2Pg7f");


var $ccHMk = parcelRequire("ccHMk");


var $liGyh = parcelRequire("liGyh");


var $1Sjzs = parcelRequire("1Sjzs");


var $dPJCf = parcelRequire("dPJCf");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $ibqdE = parcelRequire("ibqdE");

/* RepliesTogglerButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $lFPm8 = parcelRequire("lFPm8");





var $u9agA = parcelRequire("u9agA");


var $fVUfS = parcelRequire("fVUfS");


var $iXCQx = parcelRequire("iXCQx");


var $gdv5Z = parcelRequire("gdv5Z");







const $fd1a9a414507ab5d$var$styles = {
    dot: "_2rko1rr0 _18s81b66 _4t3iftgi _1bsbftgi _bfhk1856",
    pressableContainer: "_18u0pxbi _19bvu2gc",
    pressableContainerWithBranch: "_18u0pxbi _19bvu2gc _kqswh2mm _1n1j1h4i _1kt9b3bt _1cs8stnw _kfgt1osq _qnecidpf",
    pressableWithBranch: "_2rko12b0 _1bsb1osq _syazazsu _bfhksm61 _ca0qu2gc _n3tdu2gc _19bvu2gc _u5f3ze3t _uiztglyw _k48p1wq8 _d0altlke _irr31dpa _1di6fcek",
    pressable: "_2rko12b0 _1bsb1osq _syazazsu _bfhksm61 _ca0qu2gc _n3tdu2gc _19bvze3t _u5f3ze3t _uiztglyw _k48p1wq8 _d0altlke _irr31dpa _1di6fcek",
    icon: "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _1ltvt94y"
};
const $fd1a9a414507ab5d$var$SHOW_HIDDEN_REPLIES = 'show-hidden-replies';
const $fd1a9a414507ab5d$var$RepliesTogglerButtonContent = ({ showHiddenReplies: showHiddenReplies, hiddenReplies: hiddenReplies, hasHiddenUnreadReplies: hasHiddenUnreadReplies, analyticsContext: analyticsContext, message: message, children: icon, isBranchHidden: isBranchHidden })=>{
    const profilePicturesHiddenReplies = (0, $42omo.useMemo)(()=>(0, $ibqdE.getProfilePicturesOfHiddenReplies)(hiddenReplies), [
        hiddenReplies
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        onClick: showHiddenReplies,
        xcss: isBranchHidden ? $fd1a9a414507ab5d$var$styles.pressable : $fd1a9a414507ab5d$var$styles.pressableWithBranch,
        analyticsContext: analyticsContext,
        testId: $fd1a9a414507ab5d$var$SHOW_HIDDEN_REPLIES,
        interactionName: $fd1a9a414507ab5d$var$SHOW_HIDDEN_REPLIES
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100"
    }, isBranchHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $fd1a9a414507ab5d$var$styles.icon,
        testId: "icon--grow-vertical"
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
        onMoreClick: ()=>{},
        data: profilePicturesHiddenReplies.map(({ displayName: displayName, profilePicturePath: profilePicturePath })=>({
                name: displayName,
                src: profilePicturePath
            })),
        maxCount: 3,
        appearance: "stack",
        size: "small",
        shouldPopupRenderToParent: true,
        testId: "replies-toggler-profile-pictures"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle",
        weight: "medium"
    }, message)), hasHiddenUnreadReplies && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $fd1a9a414507ab5d$var$styles.dot,
        testId: "unread-comment-replies-indicator"
    })));
};
const $fd1a9a414507ab5d$var$curvedBranchCustomStyles = {
    height: "var(--ds-space-300, 24px)",
    left: "var(--ds-space-negative-150, -12px)"
};
const $fd1a9a414507ab5d$export$3b601073833f0b61 = ({ hiddenReplies: hiddenReplies, showHiddenReplies: showHiddenReplies, hasHiddenUnreadReplies: hasHiddenUnreadReplies, analyticsContext: analyticsContext, message: message, isHiddenReplyView: isHiddenReplyView, expandReplyEditor: expandReplyEditor })=>{
    const isBranchHidden = !isHiddenReplyView || isHiddenReplyView && expandReplyEditor;
    const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fd1a9a414507ab5d$var$RepliesTogglerButtonContent, {
        isBranchHidden: isBranchHidden,
        hiddenReplies: hiddenReplies,
        showHiddenReplies: showHiddenReplies,
        hasHiddenUnreadReplies: hasHiddenUnreadReplies,
        analyticsContext: analyticsContext,
        message: message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lFPm8))), {
        label: ""
    }));
    return isBranchHidden ? buttonContent : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: "curved-branching-wrapper",
        xcss: expandReplyEditor ? $fd1a9a414507ab5d$var$styles.pressableContainerWithBranch : $fd1a9a414507ab5d$var$styles.pressableContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
        showDefaultStyles: true,
        customStyles: $fd1a9a414507ab5d$var$curvedBranchCustomStyles
    }, buttonContent));
};


const $98ec5da5f93a34eb$var$repliesTogglerStyles = {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    height: '24px',
    paddingTop: "var(--ds-space-100, 8px)",
    paddingBottom: "var(--ds-space-100, 8px)",
    left: 0
};
const $98ec5da5f93a34eb$var$repliesTogglerBranchingStyle = null;
const $98ec5da5f93a34eb$var$repliesTogglerBranchingStyleUpdated = null;
const $98ec5da5f93a34eb$var$replyBranchUnsetHeight = null;
const $98ec5da5f93a34eb$var$repliesTogglerBranchingStyleWithoutReply = null;
const $98ec5da5f93a34eb$var$unreadIndicatorStyle = (0, $ecnYn.xcss)({
    alignItems: 'center',
    gap: 'space.075'
});
const $98ec5da5f93a34eb$var$pressableStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle',
    backgroundColor: 'color.background.neutral.subtle',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    borderRadius: 'radius.small',
    userSelect: 'none',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    ':hover': {
        cursor: 'pointer',
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
}); // This snippet is being used in CommentBody.tsx
const $98ec5da5f93a34eb$var$dotStyles = null;
const $98ec5da5f93a34eb$var$i18n = (0, $aXWIB.defineMessages)({
    hideRepliesText: {
        id: "comments-common.comment-thread.hide.replies",
        defaultMessage: "Hide replies"
    },
    hideReplyText: {
        id: "comments-common.comment-thread.hide.reply",
        defaultMessage: "Hide reply"
    },
    showMoreRepliesText: {
        id: "comments-common.comment-thread.show.more.replies",
        defaultMessage: "Show {numOfHiddenReplies, plural, one {# more reply} other {# more replies}}"
    },
    showMoreRepliesTextForStandalone: {
        id: "comments-common.comment-thread.show.more.replies.for.standalone",
        defaultMessage: "{numOfHiddenReplies, plural, one {# more reply} other {# more replies}}"
    },
    showReplyText: {
        id: "comments-common.comment-thread.show.reply",
        defaultMessage: "Show reply"
    }
});
const $98ec5da5f93a34eb$var$withLeftMargin = null;
const $98ec5da5f93a34eb$var$MAX_PROFILE_PICTURES_TO_SHOW = 3;
const $98ec5da5f93a34eb$var$getFormattedShowReplyMessage = ({ repliesLength: repliesLength, isStandaloneComment: isStandaloneComment, numOfHiddenReplies: numOfHiddenReplies, formatMessage: formatMessage })=>{
    if (repliesLength === 1) return formatMessage($98ec5da5f93a34eb$var$i18n.showReplyText);
    return formatMessage(isStandaloneComment ? $98ec5da5f93a34eb$var$i18n.showMoreRepliesTextForStandalone : $98ec5da5f93a34eb$var$i18n.showMoreRepliesText, {
        numOfHiddenReplies: numOfHiddenReplies
    });
};
const $98ec5da5f93a34eb$var$getAnalyticsContext = ({ analyticsSource: analyticsSource, commentType: commentType, replies: replies, hasHiddenUnreadReplies: hasHiddenUnreadReplies, currentNumOfHiddenReplies: currentNumOfHiddenReplies, shouldShowShowMoreRepliesToggle: shouldShowShowMoreRepliesToggle })=>({
        attributes: shouldShowShowMoreRepliesToggle ? {
            name: 'repliesToggler',
            source: analyticsSource,
            commentType: commentType,
            hasHiddenUnreadReplies: hasHiddenUnreadReplies,
            numOfHiddenReplies: currentNumOfHiddenReplies,
            numOfReplies: replies.length
        } : {
            attributes: {
                name: 'hideReplies',
                source: analyticsSource,
                commentType: commentType,
                numOfReplies: replies.length
            }
        }
    });
const $98ec5da5f93a34eb$var$useFocusedCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedCommentId');
const $98ec5da5f93a34eb$var$useReplyToCommentQueryParam = (0, $dPJCf.createSingleQueryParamHook)('replyToComment');
const $98ec5da5f93a34eb$export$fa25a7ffef408bc8 = ({ replies: replies, unreadReplyIds: unreadReplyIds, setReplyView: setReplyView, currentReplyView: currentReplyView, commentType: commentType, parentCommentId: parentCommentId, isParentOpen: isParentOpen, canAddComments: canAddComments, latestReplyIds: latestReplyIds, isStandaloneComment: isStandaloneComment = false, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, analyticsSource: analyticsSource, expandReplyEditor: expandReplyEditor })=>{
    const focusedCommentId = $98ec5da5f93a34eb$var$useFocusedCommentIdQueryParam();
    const replyToComment = $98ec5da5f93a34eb$var$useReplyToCommentQueryParam();
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    (0, $42omo.useEffect)(()=>{
        // used to expand all replies of standalone comment
        const targetCommentId = focusedCommentId || replyToComment;
        if (targetCommentId) {
            // to check if the queryParam is parentCommentId or not
            const isReplyToCommentInChain = replies?.map((reply)=>reply?.id)?.includes(targetCommentId);
            if (isReplyToCommentInChain) setReplyView((0, $ibqdE.ViewReplyOptions).ALL);
        }
    }, [
        focusedCommentId,
        replyToComment,
        setReplyView,
        replies
    ]); // Memoize hidden replies calculation since it's used in multiple places
    const hiddenReplies = (0, $42omo.useMemo)(()=>{
        // If all replies are hidden due to current view, return all replies
        if (currentReplyView === (0, $ibqdE.ViewReplyOptions).HIDDEN) return replies;
         // Otherwise, use the default hidden replies logic
        return (0, $ibqdE.getDefaultHiddenReplies)({
            replies: replies,
            isParentOpen: isParentOpen,
            latestReplyIds: latestReplyIds
        });
    }, [
        replies,
        isParentOpen,
        latestReplyIds,
        currentReplyView
    ]); // for the unread indicator, we only want to render it if there are any hidden unread
    const hasHiddenUnreadReplies = (0, $42omo.useMemo)(()=>{
        const hiddenReplyIds = new Set(hiddenReplies.map((reply)=>reply.id));
        return unreadReplyIds.some((replyId)=>hiddenReplyIds.has(replyId));
    }, [
        unreadReplyIds,
        hiddenReplies
    ]);
    const currentNumOfHiddenReplies = (0, $ibqdE.getNumOfHiddenReplies)({
        replies: replies,
        latestReplyIds: latestReplyIds,
        currentReplyView: currentReplyView
    });
    const shouldShowShowMoreRepliesToggle = currentNumOfHiddenReplies > 0;
    const shouldShowProfilePictures = currentReplyView !== (0, $ibqdE.ViewReplyOptions).ALL && shouldShowShowMoreRepliesToggle;
    const shouldShowShortenedBranchStyles = !isParentOpen && shouldShowShowMoreRepliesToggle;
    const profilePicturesHiddenReplies = (0, $42omo.useRef)(shouldShowProfilePictures ? (0, $ibqdE.getProfilePicturesOfHiddenReplies)(hiddenReplies) : []);
    const showHiddenReplies = (0, $42omo.useCallback)((event)=>{
        event.stopPropagation();
        setReplyView((0, $ibqdE.ViewReplyOptions).ALL);
        (focusedCommentId || replyToComment) && removeCommentQueryParams();
        profilePicturesHiddenReplies.current = [];
    }, [
        setReplyView,
        focusedCommentId,
        replyToComment,
        removeCommentQueryParams
    ]);
    const hideReplies = (0, $42omo.useCallback)((event)=>{
        event.stopPropagation(); // remove the queryParams if it exists
        (focusedCommentId || replyToComment) && removeCommentQueryParams();
        setReplyView((0, $ibqdE.ViewReplyOptions).HIDDEN); // all replies will be considered
        profilePicturesHiddenReplies.current = (0, $ibqdE.getProfilePicturesOfHiddenReplies)(replies);
    }, [
        replies,
        setReplyView,
        focusedCommentId,
        replyToComment,
        removeCommentQueryParams
    ]);
    if ((0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true)) {
        if (!shouldShowShowMoreRepliesToggle) return null;
    }
    const formattedShowReplyMessage = $98ec5da5f93a34eb$var$getFormattedShowReplyMessage({
        repliesLength: replies.length,
        isStandaloneComment: isStandaloneComment,
        numOfHiddenReplies: currentNumOfHiddenReplies,
        formatMessage: formatMessage
    });
    const analyticsContext = $98ec5da5f93a34eb$var$getAnalyticsContext({
        analyticsSource: analyticsSource,
        commentType: commentType,
        replies: replies,
        hasHiddenUnreadReplies: hasHiddenUnreadReplies,
        currentNumOfHiddenReplies: currentNumOfHiddenReplies,
        shouldShowShowMoreRepliesToggle: shouldShowShowMoreRepliesToggle
    });
    return (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "replies-toggler-container",
        onMouseEnter: ()=>onMouseEnter(parentCommentId),
        onMouseLeave: ()=>onMouseLeave()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fd1a9a414507ab5d$export$3b601073833f0b61), {
        hiddenReplies: hiddenReplies,
        message: formattedShowReplyMessage,
        showHiddenReplies: showHiddenReplies,
        hasHiddenUnreadReplies: hasHiddenUnreadReplies,
        analyticsContext: analyticsContext,
        isHiddenReplyView: currentReplyView === (0, $ibqdE.ViewReplyOptions).HIDDEN,
        expandReplyEditor: expandReplyEditor
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // handles making sure we keep correct highlight state when mousing over this
    , {
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseEnter: ()=>onMouseEnter(parentCommentId),
        onMouseLeave: ()=>onMouseLeave(),
        className: (0, $gMc0m.default)([
            replies.length > 0 && (canAddComments || currentNumOfHiddenReplies === 0) && "_kqswh2mm _1n1j11qs _1kt9b3bt _1cs8stnw _qnecidpf _1aukidpf _kfgt1wqb",
            replies.length > 0 && (canAddComments || currentNumOfHiddenReplies === 0) && (0, $9wGTI.fg)('confluence_comment_border_migration') && "_kqswh2mm _1n1j1h4i _1kt9b3bt _1cs8stnw _qnecidpf _1aukidpf _kfgt1wqb",
            replies.length > 0 && shouldShowShortenedBranchStyles && "_kfgtgktf",
            replies.length > 0 && currentReplyView === (0, $ibqdE.ViewReplyOptions).HIDDEN && isStandaloneComment && "_kfgtn7od"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
        testId: "replies-toggler-container",
        showDefaultStyles: replies.length > 0,
        disableLeftProp: true,
        customStyles: $98ec5da5f93a34eb$var$repliesTogglerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_18u0utpp"
        ])
    }, shouldShowShowMoreRepliesToggle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        onClick: showHiddenReplies,
        testId: "show-hidden-replies",
        analyticsContext: analyticsContext,
        xcss: $98ec5da5f93a34eb$var$pressableStyles,
        interactionName: "show-hidden-replies"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: isStandaloneComment ? 'space.150' : 'space.050'
    }, shouldShowProfilePictures && profilePicturesHiddenReplies.current.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
        data: profilePicturesHiddenReplies.current.map((profilePicturesInfo)=>({
                name: profilePicturesInfo.displayName,
                src: profilePicturesInfo.profilePicturePath
            })),
        maxCount: $98ec5da5f93a34eb$var$MAX_PROFILE_PICTURES_TO_SHOW,
        appearance: "stack",
        size: "small",
        shouldPopupRenderToParent: true,
        testId: "replies-toggler-profile-pictures"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: $98ec5da5f93a34eb$var$unreadIndicatorStyle
    }, formattedShowReplyMessage, hasHiddenUnreadReplies && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "unread-comment-replies-indicator",
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _18s81b66 _4t3iu2gc _1bsbu2gc _bfhk1856"
        ])
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: hideReplies,
        testId: "hide-replies",
        appearance: "subtle",
        analyticsContext: analyticsContext,
        interactionName: "hide-replies"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text",
        size: "medium",
        weight: "medium"
    }, replies.length === 1 ? formatMessage($98ec5da5f93a34eb$var$i18n.hideReplyText) : formatMessage($98ec5da5f93a34eb$var$i18n.hideRepliesText)))))));
};
module.exports["RepliesToggler"] = $98ec5da5f93a34eb$export$fa25a7ffef408bc8;

});

parcelRegister("lLpk8", function(module, exports) {
/* RepliesFooter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $1s5hv = parcelRequire("1s5hv");


var $dANtQ = parcelRequire("dANtQ");


var $ep3mz = parcelRequire("ep3mz");


var $ibqdE = parcelRequire("ibqdE");

/* RepliesFooterEditor.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gdv5Z = parcelRequire("gdv5Z");


var $bQm3c = parcelRequire("bQm3c");


var $daq5m = parcelRequire("daq5m");


var $1Sjzs = parcelRequire("1Sjzs");

const $871c7d18e1ea278e$var$styles = {
    editorContainer: "_1bsb1osq _19bv1b66",
    commentAuthorContainer: "_19bv1b66 _ca0qu2gc"
};
const $871c7d18e1ea278e$var$customCurvedBranchingStyles = {
    height: "var(--ds-space-300, 24px)",
    left: "var(--ds-space-negative-200, -16px)"
};
const $871c7d18e1ea278e$export$2df4c5a1d76b6715 = ({ children: replyEditor })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
        showDefaultStyles: true,
        customStyles: $871c7d18e1ea278e$var$customCurvedBranchingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $871c7d18e1ea278e$var$styles.commentAuthorContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $daq5m.CommentAuthor), {
        size: "small",
        commentMode: "create",
        userId: userId
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: "reply-editor-container",
        xcss: $871c7d18e1ea278e$var$styles.editorContainer
    }, replyEditor));
};






var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $jPqj0 = parcelRequire("jPqj0");


var $9FoVw = parcelRequire("9FoVw");


var $i6UMJ = parcelRequire("i6UMJ");


var $5U5Co = parcelRequire("5U5Co");




const $61a1d78c6ff19498$var$messages = (0, $aXWIB.defineMessages)({
    hideReplies: {
        id: "comments-common.comments.replies.footer.hideReplies",
        defaultMessage: "{numOfVisibleReplies, plural, one {Hide reply} other {Hide replies}}"
    }
});
const $61a1d78c6ff19498$export$b27fc6926daa79f5 = ({ isHideRepliesToggleVisible: isHideRepliesToggleVisible, isReplyButtonVisible: isReplyButtonVisible, numOfVisibleReplies: numOfVisibleReplies, location: location, scrollToId: scrollToId, setReplyView: setReplyView, isOffline: isOffline, handleReplyButtonClick: handleReplyButtonClick })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const handleHideRepliesToggleClick = async (event)=>{
        event.stopPropagation();
        if (location === (0, $i6UMJ.LocationValue).FOOTER) await (0, $9FoVw.handleFooterCommentsNavigation)({
            inline: 'start',
            block: 'start',
            commentId: scrollToId,
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            shouldScrollIfCommentIsInViewport: false,
            awaitScrollCompletion: true
        });
        else await (0, $9FoVw.handleCommentsPanelNavigation)({
            block: 'start',
            annotationId: scrollToId,
            context: (0, $9FoVw.NavigationContext).PANEL,
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            shouldScrollIfCommentIsInViewport: false,
            awaitScrollCompletion: true
        });
        // Hide replies regardless of scroll completion status
        // The scroll may not complete in test environments, but we still want to hide replies
        setReplyView((0, $ibqdE.ViewReplyOptions).HIDDEN);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isReplyButtonVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5U5Co.ReplyButton), {
        handleReplyButtonClick: handleReplyButtonClick,
        isOffline: isOffline
    }), isHideRepliesToggleVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($jPqj0))),
        onClick: handleHideRepliesToggleClick
    }, formatMessage($61a1d78c6ff19498$var$messages.hideReplies, {
        numOfVisibleReplies: numOfVisibleReplies
    })));
};


const $56737fe079f60a2e$var$styles = {
    repliesFooter: "_1bahesu3 _19bvpxbi",
    repliesFooterSpaceBetween: "_1bah1yb4 _19bv1ejb"
};
const $56737fe079f60a2e$export$5b80eae1c1e011bf = ({ replyView: replyView, setReplyView: setReplyView, isEditorExpanded: isEditorExpanded, numOfVisibleReplies: numOfVisibleReplies, isParentCommentOpen: isParentCommentOpen, children: replyEditor, handleReplyButtonClick: handleReplyButtonClick, scrollToId: scrollToId, location: location, isStandaloneComment: isStandaloneComment = false, isOffline: isOffline = false })=>{
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId, true);
    const isReplyButtonVisible = !isEditorExpanded && canAddComments && isParentCommentOpen && !isStandaloneComment;
    const isHideRepliesToggleVisible = !isStandaloneComment && replyView !== (0, $ibqdE.ViewReplyOptions).HIDDEN && numOfVisibleReplies > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        testId: "replies-footer",
        xcss: isReplyButtonVisible ? $56737fe079f60a2e$var$styles.repliesFooterSpaceBetween : $56737fe079f60a2e$var$styles.repliesFooter,
        gap: isEditorExpanded ? 'space.100' : 'space.0',
        direction: isEditorExpanded ? 'column' : 'row',
        alignItems: isEditorExpanded ? 'start' : 'center'
    }, isEditorExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $871c7d18e1ea278e$export$2df4c5a1d76b6715), null, replyEditor) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $61a1d78c6ff19498$export$b27fc6926daa79f5), {
        isHideRepliesToggleVisible: isHideRepliesToggleVisible,
        isReplyButtonVisible: isReplyButtonVisible,
        numOfVisibleReplies: numOfVisibleReplies,
        location: location,
        scrollToId: scrollToId,
        setReplyView: setReplyView,
        isOffline: isOffline,
        handleReplyButtonClick: handleReplyButtonClick
    }));
};
module.exports["RepliesFooter"] = $56737fe079f60a2e$export$5b80eae1c1e011bf;

});

parcelRegister("8gR6k", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3mVfX = parcelRequire("3mVfX");


var $ibqdE = parcelRequire("ibqdE");

const $020512e6fc7b9101$export$b1d0bdb48de923ea = ({ allReplies: allReplies, isParentCommentOpen: isParentCommentOpen, currentReplyView: currentReplyView, latestReplies: latestReplies, parentCommentId: parentCommentId, setVisibleReplies: setVisibleReplies, allowNestedReplies: allowNestedReplies = false })=>{
    const { currentView: currentView } = (0, $3mVfX.useCommentsPanelState)();
    (0, $42omo.useLayoutEffect)(()=>{
        (0, $ibqdE.updateVisibleReplies)({
            parentCommentId: parentCommentId,
            currentReplyView: currentReplyView,
            setVisibleReplies: setVisibleReplies,
            allReplies: allReplies,
            isParentCommentOpen: isParentCommentOpen,
            latestReplies: latestReplies,
            currentView: currentView,
            allowNestedReplies: allowNestedReplies
        });
    }, [
        allReplies,
        currentReplyView,
        isParentCommentOpen,
        latestReplies,
        parentCommentId,
        setVisibleReplies,
        currentView,
        allowNestedReplies
    ]);
};
module.exports["useUpdateVisibleReplies"] = $020512e6fc7b9101$export$b1d0bdb48de923ea;

});

parcelRegister("jVIRU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3mVfX = parcelRequire("3mVfX");


var $ibqdE = parcelRequire("ibqdE");

const $9e3ef994fae6be13$export$1519d63e8a4143ae = ({ allReplies: allReplies, isParentCommentOpen: isParentCommentOpen, currentReplyView: currentReplyView, latestReplies: latestReplies, parentCommentId: parentCommentId, allowNestedReplies: allowNestedReplies = false })=>{
    const { currentView: currentView } = (0, $3mVfX.useCommentsPanelState)();
    return (0, $42omo.useMemo)(()=>(0, $ibqdE.computeVisibleReplies)({
            parentCommentId: parentCommentId,
            currentReplyView: currentReplyView,
            allReplies: allReplies,
            isParentCommentOpen: isParentCommentOpen,
            latestReplies: latestReplies,
            currentView: currentView,
            allowNestedReplies: allowNestedReplies
        }), [
        allReplies,
        currentReplyView,
        isParentCommentOpen,
        latestReplies,
        parentCommentId,
        currentView,
        allowNestedReplies
    ]);
};
module.exports["useVisibleReplies"] = $9e3ef994fae6be13$export$1519d63e8a4143ae;

});

parcelRegister("9tfnI", function(module, exports) {
/**
 * @generated SignedSource<<2d9e6d031407fc73dc5b5c8f76068559>>
 * @relayHash 7aa392ac24b60ca30af878bca1c734bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7732d40cfe8a07c6480c6fa88698f2b50d6f208bd2caeb687fa3bafbe1f452fd
const $eaa0b5bea1a46072$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentIdToDelete"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "deleteFrom"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentIdToDelete",
                    "variableName": "commentIdToDelete"
                },
                {
                    "kind": "Variable",
                    "name": "deleteFrom",
                    "variableName": "deleteFrom"
                }
            ],
            "kind": "ScalarField",
            "name": "deleteComment"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentDeleteGeneralCommentMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentDeleteGeneralCommentMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7aa392ac24b60ca30af878bca1c734bb",
            "id": "7732d40cfe8a07c6480c6fa88698f2b50d6f208bd2caeb687fa3bafbe1f452fd",
            "metadata": {},
            "name": "CommentDeleteGeneralCommentMutation",
            "operationKind": "mutation",
            "text": "mutation CommentDeleteGeneralCommentMutation($commentIdToDelete:ID!,$deleteFrom:CommentDeletionLocation){deleteComment(commentIdToDelete:$commentIdToDelete,deleteFrom:$deleteFrom)}"
        }
    };
}();
$eaa0b5bea1a46072$var$node.hash = "21ca12d96d4a730277a95bbc05c15c9c";
var $eaa0b5bea1a46072$export$2e2bcd8739ae039 = $eaa0b5bea1a46072$var$node;


/**
 * @generated SignedSource<<cbd10082d704d33e1a3e9502fb713d24>>
 * @relayHash 89c9c6606c3cc7f9e98c234f63e138f9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 53dad722b9392cc0d8fb000b7813f8dc5b4c5bbea45d2a785e57afe7c6db80c4
const $2ae18362ec7f1758$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentIdToDelete"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "deleteFrom"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentIdToDelete",
                    "variableName": "commentIdToDelete"
                },
                {
                    "kind": "Variable",
                    "name": "deleteFrom",
                    "variableName": "deleteFrom"
                }
            ],
            "kind": "ScalarField",
            "name": "deleteComment"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentDeleteInlineCommentMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentDeleteInlineCommentMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "89c9c6606c3cc7f9e98c234f63e138f9",
            "id": "53dad722b9392cc0d8fb000b7813f8dc5b4c5bbea45d2a785e57afe7c6db80c4",
            "metadata": {},
            "name": "CommentDeleteInlineCommentMutation",
            "operationKind": "mutation",
            "text": "mutation CommentDeleteInlineCommentMutation($commentIdToDelete:ID!,$deleteFrom:CommentDeletionLocation){deleteComment(commentIdToDelete:$commentIdToDelete,deleteFrom:$deleteFrom)}"
        }
    };
}();
$2ae18362ec7f1758$var$node.hash = "985100db430c5b7c44c5f1e2701cbfdc";
var $2ae18362ec7f1758$export$2e2bcd8739ae039 = $2ae18362ec7f1758$var$node;


/**
 * @generated SignedSource<<f367743e7ed7efb54a38311904e05114>>
 * @relayHash 8e5e866c8ce8d1cb963ef62edd739b94
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 18a27afe1a8aa48e2b295eb57b00b2804ec99dd028f5aa61b14ebdb521b94793
const $cd762cea5f448981$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "kind": "ScalarField",
            "name": "deleteInlineComment"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentDeleteInlineCommentMutationWithStepMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentDeleteInlineCommentMutationWithStepMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8e5e866c8ce8d1cb963ef62edd739b94",
            "id": "18a27afe1a8aa48e2b295eb57b00b2804ec99dd028f5aa61b14ebdb521b94793",
            "metadata": {},
            "name": "CommentDeleteInlineCommentMutationWithStepMutation",
            "operationKind": "mutation",
            "text": "mutation CommentDeleteInlineCommentMutationWithStepMutation($input:DeleteInlineCommentInput!){deleteInlineComment(input:$input)}"
        }
    };
}();
$cd762cea5f448981$var$node.hash = "8bc2a29aa8ca1e95a28cad450493e297";
var $cd762cea5f448981$export$2e2bcd8739ae039 = $cd762cea5f448981$var$node;


/**
 * @generated SignedSource<<84ea32fc28668aada6e062d8a372be42>>
 * @relayHash b166cb02008e1ced909e66efb1618724
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7f20db408527e12b3b82266fb8dbd13b035a569d68a64e5fcf9e00d7df264ab4
const $6afe964f7c8584f2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "concreteType": "ConfluenceCommentResolutionState",
        "kind": "LinkedField",
        "name": "commentResolutionStates",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "commentId"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "errorType"
            },
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ],
        "type": "ReopenCommentsMutationErrorExtension"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CommentReopenCommentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceReopenCommentPayload",
                    "kind": "LinkedField",
                    "name": "confluence_reopenComment",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CommentReopenCommentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceReopenCommentPayload",
                    "kind": "LinkedField",
                    "name": "confluence_reopenComment",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b166cb02008e1ced909e66efb1618724",
            "id": "7f20db408527e12b3b82266fb8dbd13b035a569d68a64e5fcf9e00d7df264ab4",
            "metadata": {},
            "name": "CommentReopenCommentMutation",
            "operationKind": "mutation",
            "text": "mutation CommentReopenCommentMutation($commentId:ID!,$cloudId:ID!){confluence_reopenComment(commentId:$commentId,cloudId:$cloudId){success,commentResolutionStates{commentId,status},errors{message,extensions{...on ReopenCommentsMutationErrorExtension{errorType,statusCode},__typename,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$6afe964f7c8584f2$var$node.hash = "119c695b9232d3c254c219ff60606f0d";
var $6afe964f7c8584f2$export$2e2bcd8739ae039 = $6afe964f7c8584f2$var$node;


/**
 * @generated SignedSource<<67762659c03bd65a05603133aa492a35>>
 * @relayHash fcfc2d9b0f804b2483ddcf7145a681dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 724c9c43713dcdc68803fcd115dbe1babe7be82cef5185aa9a634678ac1544a4
const $0748a08963961eeb$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentIds"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "commentIds",
            "variableName": "commentIds"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "concreteType": "ConfluenceCommentResolutionState",
        "kind": "LinkedField",
        "name": "commentResolutionStates",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "commentId"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "resolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "resolvedTime"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "resolvedUser"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "resolvedFriendlyDate"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "status"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "errorType"
            },
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ],
        "type": "ResolveCommentsMutationErrorExtension"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CommentResolveCommentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceResolveCommentsPayload",
                    "kind": "LinkedField",
                    "name": "confluence_resolveComments",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CommentResolveCommentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceResolveCommentsPayload",
                    "kind": "LinkedField",
                    "name": "confluence_resolveComments",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "fcfc2d9b0f804b2483ddcf7145a681dc",
            "id": "724c9c43713dcdc68803fcd115dbe1babe7be82cef5185aa9a634678ac1544a4",
            "metadata": {},
            "name": "CommentResolveCommentMutation",
            "operationKind": "mutation",
            "text": "mutation CommentResolveCommentMutation($commentIds:[ID]!,$cloudId:ID!){confluence_resolveComments(commentIds:$commentIds,cloudId:$cloudId){success,commentResolutionStates{commentId,resolveProperties{resolvedTime,resolvedUser,resolvedFriendlyDate},status},errors{message,extensions{...on ResolveCommentsMutationErrorExtension{errorType,statusCode},__typename,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$0748a08963961eeb$var$node.hash = "a1e79d6cdf36db4379af2bb6df78c060";
var $0748a08963961eeb$export$2e2bcd8739ae039 = $0748a08963961eeb$var$node;



var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $21K7m = parcelRequire("21K7m");


var $cUycv = parcelRequire("cUycv");


var $9wGTI = parcelRequire("9wGTI");


var $1ggpj = parcelRequire("1ggpj");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $3ZsvI = parcelRequire("3ZsvI");


var $8i27m = parcelRequire("8i27m");


var $NYiei = parcelRequire("NYiei");


var $jbF1h = parcelRequire("jbF1h");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $bSvtO = parcelRequire("bSvtO");


var $1YPul = parcelRequire("1YPul");


var $8SCD6 = parcelRequire("8SCD6");


var $kmHPt = parcelRequire("kmHPt");


var $auGhu = parcelRequire("auGhu");


var $kEmgx = parcelRequire("kEmgx");


var $1Sjzs = parcelRequire("1Sjzs");


var $cTi4A = parcelRequire("cTi4A");


var $6FXhW = parcelRequire("6FXhW");


var $mzXSs = parcelRequire("mzXSs");


var $g0DaR = parcelRequire("g0DaR");

var $isdzP = parcelRequire("isdzP");

var $8dA1U = parcelRequire("8dA1U");

var $jJx00 = parcelRequire("jJx00");


var $cHfPA = parcelRequire("cHfPA");


var $ep3mz = parcelRequire("ep3mz");


var $8z9UY = parcelRequire("8z9UY");


var $3s9yq = parcelRequire("3s9yq");


var $9rE3H = parcelRequire("9rE3H");


var $b1hSc = parcelRequire("b1hSc");


var $liGyh = parcelRequire("liGyh");


var $aUU0C = parcelRequire("aUU0C");


var $k8e76 = parcelRequire("k8e76");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $gtj7V = parcelRequire("gtj7V");


var $cD1qu = parcelRequire("cD1qu");


var $8WQTF = parcelRequire("8WQTF");


var $cZa7r = parcelRequire("cZa7r");


var $3ejfs = parcelRequire("3ejfs");


var $2i3To = parcelRequire("2i3To");


var $9CnRS = parcelRequire("9CnRS");


var $ftXPY = parcelRequire("ftXPY");


var $87CZC = parcelRequire("87CZC");


var $bQm3c = parcelRequire("bQm3c");


var $7W8i8 = parcelRequire("7W8i8");


var $7B9wr = parcelRequire("7B9wr");


var $i6UMJ = parcelRequire("i6UMJ");


var $en1dX = parcelRequire("en1dX");


var $9FoVw = parcelRequire("9FoVw");


var $6tkbf = parcelRequire("6tkbf");


var $aMfLn = parcelRequire("aMfLn");


var $3mVfX = parcelRequire("3mVfX");


var $6hmtW = parcelRequire("6hmtW");


var $308Wd = parcelRequire("308Wd");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $5fMeR = parcelRequire("5fMeR");


var $fy5yb = parcelRequire("fy5yb");


var $7qvmT = parcelRequire("7qvmT");


var $b5IrT = parcelRequire("b5IrT");

const $dbdd2e782e37c476$var$CommentResolveCommentMutation = (0, $0748a08963961eeb$export$2e2bcd8739ae039);
const $dbdd2e782e37c476$var$CommentReopenCommentMutation = (0, $6afe964f7c8584f2$export$2e2bcd8739ae039);
const $dbdd2e782e37c476$var$CommentDeleteInlineCommentMutationWithStepMutation = (0, $cd762cea5f448981$export$2e2bcd8739ae039);
const $dbdd2e782e37c476$var$CommentDeleteInlineCommentMutation = (0, $2ae18362ec7f1758$export$2e2bcd8739ae039);
const $dbdd2e782e37c476$var$CommentDeleteGeneralCommentMutation = (0, $eaa0b5bea1a46072$export$2e2bcd8739ae039);
const $dbdd2e782e37c476$var$i18n = (0, $aXWIB.defineMessages)({
    commentReopenedFlagTitle: {
        id: "comments-panel.comment.reopened.flag.title",
        defaultMessage: "Comment reopened"
    },
    commentReopenFailedFlagTitle: {
        id: "comments-panel.comment.reopen.failed.flag.title",
        defaultMessage: "Failed to reopen comment"
    },
    commentReopenCacheUpdateFailedFlagTitle: {
        id: "comments-panel.comment.reopen.cache-update.failed.flag.title",
        defaultMessage: "Failed to update reopened comment. Please refresh the page."
    },
    retryCTA: {
        id: "comments-panel.comment.reopen.failed.flag.cta.retry",
        defaultMessage: "Retry now"
    }
});
const $dbdd2e782e37c476$var$logger = (0, $7W8i8.getLogger)('page-comments-queries');
const $dbdd2e782e37c476$var$commentWrapperReplyPaddingOverrides = null;
const $dbdd2e782e37c476$var$commentWrapperReplyPaddingOverridesV2 = null;
const $dbdd2e782e37c476$var$standaloneCommentWrapperReplyPaddingOverrides = null;
const $dbdd2e782e37c476$var$leftBorderStyle = null;
const $dbdd2e782e37c476$var$leftBorderStyleUpdated = null; // this component can be used for parent comment and a reply
const $dbdd2e782e37c476$var$CommentComponent = ({ comment: comment, supportedTopLevelActions: supportedTopLevelActions, pageMode: pageMode, pageInfo: pageInfo, isUnread: isUnread = false, isHovered: isHovered, threadKey: threadKey, flags: flags, isAnnotatedTextPressed: isAnnotatedTextPressed, setAnnotatedTextPressed: setAnnotatedTextPressed, adjustForNestedReplies: adjustForNestedReplies = false, hideBranchingStyle: hideBranchingStyle = false, hideReactions: hideReactions = false, canAddComments: canAddComments = true, isThreadHovered: isThreadHovered, isParentCommentOpen: isParentCommentOpen, isStandaloneComment: isStandaloneComment, showRepliesWithCurvedBorders: showRepliesWithCurvedBorders, deleteStandaloneComment: deleteStandaloneComment, replyToComment: replyToComment, updateReactionsCacheFn: updateReactionsCacheFn, onRendered: onRendered, isLastUnnestableReply: isLastUnnestableReply = false, isReplyEditorOpen: isReplyEditorOpen = false, commentHandlesPadding: commentHandlesPadding = false, hasParentMaxHeight: hasParentMaxHeight = false })=>{
    // Store stable references to break circular dependency in useCallback
    const handleResolveCommentRef = (0, $42omo.useRef)(null);
    const handleReopenCommentRef = (0, $42omo.useRef)(null);
    const [editCommentId, setCommentForEdit] = (0, $42omo.useState)('');
    const { isReactionsEnabled: isReactionsEnabled } = (0, $42omo.useContext)((0, $8SCD6.ReactionsContext));
    const { commentService: commentService } = (0, $6hmtW.useCommentService)();
    const isNewDanglingCommentExperienceEnable = (0, $7B9wr.useIsNewDanglingCommentExperienceEnabled)();
    const isOffline = (0, $cZa7r.useAnnotationsIsOffline)();
    const { setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { removeUnresolvedInlineComment: removeUnresolvedInlineComment, addUnresolvedInlineComment: addUnresolvedInlineComment } = (0, $k8e76.useInlineCommentsActions)();
    const [{ commentsDataMap: legacyCommentsDataMap, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, cacheUpdateFailed: cacheUpdateFailed }, { addNewCommentThreads: addNewCommentThreads, addReplyToCommentThread: addReplyToCommentThread, deleteParentComment: deleteParentComment, handleRemovingComments: handleRemovingComments, setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList }] = (0, $8i27m.useCommentsData)();
    const { setCacheUpdateFailed: setCacheUpdateFailed } = (0, $8i27m.useCommentsDataActions)(); // Get cache operations for new comments data manager
    const { deleteCommentInCache: deleteCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    }); // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)(); // Use new or legacy data based on experiment
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    const [{ annotations: annotations }] = (0, $aUU0C.useEditorAnnotations)();
    const { rendererActions: rendererActions } = (0, $8WQTF.useRendererActions)();
    const [{ updateDocumentFn: updateDocumentFn }] = (0, $1YPul.useUpdateDocument)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [{ currentlySelectedThreadKey: currentlySelectedThreadKey, currentView: currentView }, { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId }] = (0, $3mVfX.useCommentsPanel)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { focusedCommentId: focusedCommentId } = (0, $liGyh.useInlineCommentQueryParams)();
    const { isCommentsPanelShown: isCommentsPanelShown, showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const [contentType] = (0, $ep3mz.useContentType)(); // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [resolveCommentFn] = (0, $308Wd.useMutationInterop)($dbdd2e782e37c476$var$CommentResolveCommentMutation, {
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "@confluence/comments-panel"
    }); // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [reopenCommentFn] = (0, $308Wd.useMutationInterop)($dbdd2e782e37c476$var$CommentReopenCommentMutation, {
        refetchQueries: // Copied from the existing dialog flow to support standalone experience
        pageMode === (0, $cD1qu.PageMode).VIEW && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? [
            {
                query: (0, $3s9yq.InlineCommentsQuery),
                variables: {
                    pageId: contentId
                }
            }
        ] : [],
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "@confluence/comments-panel"
    });
    const [deleteTopLevelRendererInlineCommentFn] = (0, $308Wd.useMutationInterop)($dbdd2e782e37c476$var$CommentDeleteInlineCommentMutationWithStepMutation, {
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "@confluence/comments-panel"
    });
    const [deleteInlineCommentFn] = (0, $308Wd.useMutationInterop)($dbdd2e782e37c476$var$CommentDeleteInlineCommentMutation, {
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "@confluence/comments-panel"
    });
    const [deleteGeneralCommentFn] = (0, $308Wd.useMutationInterop)($dbdd2e782e37c476$var$CommentDeleteGeneralCommentMutation, {
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "@confluence/comments-panel"
    }); // Get the update functions for the comments data manager - aliased to support the different
    // mutation's different result types
    const { updateCommentInCache: updateResolveCommentInCache } = (0, $jbF1h.useUpdateCommentInCache)();
    const { updateCommentInCache: updateReopenCommentInCache } = (0, $jbF1h.useUpdateCommentInCache)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const userId = comment?.author?.accountId;
    const topCommentUserAvatar = comment?.author?.profilePicture?.path;
    const topCommentDisplayName = comment?.author?.displayName ?? formatMessage((0, $3ejfs.commentsi18n).anonymous);
    const commentId = comment?.id;
    const date = comment?.version?.when;
    const createdAt = comment?.createdAt?.value;
    const createdAtNonLocalized = comment?.createdAtNonLocalized;
    const versionByDisplayName = comment?.version?.by?.displayName;
    const versionDate = comment?.version?.when;
    const permissions = comment?.permissions;
    const content = comment?.body?.value;
    const permissionType = comment?.author?.permissionType ?? undefined;
    const parentCommentId = comment?.parentId;
    const isReply = !!parentCommentId;
    const isEdited = (comment?.version?.number || 0) > 1;
    const numReplies = comment?.replies?.length || 0; // Agent session — wire SSE state for the agent-mention-in-comment feature.
    // Any comment (top-level OR reply) can be associated with an agent session, so
    // each comment looks up its OWN session by commentId from AgentSessionsContext
    // (populated by the per-surface AgentSessionsFetcher mounted in CommentsPanelList).
    // When there is no session the hook is a no-op. The experiment is inlined per
    // confluence-feature-gating/inline-usage and ordered last (gate-last).
    const agentSessions = (0, $6FXhW.useAgentSessionsContext)();
    const agentSession = commentId ? agentSessions.get(commentId) : undefined;
    const { state: agentSessionState } = (0, $mzXSs.useCommentAgentSession)((0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? commentId ?? '' : '', (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? agentSession?.conversationId : undefined, (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? agentSession?.state ?? undefined : undefined);
    const commentUrl = pageMode === (0, $cD1qu.PageMode).EDIT ? comment?.links?.editui : comment?.links?.webui; // view page and live docs uses the webui field
    const isDatabaseOrWhiteboard = contentType === 'database' || (0, $1ggpj.isCanvasContentType)(contentType); // When hideReactions (e.g. comment preview popup), pass empty summary so reactions query is skipped and none render
    const inheritedReactionsData = hideReactions ? (0, $g0DaR.defaultReactionsSummary) : comment?.reactionsSummary ?? null;
    const contributors = (0, $cHfPA.hasContributors)(comment) ? comment.contributors : undefined;
    const inlineCommentlocation = comment?.location;
    const footerCommentLocation = comment?.location;
    const commentType = inlineCommentlocation?.type === 'INLINE' ? (0, $8i27m.CommentType).INLINE : (0, $8i27m.CommentType).GENERAL;
    const getResolvedProperties = (0, $42omo.useCallback)((type)=>{
        const properties = type === (0, $8i27m.CommentType).INLINE ? inlineCommentlocation?.inlineResolveProperties : footerCommentLocation?.commentResolveProperties;
        if (!isReply) return properties || undefined;
        return undefined;
    }, [
        inlineCommentlocation,
        footerCommentLocation,
        isReply
    ]);
    const resolveProperties = getResolvedProperties(commentType);
    const annotatedText = inlineCommentlocation?.inlineText || undefined;
    const isCommentRemovedByAnotherUser = comment?.wasRemovedByAnotherUser;
    const isResolvedByAnotherUser = isCommentRemovedByAnotherUser && isCommentRemovedByAnotherUser === (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD;
    const isDeletedByAnotherUser = isCommentRemovedByAnotherUser && isCommentRemovedByAnotherUser === (0, $8i27m.CommentActionType).DELETE_COMMENT;
    const deleteCommentInCacheOnUpdate = (0, $42omo.useCallback)((removalCommentId, experienceName)=>deleteCommentInCache({
            commentId: removalCommentId,
            onError: (err)=>{
                (0, $8dA1U.handleMutationFailure)({
                    experienceTracker: experienceTracker,
                    experienceName: experienceName,
                    error: err,
                    commentId: removalCommentId
                });
            }
        }), [
        deleteCommentInCache,
        experienceTracker
    ]); // This used to be behind confluence_frontend_content_wrapper, but that gate is rolled out.
    // Keeping this as a single variable keeps experiment exposures constant, and the `|| false`
    // avoids feature-gating ratcheting concerns until confluence_fe_delete_comment_optimistic is cleaned up.
    const isOptimisticDeleteEnabled = (0, $6mKj3.expVal)('confluence_fe_delete_comment_optimistic', 'isEnabled', false) || false;
    const handleDeleteInlineComment = ()=>{
        // NOTE: The DELETE experience is started in CommentActions.tsx
        const isDangling = resolveProperties?.isDangling;
        const isTopLevelRendererComment = !isDatabaseOrWhiteboard && pageMode === (0, $cD1qu.PageMode).VIEW && !isReply;
        const canDeleteAnnotation = !isDangling && isTopLevelRendererComment;
        let step;
        if (canDeleteAnnotation) try {
            const deleteResult = rendererActions?.deleteAnnotation(threadKey, 'inlineComment');
            if (deleteResult) step = deleteResult.step;
            else {
                experienceTracker.stopOnError({
                    name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                    error: new Error(`Unable to remove annotation ${threadKey} from document`)
                });
                return;
            }
        } catch (e) {
            experienceTracker.stopOnError({
                name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                error: e
            });
            return;
        }
        if (isStandaloneComment) {
            deleteStandaloneComment && parentCommentId && deleteStandaloneComment(parentCommentId, commentId);
            return;
        }
        resetContentChanged(); // Optimistically mark the annotation as resolved.
        // If deletion is successful, the annotation will be deleted later;
        // if deletion fails, the annotation will be unresolved.
        if (!isReply && isOptimisticDeleteEnabled) (0, $jJx00.resolveInlineCommentAnnotation)(threadKey, pageMode, eventEmitter);
         // Optimistically delete the comment thread, if it is not a reply.
        let deletedParentComment = null;
        if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            if (!isReply && isOptimisticDeleteEnabled) deletedParentComment = (0, $fy5yb.deleteParentCommentOptimistically)({
                threadKey: threadKey,
                commentType: commentType,
                commentsDataMap: commentsDataMap,
                deleteParentComment: deleteParentComment
            });
            else deletedParentComment = (0, $fy5yb.deleteInlineParentComment)({
                isReply: isReply,
                threadKey: threadKey,
                commentType: commentType,
                commentsDataMap: commentsDataMap,
                deleteParentComment: deleteParentComment
            });
        } // Optimistically delete the reply, if it is a reply.
        const deletedReplyComment = !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) && isReply && isOptimisticDeleteEnabled ? (0, $fy5yb.deleteReplyCommentOptimistically)({
            threadKey: threadKey,
            commentId: commentId,
            commentType: commentType,
            commentsDataMap: commentsDataMap,
            handleRemovingComments: handleRemovingComments
        }) : null;
        const deleteMutation = canDeleteAnnotation ? deleteTopLevelRendererInlineCommentFn : deleteInlineCommentFn;
        const optimisticDeleteResponse = canDeleteAnnotation ? {
            deleteInlineComment: true
        } : {
            deleteComment: true
        };
        const deleteVariables = {
            variables: canDeleteAnnotation ? {
                input: {
                    commentId: commentId,
                    step: step ? (0, $aMfLn.constructStepForGql)(step) : {}
                }
            } : {
                commentIdToDelete: commentId,
                // There is no VIEW option
                deleteFrom: pageMode === (0, $cD1qu.PageMode).EDIT ? (0, $8z9UY.CommentDeletionLocation).EDITOR : (0, $8z9UY.CommentDeletionLocation).LIVE
            },
            update: (0, $kgNLQ.selectUpdateFunction)((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false), ()=>deleteCommentInCacheOnUpdate(commentId, (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE)), ()=>isReply ? (0, $g0DaR.updateApolloCacheCallback)('delete', {
                    pageId: contentId,
                    contentStatus: [
                        'CURRENT',
                        'DRAFT'
                    ]
                }, parentCommentId, commentId) : undefined),
            optimisticResponse: isOptimisticDeleteEnabled ? optimisticDeleteResponse : undefined
        };
        deleteMutation({
            ...deleteVariables
        }).then(({ data: data })=>{
            if (!data || canDeleteAnnotation && !data.deleteInlineComment || !canDeleteAnnotation && !data.deleteComment) throw new Error('No data returned from mutation');
            const cleanUpReply = ()=>{
                if (!isOptimisticDeleteEnabled) {
                    if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) handleRemovingComments({
                        threadKey: threadKey,
                        commentId: commentId,
                        action: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                        commentType: commentType
                    });
                }
            };
            const deleteAnnotationAndCleanUpParent = (annotationId)=>{
                // For a top level comment in renderer, we need to send out the events to tell the
                // renderer to deselect the annotation and remove it from the document
                if (pageMode === (0, $cD1qu.PageMode).VIEW) {
                    const deleteResult = rendererActions?.deleteAnnotation(annotationId, 'inlineComment');
                    if (deleteResult && deleteResult.doc) {
                        // Inform the Renderer to de-select the annotation
                        eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
                        eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                        updateDocumentFn && updateDocumentFn(deleteResult.doc);
                    } // For editor/live pages we need to send the event to delete the mark
                } else eventEmitter.emit('delete', annotationId);
            }; // send bridge api signal to content types.
            commentService.onDeleteComment?.(threadKey);
            const onSuccess = (annotationId)=>{
                if (isReply) cleanUpReply();
                else deleteAnnotationAndCleanUpParent(annotationId);
                experienceTracker.succeed({
                    name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE)
                });
            };
            (0, $8dA1U.handleDeleteSuccess)({
                commentId: commentId,
                annotationId: threadKey,
                pageId: contentId,
                pageMode: pageMode,
                isReply: isReply,
                source: isStandaloneComment ? (0, $en1dX.AnalyticsSource).STANDALONE : (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                inlineNodeTypes: undefined,
                createAnalyticsEvent: // We need to figure out how to get this data
                createAnalyticsEvent,
                removeUnresolvedInlineComment: removeUnresolvedInlineComment,
                onSuccess: onSuccess
            });
        }).catch((err)=>{
            handleDeleteCommentError({
                err: err,
                deletedParentComment: deletedParentComment,
                deletedReplyComment: deletedReplyComment
            });
        });
    };
    const handleDeleteGeneralComment = ()=>{
        // Optimistically delete the comment thread, if it is not a reply.
        const deletedParentComment = !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) && !isReply && isOptimisticDeleteEnabled ? (0, $fy5yb.deleteParentCommentOptimistically)({
            threadKey: threadKey,
            commentType: commentType,
            commentsDataMap: commentsDataMap,
            deleteParentComment: deleteParentComment
        }) : null; // Optimistically delete the reply, if it is a reply.
        const deletedReplyComment = !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) && isReply && isOptimisticDeleteEnabled ? (0, $fy5yb.deleteReplyCommentOptimistically)({
            threadKey: threadKey,
            commentId: commentId,
            commentType: commentType,
            commentsDataMap: commentsDataMap,
            handleRemovingComments: handleRemovingComments
        }) : null;
        let deleteLocation; // There is no deleteLocation for View Page
        if (pageMode !== (0, $cD1qu.PageMode).VIEW) deleteLocation = pageMode === (0, $cD1qu.PageMode).EDIT ? (0, $8z9UY.CommentDeletionLocation).EDITOR : (0, $8z9UY.CommentDeletionLocation).LIVE;
        const queryVariables = (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
            pageId: contentId,
            type: 'FOOTER' // If we have footer, always write to footer. Panel works either way
        });
        const deleteVariables = {
            variables: {
                commentIdToDelete: commentId,
                deleteFrom: deleteLocation
            },
            update: (0, $kgNLQ.selectUpdateFunction)((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false), ()=>deleteCommentInCacheOnUpdate(commentId, (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE)), ()=>isReply ? (0, $87CZC.updateApolloCacheReplyCallback)('delete', queryVariables, parentCommentId, isReactionsEnabled, commentId) : (0, $87CZC.updateApolloCacheParentCallback)('delete', queryVariables, isReactionsEnabled, commentId)),
            optimisticResponse: isOptimisticDeleteEnabled ? {
                deleteComment: true
            } : undefined
        };
        deleteGeneralCommentFn({
            ...deleteVariables
        }).then(({ data: data })=>{
            if (!data || !data.deleteComment) throw new Error('No data returned from mutation');
            resetContentChanged();
            if (!isOptimisticDeleteEnabled) {
                if (isReply) {
                    if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) handleRemovingComments({
                        threadKey: threadKey,
                        commentId: commentId,
                        action: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                        commentType: commentType
                    });
                } else if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) deleteParentComment({
                    threadKey: threadKey,
                    commentType: commentType
                });
            }
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'deleted',
                    actionSubject: 'comment',
                    actionSubjectId: commentId,
                    objectType: 'page',
                    objectId: contentId,
                    source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        isReply: isReply,
                        commentType: (0, $8i27m.CommentType).GENERAL,
                        source: isStandaloneComment ? (0, $en1dX.AnalyticsSource).STANDALONE : (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                        pageMode: pageMode
                    }
                }
            }).fire();
            experienceTracker.succeed({
                name: (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE)
            });
        }).catch((err)=>{
            handleDeleteCommentError({
                err: err,
                deletedParentComment: deletedParentComment,
                deletedReplyComment: deletedReplyComment
            });
        });
    };
    const handleDeleteCommentError = ({ err: err, deletedParentComment: deletedParentComment, deletedReplyComment: deletedReplyComment })=>{
        const isInlineComment = commentType === (0, $8i27m.CommentType).INLINE;
        const parsedError = (0, $isdzP.parseError)(err);
        const translatedError = (0, $isdzP.getTranslatedError)(parsedError.message, commentId);
        if ((0, $isdzP.isAlreadyDeletedError)(translatedError)) {
            flags?.showWarningFlag({
                id: commentId,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).commentAlreadyDeletedTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), translatedError)
            });
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'alreadyDeleted',
                    actionSubject: 'comment',
                    actionSubjectId: commentId,
                    objectType: 'page',
                    objectId: contentId,
                    source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        commentType: commentType,
                        mode: pageMode,
                        framework: isInlineComment ? (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER : undefined,
                        isReply: isReply
                    }
                }
            }).fire();
        } else if (isOptimisticDeleteEnabled) // show an error flag to the user when optimistic deletion fails
        flags?.showErrorFlag({
            id: commentId,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).deleteErrorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).deleteError)
        });
        if (deletedParentComment) {
            if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) addNewCommentThreads(deletedParentComment);
        }
        if (isInlineComment && !isReply && isOptimisticDeleteEnabled) (0, $jJx00.unresolveInlineCommentAnnotation)(threadKey, pageMode, eventEmitter);
        if (deletedReplyComment && isOptimisticDeleteEnabled) {
            if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) addReplyToCommentThread(threadKey, deletedReplyComment, commentType, true);
        }
        (0, $8dA1U.handleMutationFailure)({
            experienceTracker: experienceTracker,
            experienceName: isInlineComment ? (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE) : (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE),
            error: err,
            commentId: commentId
        });
    };
    const handleEditComment = ()=>{
        setCommentForEdit(commentId);
    };
    const exitCommentEditor = ()=>{
        setCommentForEdit('');
    };
    const handleReplyToComment = (id)=>{
        setReplyToCommentId({
            parentCommentId: id,
            location: (0, $i6UMJ.LocationValue).PANEL,
            user: {
                displayName: comment?.author?.displayName,
                accountId: comment?.author?.accountId
            },
            contributorUsers: (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? (0, $7qvmT.getReplyToContributorUsers)(contributors) : undefined
        });
    };
    const handleReopenMutationFailure = (0, $42omo.useCallback)(({ isCacheUpdateFailed: isCacheUpdateFailed })=>{
        // TODO: Add experience tracking for reopening, which will allow us to differentiate and
        // detect cache errors vs mutation errors by the error value in the stopOnError() experience
        // call.  When that is added, we can go back to having a single flag message.
        flags?.showErrorFlag({
            id: commentId,
            title: formatMessage(isCacheUpdateFailed ? $dbdd2e782e37c476$var$i18n.commentReopenCacheUpdateFailedFlagTitle : $dbdd2e782e37c476$var$i18n.commentReopenFailedFlagTitle),
            isAutoDismiss: true,
            actions: [
                {
                    content: formatMessage($dbdd2e782e37c476$var$i18n.retryCTA),
                    onClick: ()=>{
                        flags.hideFlag(flags.state.flags[0]?.id);
                        handleReopenCommentRef.current?.();
                    }
                }
            ]
        });
    }, [
        commentId,
        flags,
        formatMessage
    ]);
    const reopenCommentUpdateFn = (0, $42omo.useCallback)((_dataProxy, mutationResult)=>updateReopenCommentInCache({
            mutationResult: mutationResult,
            commentId: commentId,
            updateCallback: (0, $kgNLQ.reopenCommentInCacheCallback),
            onError: ()=>handleReopenMutationFailure({
                    isCacheUpdateFailed: true
                })
        }), [
        commentId,
        handleReopenMutationFailure,
        updateReopenCommentInCache
    ]);
    const handleReopenComment = ()=>{
        // NOTE: The reopen experience is started in CommentActions.tsx
        reopenCommentFn({
            variables: {
                commentId: commentId,
                cloudId: cloudId
            },
            update: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? reopenCommentUpdateFn : undefined
        }).then(()=>{
            // Update the list of active annotationIds
            addUnresolvedInlineComment(threadKey, pageMode); // Emit the event to editor/renderer to reactivate the annotationId
            if (!isDatabaseOrWhiteboard && commentType === (0, $8i27m.CommentType).INLINE) {
                if ((0, $6mKj3.expVal)('confluence_fe_resolve_reopen_comment_refactor', 'isEnabled', false)) (0, $jJx00.unresolveInlineCommentAnnotation)(threadKey, pageMode, eventEmitter);
                else if (pageMode === (0, $cD1qu.PageMode).VIEW) {
                    const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                    emitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
                        [threadKey]: {
                            id: threadKey,
                            annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT,
                            state: (0, $cUycv.AnnotationMarkStates).ACTIVE
                        }
                    });
                } else {
                    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
                    emitter.emit('unresolve', threadKey);
                }
            } // Update the state for panel experience (legacy only)
            if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                if ((0, $6mKj3.expVal)('confluence_fe_resolve_reopen_comment_refactor', 'isEnabled', false)) (0, $3ZsvI.reopenCommentInDataMap)(commentsDataMap, commentType, threadKey, addNewCommentThreads);
                else {
                    const commentsDataMapClone = {
                        ...commentsDataMap
                    };
                    const commentInMap = commentsDataMapClone[commentType][threadKey];
                    if (commentInMap) {
                        commentInMap.isOpen = true;
                        commentInMap.wasRemovedByAnotherUser = false;
                        const commentLocation = commentInMap.location;
                        if (commentLocation && 'commentResolveProperties' in commentLocation && commentLocation.commentResolveProperties) commentLocation.commentResolveProperties.resolved = false;
                        if (commentLocation && 'inlineResolveProperties' in commentLocation && commentLocation.inlineResolveProperties) commentLocation.inlineResolveProperties.resolved = false;
                        addNewCommentThreads(commentsDataMapClone);
                    }
                }
            } // Show the reopen flag
            flags?.showSuccessCircleFlag({
                id: commentId,
                title: formatMessage($dbdd2e782e37c476$var$i18n.commentReopenedFlagTitle),
                isAutoDismiss: true,
                actions: [
                    {
                        content: formatMessage((0, $9CnRS.i18n).goToCommentCTA),
                        onClick: ()=>{
                            const isDangling = inlineCommentlocation?.inlineResolveProperties?.isDangling;
                            let currentViewValue = undefined;
                            if ((0, $6mKj3.expVal)('confluence_comments_comments_6783', 'isEnabled', false)) {
                                // COMMENTS-6783: Always call both `showCommentsPanel` and `setCurrentView`.
                                // We can't reliably read `isCommentsPanelShown` here: this onClick is held by
                                // the flags state container and the `Comment` component that registered it
                                // is unmounted whenever the panel is closed, so any closure / ref over the
                                // "panel shown" value is permanently stale by the time the user clicks
                                // "Go to comment". `showCommentsPanel` is a no-op when the comments panel
                                // is already shown (see `showObjectSidebar` in object-sidebar-api), and
                                // `setCurrentView` is needed so that the view is updated when the panel
                                // is already open. Together they handle both cases correctly.
                                currentViewValue = isDangling && isNewDanglingCommentExperienceEnable ? (0, $3mVfX.ViewValues).DELETED_CONTENT : (0, $3mVfX.ViewValues).OPEN;
                                showCommentsPanel({
                                    openWithView: currentViewValue
                                });
                                setCurrentView(currentViewValue);
                            } else {
                                // just in case the user closed the panel after flag is displayed but before the action is taken, we'll want to reopen the panel again
                                // TOFIX: isCommentsPanelShown is still true after the panel is closed so we'll omit this check for now
                                if (isDangling && isNewDanglingCommentExperienceEnable) {
                                    setCurrentView((0, $3mVfX.ViewValues).DELETED_CONTENT);
                                    currentViewValue = (0, $3mVfX.ViewValues).DELETED_CONTENT;
                                } else if (isCommentsPanelShown) {
                                    setCurrentView((0, $3mVfX.ViewValues).OPEN);
                                    currentViewValue = (0, $3mVfX.ViewValues).OPEN;
                                }
                            } // Call navigation with view change waiting for reopen flow
                            (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                context: (0, $9FoVw.NavigationContext).PANEL,
                                block: 'center',
                                annotationId: threadKey,
                                commentType: commentType === (0, $8i27m.CommentType).INLINE ? 'INLINE' : 'FOOTER',
                                annotationClicked: true,
                                expectedView: currentViewValue,
                                commentId: commentId
                            });
                            if (commentType === (0, $8i27m.CommentType).INLINE || commentType === (0, $8i27m.CommentType).GENERAL) setCurrentlySelectedThreadKey(threadKey);
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    },
                    {
                        content: formatMessage((0, $9CnRS.i18n).undoCTA),
                        onClick: ()=>{
                            handleResolveCommentRef.current?.();
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    }
                ]
            });
            if (commentType === (0, $8i27m.CommentType).INLINE) {
                if (isDatabaseOrWhiteboard && (0, $9wGTI.fg)('cc-whiteboards-consolidating-comments')) {
                    // add unresolved comment to whiteboard and database
                    const commentInMap = commentsDataMap[commentType][threadKey];
                    const commentLocation = commentInMap.location;
                    commentService.onReopenResolvedComment?.({
                        contentId: contentId,
                        referenceId: commentLocation.inlineMarkerRef
                    });
                }
                const orderedActiveAnnotationIds = orderedActiveAnnotationIdList.map((annotation)=>annotation.threadKey); // only insert reopened comment annotation if the comment highlight exists
                if (!resolveProperties?.isDangling) {
                    let annotationsList = annotations;
                    if (pageMode === (0, $cD1qu.PageMode).VIEW) {
                        const annotationMarks = rendererActions?.getAnnotationMarks();
                        annotationsList = annotationMarks?.map((mark)=>mark.attrs.id) ?? [];
                    }
                    if (annotationsList.length > 0) (0, $g0DaR.insertReopenedCommentAnnotation)(annotationsList, threadKey, orderedActiveAnnotationIds, setOrderedActiveAnnotationIdList);
                }
            }
        }).catch(()=>{
            handleReopenMutationFailure({
                isCacheUpdateFailed: false
            });
        });
    };
    const resolveExperienceName = commentType === (0, $8i27m.CommentType).INLINE ? (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE) : (0, $irVI7.RESOLVE_PAGE_COMMENT_EXPERIENCE);
    const handleResolveMutationFailure = (0, $42omo.useCallback)((resolveError)=>{
        (0, $8dA1U.handleMutationFailure)({
            experienceTracker: experienceTracker,
            experienceName: resolveExperienceName,
            error: resolveError
        });
    }, [
        experienceTracker,
        resolveExperienceName
    ]);
    const resolveCommentsUpdateFn = (0, $42omo.useCallback)((_dataProxy, mutationResult)=>updateResolveCommentInCache({
            mutationResult: mutationResult,
            commentId: commentId,
            updateCallback: (0, $kgNLQ.resolveCommentInCacheCallback),
            onError: handleResolveMutationFailure
        }), [
        updateResolveCommentInCache,
        commentId,
        handleResolveMutationFailure
    ]);
    let commentsDataManagerResolveUpdateFn = undefined;
    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) commentsDataManagerResolveUpdateFn = resolveCommentsUpdateFn; // FG enables new BE resolve comments endpoint
    const handleResolveComment = ()=>{
        if ((0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) {
            // Optimistically mark the comment as resolved in the data map & update UI early (legacy only)
            if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) (0, $3ZsvI.resolveCommentInDataMap)(commentsDataMap, commentType, threadKey, addNewCommentThreads);
             // Optimistically mark the inline comment annotation as resolved
            if (!isDatabaseOrWhiteboard && commentType === (0, $8i27m.CommentType).INLINE) (0, $jJx00.resolveInlineCommentAnnotation)(threadKey, pageMode, eventEmitter);
        } // NOTE: The RESOLVED experience is started in CommentActions.tsx
        resolveCommentFn({
            variables: {
                commentIds: [
                    commentId
                ],
                cloudId: cloudId
            },
            update: commentsDataManagerResolveUpdateFn || ((cache, { data: data })=>{
                (0, $3ZsvI.updateCommentsQueryCacheForResolve)({
                    cache: cache,
                    commentId: commentId,
                    query: (0, $b1hSc.default),
                    queryVariables: (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
                        pageId: contentId,
                        type: commentType === (0, $8i27m.CommentType).GENERAL ? 'FOOTER' : undefined // If we have footer, always write to footer. Panel works either way
                    }),
                    cacheUpdateFailed: cacheUpdateFailed,
                    setCacheUpdateFailed: setCacheUpdateFailed,
                    source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                    logger: $dbdd2e782e37c476$var$logger
                });
                if (!isReply && comment.type === (0, $8i27m.CommentType).GENERAL) try {
                    const { confluence_resolveComments: confluence_resolveComments } = data;
                    if (!confluence_resolveComments) return;
                    const { commentResolutionStates: commentResolutionStates, success: success } = confluence_resolveComments;
                    const commentsSectionQuery = isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery);
                    if (!success || commentResolutionStates === null || commentResolutionStates.length === 0) return;
                    const firstState = commentResolutionStates[0];
                    if (!firstState) return;
                    const { commentId: commentId } = firstState;
                    const prevData = (0, $l1uFv.readQueryInterop)({
                        query: commentsSectionQuery,
                        variables: {
                            contentId: contentId,
                            offset: '',
                            first: (0, $2i3To.DEFAULT_LIMIT)
                        },
                        __callerPackage__: "@confluence/comments-panel"
                    });
                    const edges = prevData?.comments?.edges; // Filter out all comments related to the parent and it's children as they will all be resolved
                    const newEdges = edges?.filter((edge)=>edge?.node?.id !== commentId && !edge?.node?.ancestors.map((a)=>a?.id).includes(commentId)) || [];
                    const newData = {
                        comments: {
                            ...prevData?.comments,
                            totalCount: newEdges.length,
                            pageInfo: {
                                ...prevData?.comments?.pageInfo,
                                endCursor: '',
                                hasNextPage: false //set hasNextPage to always false to avoid performing incremental fetching again which will result in duplicate data
                            },
                            edges: newEdges
                        },
                        content: {
                            ...prevData?.content,
                            nodes: [
                                ...prevData?.content?.nodes || []
                            ]
                        },
                        user: {
                            ...prevData?.user
                        }
                    };
                    (0, $fEmGS.writeQueryInterop)({
                        query: commentsSectionQuery,
                        variables: {
                            contentId: contentId,
                            offset: '',
                            first: (0, $2i3To.DEFAULT_LIMIT)
                        },
                        data: {
                            ...newData
                        },
                        __callerPackage__: "@confluence/comments-panel"
                    });
                } catch (err) {
                    $dbdd2e782e37c476$var$logger.error`An error occurred when updating cache for general comments resolve - ${err}`;
                    if (!(0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) // CommentsSectionQuery is being deprecated. `readQuery` will throw error
                    // if a matching cache entry is not present. This won't break any user experience.
                    // However, setCacheUpdateFailed(true) will trigger a refetch of ActiveCommentsQuery,
                    // whose result, with optimistic resolve, will include the newly resolved comment.
                    // This causes comments panel to show the resolved comment. So skipping it here.
                    setCacheUpdateFailed(true);
                }
            }),
            // When a `optimisticResponse` is set, useMutation invokes the update function twice:
            // first immediately, and after mutation succeeds, a second time. If mutation fails,
            // the cache updated by the update function is rolled back. Thus, this optimistic
            // resolve works both when cc_comments_new_comments_data_manager is ON and OFF.
            optimisticResponse: (0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false) ? {
                confluence_resolveComments: {
                    commentResolutionStates: [
                        {
                            commentId: commentId,
                            status: true,
                            resolveProperties: {
                                // These 2 values will be updated to the correct value after mutation succeeds.
                                // - `resolvedUser` is only displayed in comments panel Resolved view,
                                //   inside a tooltip when hovered.
                                // - `resolvedFriendlyDate` is not used by the current comments panel UI.
                                // So setting it as empty optimistically won't affect the static UI.
                                resolvedUser: null,
                                resolvedFriendlyDate: '',
                                resolvedTime: Date.now(),
                                __typename: 'InlineCommentResolveProperties'
                            },
                            __typename: 'ConfluenceCommentResolutionState'
                        }
                    ],
                    success: true,
                    errors: [],
                    __typename: 'ConfluenceResolveCommentsPayload'
                } // typed as any because optimisticResponse is provided only for the resolve comment mutation
            } : undefined
        }).then(()=>{
            if (!(0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) // Update the state for panel experience when optimistic resolve is disabled
            // If enabled, this has been done before the mutation succeeds.
            {
                if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                    if ((0, $6mKj3.expVal)('confluence_fe_resolve_reopen_comment_refactor', 'isEnabled', false)) (0, $3ZsvI.resolveCommentInDataMap)(commentsDataMap, commentType, threadKey, addNewCommentThreads);
                    else {
                        const commentsDataMapClone = {
                            ...commentsDataMap
                        };
                        const commentInMap = commentsDataMapClone[commentType][threadKey];
                        if (commentInMap) {
                            commentsDataMapClone[commentType][threadKey].isOpen = false;
                            const commentLocation = commentsDataMapClone[commentType][threadKey].location;
                            if (commentLocation && commentLocation.inlineResolveProperties) commentLocation.inlineResolveProperties.resolved = true;
                            if (commentLocation && commentLocation.commentResolveProperties) commentLocation.commentResolveProperties.resolved = true;
                            addNewCommentThreads(commentsDataMapClone);
                        }
                    }
                }
            } // Update content types comment service if we are resolving a comment
            commentService.onResolveComment?.(threadKey);
            if (commentType === (0, $8i27m.CommentType).INLINE || !(0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) // (Putting this behind the experiment just in case.)
            // This handles INLINE comment annotation. No need to invoke it for GENERAL comment.
            (0, $8dA1U.handleResolveSuccess)({
                commentId: commentId,
                parentCommentMarkerRef: threadKey,
                pageId: contentId,
                pageMode: pageMode,
                commentType: commentType,
                eventEmitter: eventEmitter,
                source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                removeUnresolvedInlineComment: removeUnresolvedInlineComment,
                createAnalyticsEvent: createAnalyticsEvent,
                setEditorViewProps: setEditorViewProps //getInlineNodeTypes  // TODO: Figure out how to get this info
            });
            setOrderedActiveAnnotationIdList(orderedActiveAnnotationIdList.map((status)=>status.threadKey).filter((id)=>id !== threadKey)); // Show the resolved flag
            flags?.showSuccessCircleFlag({
                id: commentId,
                title: formatMessage((0, $9CnRS.i18n).resolvedFlagText),
                isAutoDismiss: true,
                actions: [
                    {
                        content: formatMessage((0, $9CnRS.i18n).goToCommentCTA),
                        onClick: ()=>{
                            if ((0, $6mKj3.expVal)('confluence_comments_comments_6783', 'isEnabled', false)) {
                                // COMMENTS-6783: Always call both `showCommentsPanel` and
                                // `setCurrentView`. We can't reliably read `isCommentsPanelShown`
                                // here: this onClick is held by the flags state container, and the
                                // `Comment` component that registered it is unmounted whenever the
                                // panel is closed, so any closure / ref over the "panel shown" value
                                // is permanently stale by the time the user clicks "Go to comment".
                                // `showCommentsPanel` is a no-op when the comments panel is already
                                // shown (see `showObjectSidebar` in object-sidebar-api), and
                                // `setCurrentView` is needed so the view is updated when the panel
                                // is already open. Together they handle both cases correctly.
                                showCommentsPanel({
                                    openWithView: (0, $3mVfX.ViewValues).RESOLVED
                                });
                                setCurrentView((0, $3mVfX.ViewValues).RESOLVED);
                            } else if (!isCommentsPanelShown) showCommentsPanel({
                                openWithView: (0, $3mVfX.ViewValues).RESOLVED
                            });
                            else setCurrentView((0, $3mVfX.ViewValues).RESOLVED);
                            (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                context: (0, $9FoVw.NavigationContext).PANEL,
                                block: 'center',
                                annotationId: threadKey,
                                commentType: commentType === (0, $8i27m.CommentType).INLINE ? 'INLINE' : 'FOOTER',
                                annotationClicked: true,
                                expectedView: (0, $3mVfX.ViewValues).RESOLVED,
                                commentId: commentId
                            });
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    },
                    {
                        content: formatMessage((0, $9CnRS.i18n).undoCTA),
                        onClick: ()=>{
                            if ((0, $6mKj3.expVal)('confluence_comments_comments_6783', 'isEnabled', false)) {
                                // COMMENTS-6783: Always re-open the panel to the OPEN view.
                                // `showCommentsPanel` is a no-op when the panel is already shown
                                // (see `showObjectSidebar` in object-sidebar-api). We can't reliably
                                // read `isCommentsPanelShown` here because the `Comment` component
                                // that registered this onClick is unmounted whenever the panel is
                                // closed, so any closure / ref over the "panel shown" value is
                                // permanently stale.
                                const isDangling = inlineCommentlocation?.inlineResolveProperties?.isDangling;
                                const currentViewValue = isDangling && isNewDanglingCommentExperienceEnable ? (0, $3mVfX.ViewValues).DELETED_CONTENT : (0, $3mVfX.ViewValues).OPEN;
                                showCommentsPanel({
                                    openWithView: currentViewValue
                                });
                            } else if (!isCommentsPanelShown) showCommentsPanel({
                                openWithView: (0, $3mVfX.ViewValues).OPEN
                            });
                            handleReopenComment();
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    }
                ]
            });
            experienceTracker.succeed({
                name: resolveExperienceName
            });
        }).catch((err)=>{
            if ((0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) {
                // Undo resolving the comment when optimistic resolve is enabled (legacy only)
                if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) (0, $3ZsvI.reopenCommentInDataMap)(commentsDataMap, commentType, threadKey, addNewCommentThreads);
                 // Undo resolving the inline comment annotation
                if (!isDatabaseOrWhiteboard && commentType === (0, $8i27m.CommentType).INLINE) (0, $jJx00.unresolveInlineCommentAnnotation)(threadKey, pageMode, eventEmitter);
                 // Show an error flag to user when resolve fails
                flags?.showErrorFlag({
                    id: commentId,
                    title: formatMessage((0, $9CnRS.i18n).resolveErrorTitle),
                    description: formatMessage((0, $9CnRS.i18n).resolveError)
                });
            }
            handleResolveMutationFailure(err);
        });
    };
    // Update refs to break circular dependency
    handleResolveCommentRef.current = handleResolveComment;
    handleReopenCommentRef.current = handleReopenComment;
    const pageType = pageInfo?.type ?? ''; // Editor setup
    const spaceId = pageInfo?.space?.id ?? ''; // User page permissions
    const operations = pageInfo?.operations || []; // User space permissions - only access when feature gate is on
    const spaceOperations = (0, $9wGTI.fg)('confluence_comments_space_operations_permissions') ? pageInfo?.space?.operations || [] : [];
    const canAddComment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment');
    const canAddAttachment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment') || spaceOperations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment'); // The user can upload media only if they have update permissions for the page if confluence_comment_use_comment_media_endpoint FG is off
    const hasMediaUploadPermissions = (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? canAddComment && canAddAttachment : operations.some((op)=>op?.operation === 'update' && op?.targetType === pageType); // We only want to focus resolved comments because the 'active' comments have
    // their own treatment for when one is hovered/selected and could cause weird behavior
    const isCommentFocused = resolveProperties?.resolved && commentId === focusedCommentId;
    const supportedActions = !isReply && isCommentRemovedByAnotherUser ? [
        'reopen'
    ] : supportedTopLevelActions;
    const shouldShowLeftBorder = (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? commentHandlesPadding && commentId === editCommentId && isReply && !isLastUnnestableReply : commentHandlesPadding && !isStandaloneComment && commentId === editCommentId && isReply;
    const handleStandaloneReply = (id)=>{
        replyToComment && replyToComment(id, comment);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            commentHandlesPadding && "_19bv1ejb _n3tdu2gc",
            commentHandlesPadding && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_19bvpxbi",
            commentHandlesPadding && isStandaloneComment && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_18u0utpp",
            shouldShowLeftBorder && "_1kl711qs",
            shouldShowLeftBorder && (0, $9wGTI.fg)('confluence_comment_border_migration') && "_1kl71h4i"
        ])
    }, commentId === editCommentId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auGhu.EditComment), {
        pageId: contentId,
        pageType: pageType,
        annotationId: threadKey,
        commentId: commentId,
        spaceId: spaceId,
        content: content ?? '',
        isReply: isReply,
        displayCommentInViewMode: exitCommentEditor,
        avatarUrl: topCommentUserAvatar ?? '',
        displayName: topCommentDisplayName,
        date: date ?? '',
        dateUrl: commentUrl ?? '',
        createdAtNonLocalized: createdAtNonLocalized ?? '',
        versionByDisplayName: versionByDisplayName,
        versionDate: versionDate ?? '',
        resolveProperties: resolveProperties,
        mode: pageMode === (0, $cD1qu.PageMode).VIEW ? 'view' : 'edit',
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        isCommentsPanel: isCommentsPanelShown,
        commentType: commentType,
        isStandaloneComment: isStandaloneComment,
        isOffline: isOffline,
        isLastUnnestableReply: isLastUnnestableReply,
        hasParentMaxHeight: hasParentMaxHeight,
        numReplies: numReplies
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kEmgx.CommentBody), {
        mode: "view",
        userId: userId,
        avatarUrl: topCommentUserAvatar,
        displayName: topCommentDisplayName,
        date: date ?? '',
        dateUrl: commentUrl ?? '',
        createdAt: createdAt ?? '',
        createdAtNonLocalized: createdAtNonLocalized ?? '',
        versionByDisplayName: versionByDisplayName,
        versionDate: versionDate ?? '',
        pageId: contentId,
        pageType: pageType,
        commentId: commentId ?? '',
        isReply: isReply,
        isEdited: isEdited,
        parentCommentId: parentCommentId,
        permissions: permissions,
        content: content ?? '',
        permissionType: permissionType ?? undefined,
        supportedActions: supportedActions,
        deleteComment: commentType === (0, $8i27m.CommentType).INLINE ? handleDeleteInlineComment : handleDeleteGeneralComment,
        editComment: handleEditComment,
        resolveComment: handleResolveComment,
        numReplies: numReplies,
        isUnread: isUnread,
        isCommentActive: true,
        hideAiSuggestEdit: currentView === (0, $3mVfX.ViewValues).RESOLVED || currentView === (0, $3mVfX.ViewValues).DELETED_CONTENT,
        isCommentsPanel: true,
        isHovered: isHovered,
        isResolvedByAnotherUser: isResolvedByAnotherUser,
        isFocused: isCommentFocused,
        isOffline: isOffline,
        resolveProperties: resolveProperties,
        annotationId: threadKey,
        annotatedText: annotatedText,
        reopenComment: handleReopenComment,
        replyToComment: isStandaloneComment ? handleStandaloneReply : handleReplyToComment,
        inheritedReactionsData: inheritedReactionsData,
        isDeletedByAnotherUser: isDeletedByAnotherUser,
        currentlySelectedThreadKey: currentlySelectedThreadKey,
        setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey,
        isAnnotatedTextPressed: isAnnotatedTextPressed,
        setAnnotatedTextPressed: setAnnotatedTextPressed,
        commentType: commentType,
        adjustForNestedReplies: adjustForNestedReplies,
        // outside CommentBody's measured height) so the line reaches the next reply. Only
        // when this is NOT the last reply — otherwise the line would dangle past the status
        // row into nothing. The 48px is tunable (approx. status-row height). Gate inlined, last.
        // Also extend it for the LAST reply when the reply editor is open below it, so the
        // line spans the status row down to the editor instead of stopping short (gap fix).
        extraReplyBranchHeight: isReply && (!isLastUnnestableReply || isReplyEditorOpen) && !!agentSessionState && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? 48 : 0,
        hideBranchingStyle: hideBranchingStyle,
        canAddComments: canAddComments,
        isThreadHovered: isThreadHovered,
        isParentCommentOpen: isParentCommentOpen,
        reactionsCacheUpdateFn: updateReactionsCacheFn,
        isStandaloneComment: isStandaloneComment,
        showRepliesWithCurvedBorders: showRepliesWithCurvedBorders,
        onRendered: onRendered,
        contributors: contributors
    }), agentSessionState && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) && (isReply ? // Nested replies: wrap the status row in the same curved branch a reply uses so it
    // attaches to the thread's connector line. Top-level comments render it unwrapped.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
        showDefaultStyles: true,
        customStyles: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? {
            left: '-16px',
            height: '24px'
        } : {
            height: '28px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cTi4A.AvatarWithActionButtonAsync), {
        agentState: agentSessionState,
        conversationId: agentSession?.conversationId ?? '',
        isCommentsPanel: true,
        isFooterComment: false,
        isReply: true,
        userId: agentSession?.agentId ?? userId,
        avatarUrl: agentSession?.avatarUrl ?? topCommentUserAvatar,
        agentName: agentSession?.agentName ?? undefined
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cTi4A.AvatarWithActionButtonAsync), {
        agentState: agentSessionState,
        conversationId: agentSession?.conversationId ?? '',
        isCommentsPanel: true,
        isFooterComment: false,
        userId: agentSession?.agentId ?? userId,
        avatarUrl: agentSession?.avatarUrl ?? topCommentUserAvatar,
        agentName: agentSession?.agentName ?? undefined
    })));
};
const $dbdd2e782e37c476$export$4d299b491347818a = /*#__PURE__*/ (0, $42omo.memo)($dbdd2e782e37c476$var$CommentComponent, (0, $b5IrT.arePropsShallowEqualWhenMemoRowsEnabled));
module.exports["Comment"] = $dbdd2e782e37c476$export$4d299b491347818a;

});

parcelRegister("auGhu", function(module, exports) {
/**
 * @generated SignedSource<<660b997737b1e067275da123643bdbbe>>
 * @relayHash 5697e0abe1263b5300c505ca404b81c1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 613ba47d392048aee86ae627f6146fedff60219a2787237cc590eb30208f746c
const $ba400452d93f7729$var$node = function() {
    var v0 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeVersionFields"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ],
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v5 = {
        "kind": "ScalarField",
        "name": "number"
    }, v6 = {
        "kind": "ScalarField",
        "name": "when"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EditCommentUpdateCommentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "updateComment",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "condition": "includeVersionFields",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EditCommentUpdateCommentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "updateComment",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "condition": "includeVersionFields",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "5697e0abe1263b5300c505ca404b81c1",
            "id": "613ba47d392048aee86ae627f6146fedff60219a2787237cc590eb30208f746c",
            "metadata": {},
            "name": "EditCommentUpdateCommentMutation",
            "operationKind": "mutation",
            "text": "mutation EditCommentUpdateCommentMutation($input:UpdateCommentInput!,$includeVersionFields:Boolean=false){updateComment(input:$input){id,body(representation:ATLAS_DOC_FORMAT)@include(if:$includeVersionFields){value}\n    version@include(if:$includeVersionFields){number,when,by{__typename,displayName}}}}"
        }
    };
}();
$ba400452d93f7729$var$node.hash = "47ab6347755394e66a03dca4de4caa26";
var $ba400452d93f7729$export$2e2bcd8739ae039 = $ba400452d93f7729$var$node;



var $42omo = parcelRequire("42omo");


var $abN8T = parcelRequire("abN8T");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $7EEGh = parcelRequire("7EEGh");


var $lesF8 = parcelRequire("lesF8");


var $6f0Oj = parcelRequire("6f0Oj");


var $ecnYn = parcelRequire("ecnYn");


var $7Sm4c = parcelRequire("7Sm4c");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $8Ss4E = parcelRequire("8Ss4E");


var $aJPUt = parcelRequire("aJPUt");


var $aGjYc = parcelRequire("aGjYc");


var $hXzKU = parcelRequire("hXzKU");


var $8i27m = parcelRequire("8i27m");


var $jbF1h = parcelRequire("jbF1h");


var $bSvtO = parcelRequire("bSvtO");


var $8SCD6 = parcelRequire("8SCD6");


var $cZa7r = parcelRequire("cZa7r");


var $bQm3c = parcelRequire("bQm3c");


var $3B9cR = parcelRequire("3B9cR");

/**
 * @generated SignedSource<<b8ac77242fe9aa482a26ed70485341f0>>
 * @relayHash 7dac482d1cfd5a28854a0820682bd12f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9594d19512d0b12a68a3c38761925e88d1279ffaa9fa2d6bbc5b1a40894d7798
const $66dfdf9e3f477c03$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ROOT"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v4 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v3 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v5 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v6 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v3 /*: any*/ 
    }, v7 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v8 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v11 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v12 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v14 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    v10 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v11 /*: any*/ ,
                    v12 /*: any*/ ,
                    v13 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v10 /*: any*/ ,
                    v11 /*: any*/ ,
                    v12 /*: any*/ ,
                    v13 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v16 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            v14 /*: any*/ ,
            v15 /*: any*/ 
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v18 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v20 = {
        "kind": "ScalarField",
        "name": "when"
    }, v21 = {
        "kind": "ScalarField",
        "name": "number"
    }, v22 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v19 /*: any*/ 
                ]
            },
            v20 /*: any*/ ,
            v21 /*: any*/ 
        ]
    }, v23 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v26 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v19 /*: any*/ ,
            v23 /*: any*/ ,
            v24 /*: any*/ ,
            v25 /*: any*/ 
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v28 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v29 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v28 /*: any*/ ,
            v9 /*: any*/ ,
            v14 /*: any*/ ,
            v15 /*: any*/ 
        ]
    }, v30 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v28 /*: any*/ ,
                    v19 /*: any*/ 
                ]
            },
            v20 /*: any*/ ,
            v21 /*: any*/ 
        ]
    }, v31 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v28 /*: any*/ ,
            v19 /*: any*/ ,
            v23 /*: any*/ ,
            v24 /*: any*/ ,
            v25 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentsPanelQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v22 /*: any*/ ,
                                v26 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v22 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v27 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentsPanelQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v29 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v30 /*: any*/ ,
                                v31 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        v31 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v27 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "7dac482d1cfd5a28854a0820682bd12f",
            "id": "9594d19512d0b12a68a3c38761925e88d1279ffaa9fa2d6bbc5b1a40894d7798",
            "metadata": {},
            "name": "CommentsPanelQuery",
            "operationKind": "query",
            "text": "query CommentsPanelQuery($pageId:ID!){comments(pageId:$pageId,type:UNRESOLVED,depth:ROOT,first:50){nodes{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}},totalCount}}"
        }
    };
}();
$66dfdf9e3f477c03$var$node.hash = "2ba184201b06cec56898efcdf0235520";
var $66dfdf9e3f477c03$export$2e2bcd8739ae039 = $66dfdf9e3f477c03$var$node;


const $eea05c4e9d0eb879$export$9e679b96e845bbef = (0, $66dfdf9e3f477c03$export$2e2bcd8739ae039);



var $1C8XP = parcelRequire("1C8XP");


var $7W8i8 = parcelRequire("7W8i8");


var $56QzY = parcelRequire("56QzY");


var $87CZC = parcelRequire("87CZC");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $7aRa9 = parcelRequire("7aRa9");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $en1dX = parcelRequire("en1dX");


var $6tkbf = parcelRequire("6tkbf");


var $6hmtW = parcelRequire("6hmtW");


var $308Wd = parcelRequire("308Wd");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");

/**
 * @generated SignedSource<<45a4680883693e6b600cb478c398287a>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: agg
 *
 * @see https://go/typsy
 **/ var $6640dd1dcbfb32b9$export$f4016897b165b6d5 = /*#__PURE__*/ function(ContentRepresentation) {
    ContentRepresentation["ATLAS_DOC_FORMAT"] = "ATLAS_DOC_FORMAT";
    ContentRepresentation["EDITOR"] = "EDITOR";
    ContentRepresentation["EDITOR2"] = "EDITOR2";
    ContentRepresentation["EXPORT_VIEW"] = "EXPORT_VIEW";
    ContentRepresentation["PLAIN"] = "PLAIN";
    ContentRepresentation["RAW"] = "RAW";
    ContentRepresentation["STORAGE"] = "STORAGE";
    ContentRepresentation["STYLED_VIEW"] = "STYLED_VIEW";
    ContentRepresentation["VIEW"] = "VIEW";
    ContentRepresentation["WIKI"] = "WIKI";
    return ContentRepresentation;
}({});



var $1Sjzs = parcelRequire("1Sjzs");


var $isdzP = parcelRequire("isdzP");


var $daq5m = parcelRequire("daq5m");


var $cvKwQ = parcelRequire("cvKwQ");

const $2d789a7ecebf6a19$var$EditCommentUpdateCommentMutation = (0, $ba400452d93f7729$export$2e2bcd8739ae039);
const $2d789a7ecebf6a19$var$i18n = (0, $aXWIB.defineMessages)({
    cannotEditTitle: {
        id: "inline-comments-common.could.not.edit.title",
        defaultMessage: "Unable to edit comment"
    }
});
const $2d789a7ecebf6a19$var$logger = (0, $7W8i8.getLogger)('inline-comments-common:edit-comment');
const $2d789a7ecebf6a19$var$editorContainerStyle = (0, $ecnYn.xcss)({
    paddingBlock: 'space.150',
    paddingInline: 'space.200'
});
const $2d789a7ecebf6a19$var$editorContainerStyleV2 = (0, $ecnYn.xcss)({
    paddingBottom: 'space.0',
    paddingInline: 'space.150'
});
const $2d789a7ecebf6a19$var$editorContainerStyleV2InlinePadding = (0, $ecnYn.xcss)({
    paddingInlineStart: 'space.200'
});
const $2d789a7ecebf6a19$var$editorReplyRelativeLeft = (0, $ecnYn.xcss)({
    position: 'relative',
    // Design requires -1px margin to account for left border which is outside the token system
    left: '-1px'
});
const $2d789a7ecebf6a19$var$editorContainerForFooterWrapperStyle = (0, $ecnYn.xcss)({
    padding: 'unset',
    paddingTop: 'space.100'
});
const $2d789a7ecebf6a19$var$editorContainerForFooterWrapperStyleV2 = (0, $ecnYn.xcss)({
    paddingLeft: 'space.050'
});
const $2d789a7ecebf6a19$var$editorContainerForFooterExtraLeftPaddingWithBorderStyle = (0, $ecnYn.xcss)({
    paddingLeft: 'space.300',
    marginLeft: 'space.200',
    marginTop: 'space.050',
    // If we're doing the border here, we need margin instead of padding so the border is flush with the editor
    borderLeft: `1.5px solid ${"var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"}`
});
const $2d789a7ecebf6a19$var$editorContainerForFooterExtraLeftPaddingWithBorderStyleUpdated = (0, $ecnYn.xcss)({
    paddingLeft: 'space.300',
    marginLeft: 'space.200',
    marginTop: 'space.050',
    // If we're doing the border here, we need margin instead of padding so the border is flush with the editor
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"}`
});
const $2d789a7ecebf6a19$var$editorContainerForFooterExtraLeftPaddingWithBorderStyleV2 = (0, $ecnYn.xcss)({
    marginLeft: 'space.150'
});
const $2d789a7ecebf6a19$var$editorContainerForStandaloneWithRepliesStyle = (0, $ecnYn.xcss)({
    paddingLeft: 'space.300',
    marginLeft: 'space.150',
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"}`
});
const $2d789a7ecebf6a19$var$editorBottomPaddingStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.100'
});
const $2d789a7ecebf6a19$var$panelEditorParentContainerStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.100',
    marginBottom: 'space.0',
    paddingBlock: 'space.0',
    paddingRight: 'space.0',
    paddingTop: 'space.0'
});
const $2d789a7ecebf6a19$var$panelEditorParentContainerStyleV2 = (0, $ecnYn.xcss)({
    marginLeft: 'space.0'
});
const $2d789a7ecebf6a19$var$panelEditorReplyContainerStyle = (0, $ecnYn.xcss)({
    margin: '0',
    padding: '0',
    paddingTop: 'space.100'
});
const $2d789a7ecebf6a19$var$panelEditorReplyContainerStyleV2 = (0, $ecnYn.xcss)({
    paddingLeft: 'space.050'
});
const $2d789a7ecebf6a19$var$adjustForBorderStyle = (0, $ecnYn.xcss)({
    // @ts-expect-error - Design requires -1px margin to account for left border which is outside the token system
    marginLeft: '-1px'
});
const $2d789a7ecebf6a19$var$standaloneEditorReplyContainerStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.negative.200',
    paddingRight: 'space.0',
    paddingTop: 'space.0'
});
const $2d789a7ecebf6a19$var$standaloneEditorReplyContainerStyleV2 = (0, $ecnYn.xcss)({
    margin: '0',
    padding: '0',
    paddingLeft: 'space.050',
    paddingTop: 'space.100'
});
const $2d789a7ecebf6a19$var$editorParentWrapperStyle = (0, $ecnYn.xcss)({
    paddingLeft: 'space.300',
    marginLeft: 'space.negative.100',
    borderLeft: `1.5px solid ${"var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"}`,
    paddingBottom: 'space.100'
});
const $2d789a7ecebf6a19$var$editorParentWrapperStyleUpdated = (0, $ecnYn.xcss)({
    paddingLeft: 'space.300',
    marginLeft: 'space.negative.100',
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"}`,
    paddingBottom: 'space.100'
});
const $2d789a7ecebf6a19$var$editorParentWrapperStyleV2 = (0, $ecnYn.xcss)({
    marginLeft: 'space.negative.050',
    borderLeft: `none`
});
const $2d789a7ecebf6a19$var$editorParentWithRepliesWrapperStyleV2 = (0, $ecnYn.xcss)({
    marginLeft: 'space.negative.050',
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"}`
});
const $2d789a7ecebf6a19$var$standaloneEditorReplyWrapperStyle = (0, $ecnYn.xcss)({
    paddingLeft: 'space.300',
    paddingBottom: 'space.200',
    marginLeft: 'space.negative.300',
    marginBottom: 'space.negative.150'
});
const $2d789a7ecebf6a19$var$leftBorderStyle = (0, $ecnYn.xcss)({
    borderLeft: `1.5px solid ${"var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"}`
});
const $2d789a7ecebf6a19$var$EditCommentComponent = ({ pageId: pageId, pageType: pageType, annotationId: annotationId, commentId: commentId, spaceId: spaceId, content: content, displayCommentInViewMode: displayCommentInViewMode, isReply: isReply, isEdited: isEdited, avatarUrl: avatarUrl, date: date, createdAtNonLocalized: createdAtNonLocalized, versionByDisplayName: versionByDisplayName, versionDate: versionDate, resolveProperties: resolveProperties, displayName: displayName, mode: mode, hasMediaUploadPermissions: hasMediaUploadPermissions, isCommentsPanel: isCommentsPanel, isFooterComment: isFooterComment = false, adjustForFooterReplies: adjustForFooterReplies = false, isLastNestedFooterReply: isLastNestedFooterReply = false, onCancelEdit: onCancelEdit, getInlineNodeTypes: getInlineNodeTypes, commentType: commentType, flags: flags, isStandaloneComment: isStandaloneComment, isOffline: isOffline, isCurrentUserAnonymous: isCurrentUserAnonymous, isLastUnnestableReply: isLastUnnestableReply = false, hasParentMaxHeight: hasParentMaxHeight = false, numReplies: numReplies = 0 })=>{
    const { userId: userId, displayName: sessionDisplayName } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { isReactionsEnabled: isReactionsEnabled } = (0, $42omo.useContext)((0, $8SCD6.ReactionsContext));
    const { updateCommentBody: updateCommentBody } = (0, $8i27m.useCommentsDataActions)();
    const { commentService: commentService } = (0, $6hmtW.useCommentService)();
    const { setStoredCommentData: setStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    const { storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const commentContainerElementRef = (0, $42omo.useRef)(null);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [updateCommentFn] = (0, $308Wd.useMutationInterop)($2d789a7ecebf6a19$var$EditCommentUpdateCommentMutation, {
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "@confluence/inline-comments-common"
    });
    // Get the update function for the comments data manager
    const { updateCommentInCache: updateCommentInCache } = (0, $jbF1h.useUpdateCommentInCache)();
    const getLoadExperienceName = (type)=>type === (0, $8i27m.CommentType).GENERAL ? (0, $irVI7.EDIT_PAGE_COMMENT_LOAD_EXPERIENCE) : (0, $irVI7.EDIT_INLINE_COMMENT_LOAD_EXPERIENCE);
    const getPublishExperienceName = (type_0)=>type_0 === (0, $8i27m.CommentType).GENERAL ? (0, $irVI7.EDIT_PAGE_COMMENT_PUBLISH_EXPERIENCE) : (0, $irVI7.EDIT_INLINE_COMMENT_PUBLISH_EXPERIENCE);
    const handleOnEditorReady = ()=>{
        experienceTracker.succeed({
            name: getLoadExperienceName(commentType)
        });
    };
    const handleOnCancel = ()=>{
        displayCommentInViewMode();
        resetContentChanged();
        onCancelEdit && onCancelEdit();
    };
    const handleEditMutationFailure = (0, $42omo.useCallback)((editMutationError)=>{
        experienceTracker.stopOnError({
            name: getPublishExperienceName(commentType),
            error: editMutationError
        });
    }, [
        commentType,
        experienceTracker
    ]);
    const getTypeForCommentEditor = (0, $42omo.useCallback)(()=>{
        if (commentType === (0, $8i27m.CommentType).GENERAL && (0, $9wGTI.fg)('confluence_separate_save_comment_ufo_interaction')) return 'page';
        else return mode === 'view' ? 'inline' : 'edit-inline';
    }, [
        commentType,
        mode
    ]);
    const editCommentUpdateFn = (0, $42omo.useCallback)((_dataProxy, mutationResult)=>updateCommentInCache({
            mutationResult: mutationResult,
            commentId: commentId,
            isReply: isReply,
            updateCallback: (0, $jbF1h.updateCommentBodyInCacheCallback),
            onError: handleEditMutationFailure
        }), [
        commentId,
        handleEditMutationFailure,
        updateCommentInCache,
        isReply
    ]);
    const handleUpdateComment = (adf, onSuccess)=>{
        (0, $8Ss4E.startEditorSubExperience)({
            name: getPublishExperienceName(commentType),
            timeout: (0, $aJPUt.ExperienceTimeout).EDITOR_PUBLISH,
            attributes: {
                mode: pageMode
            }
        });
        // (Setting includeVersionFields in an if block is so Lint doesn't think we're saving or
        //  wrapping the experiment value)
        let includeVersionFields = false;
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) includeVersionFields = true;
        const adfString = JSON.stringify(adf);
        const variables = {
            input: {
                commentId: commentId,
                commentBody: {
                    value: adfString,
                    representationFormat: (0, $6640dd1dcbfb32b9$export$f4016897b165b6d5).ATLAS_DOC_FORMAT
                }
            },
            includeVersionFields: includeVersionFields
        };
        const getQuery = ()=>{
            if (isCommentsPanel || isFooterComment) return 0, $eea05c4e9d0eb879$export$9e679b96e845bbef;
            else if (isStandaloneComment) return 0, $1C8XP.ActiveInlineCommentsQuery;
            else return 0, $3B9cR.InlineCommentQuery;
        };
        const getQueryVariable = ()=>{
            if (isCommentsPanel || isFooterComment) return {
                pageId: pageId
            };
            else if (isStandaloneComment) return {
                inlineMarkerRefList: [
                    annotationId
                ],
                pageId: pageId,
                contentStatus: [
                    'DRAFT',
                    'CURRENT'
                ]
            };
            else return {
                annotationId: annotationId,
                pageId: pageId,
                contentStatus: [
                    'DRAFT',
                    'CURRENT'
                ]
            };
        };
        const isOptimisticEditEnabled = (0, $aGjYc.shouldUseCommentDraftForOptimisticSave)(getTypeForCommentEditor(), 'edit');
        // When optimistic save is active, immediately switch to view mode so the user
        // sees their edit reflected without waiting for the network. On error we revert.
        if (isOptimisticEditEnabled) {
            onSuccess();
            resetContentChanged();
            displayCommentInViewMode();
        }
        return updateCommentFn({
            variables: variables,
            optimisticResponse: isOptimisticEditEnabled ? (0, $cvKwQ.getEditCommentOptimisticResponse)({
                commentId: commentId,
                adfString: adfString,
                sessionDisplayName: sessionDisplayName
            }) : undefined,
            update: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? editCommentUpdateFn : ()=>{
                // readQuery can still return null which complicates TS lint errors with optional chaining
                // once we move to v3 of the apollo client we can move to cache.modify
                try {
                    const dataProxy = (0, $l1uFv.readQueryInterop)({
                        query: getQuery(),
                        variables: getQueryVariable(),
                        __callerPackage__: "@confluence/inline-comments-common"
                    });
                    const data = Object.assign({}, dataProxy);
                    let oldComment;
                    // Standalone only has 1 comment so use index 0
                    const idxToUpdate = isCommentsPanel || isFooterComment ? data?.comments?.nodes?.findIndex((n)=>n?.id === commentId) || -1 : 0;
                    if (idxToUpdate === -1) return;
                    // find the comment to update for a reply or the parent comment
                    if (isReply) {
                        const replies = data?.comments?.nodes?.[idxToUpdate]?.replies ?? [];
                        replies.forEach((reply)=>{
                            if (reply?.id === commentId) oldComment = reply;
                        });
                    } else oldComment = data?.comments?.nodes?.[idxToUpdate];
                    if (oldComment) {
                        (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(oldComment, 'body.value', adfString);
                        (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(oldComment, 'version.number', (oldComment.version?.number ?? 0) + 1);
                        (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(oldComment, 'version.when', new Date().toISOString());
                        (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(oldComment, 'version.by.displayName', sessionDisplayName);
                    }
                    (0, $fEmGS.writeQueryInterop)({
                        query: getQuery(),
                        variables: getQueryVariable(),
                        data: data,
                        __callerPackage__: "@confluence/inline-comments-common"
                    });
                } catch (error) {
                    $2d789a7ecebf6a19$var$logger.error`An Error occurred when updating cache for edit reply in panel or inline - ${error}`;
                }
                if (commentType === (0, $8i27m.CommentType).GENERAL) (0, $87CZC.updateFooterApolloCacheOnEdit)(commentId, adfString, pageId, isReactionsEnabled, sessionDisplayName);
            }
        }).then(()=>{
            experienceTracker.succeed({
                name: getPublishExperienceName(commentType),
                attributes: {
                    mode: pageMode,
                    type: isReply ? 'reply' : 'topLevel'
                }
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'updated',
                    actionSubject: 'comment',
                    actionSubjectId: commentId,
                    objectType: pageType,
                    objectId: pageId,
                    source: pageMode === (0, $cD1qu.PageMode).VIEW ? 'viewPageScreen' : 'editPageScreen',
                    attributes: {
                        commentType: commentType,
                        pageType: pageType,
                        source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : isFooterComment ? (0, $en1dX.AnalyticsSource).PAGE_FOOTER : (0, $en1dX.AnalyticsSource).STANDALONE,
                        pageMode: pageMode,
                        isReply: isReply,
                        navdexPointType: (0, $56QzY.END),
                        isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                        inlineNodeTypes: getInlineNodeTypes && annotationId ? getInlineNodeTypes(annotationId) : undefined
                    }
                }
            }).fire();
            if (annotationId && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) updateCommentBody(commentId, annotationId, adfString, commentType, sessionDisplayName);
            if (annotationId) // Update content types comment service if we are editing a comment
            commentService.onUpdateComment?.(annotationId, 'edit');
            // Update stored comment data with the new body value
            if (setStoredCommentData && storedCommentData) {
                if (isReply) {
                    // For replies, update the specific reply within the stored comment data
                    const replies_0 = storedCommentData.replies;
                    if (replies_0 && replies_0.length > 0) {
                        const replyIndex = replies_0.findIndex((reply_0)=>reply_0.id === commentId);
                        if (replyIndex !== -1) {
                            // Create new replies array with updated reply at specific index
                            const updatedReplies = [
                                ...replies_0
                            ];
                            const reply_1 = updatedReplies[replyIndex];
                            if (reply_1 && reply_1.version) updatedReplies[replyIndex] = {
                                ...reply_1,
                                body: {
                                    value: adfString
                                },
                                version: {
                                    ...reply_1.version,
                                    by: {
                                        ...reply_1.version.by,
                                        displayName: sessionDisplayName || reply_1.version.by?.displayName || null
                                    },
                                    number: (reply_1.version.number ?? 0) + 1,
                                    when: new Date().toISOString()
                                }
                            };
                            setStoredCommentData({
                                ...storedCommentData,
                                replies: updatedReplies
                            });
                        }
                    }
                } else // For parent comments, update the main comment data
                if (storedCommentData.version) {
                    const updatedCommentData = {
                        ...storedCommentData,
                        body: {
                            value: adfString
                        },
                        version: {
                            ...storedCommentData.version,
                            by: {
                                ...storedCommentData.version.by,
                                displayName: sessionDisplayName || storedCommentData.version.by?.displayName || null
                            },
                            number: (storedCommentData.version.number ?? 0) + 1,
                            when: new Date().toISOString()
                        }
                    };
                    setStoredCommentData(updatedCommentData);
                }
            }
            // reset the editor — skip if optimistic save already handled this immediately
            if (!isOptimisticEditEnabled) {
                onSuccess();
                resetContentChanged();
                displayCommentInViewMode();
            }
        }).catch((error_0)=>{
            const { message: message } = (0, $isdzP.parseError)(error_0);
            const translatedError = (0, $isdzP.getTranslatedError)(message, commentId);
            if ((0, $isdzP.isAlreadyDeletedError)(translatedError)) {
                flags.showWarningFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $2d789a7ecebf6a19$var$i18n.cannotEditTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), translatedError)
                });
                experienceTracker.abort({
                    name: (0, $irVI7.EDIT_INLINE_COMMENT_PUBLISH_EXPERIENCE),
                    reason: 'Comment already deleted'
                });
            }
            if ((0, $isdzP.isUnexpectedError)(translatedError)) handleEditMutationFailure(error_0);
            else // These errors will not be reported to splunk/signalfx through experience tracking as they are expected
            (0, $7Sm4c.markErrorAsHandled)(error_0);
            return Promise.reject({
                error: translatedError
            });
        });
    };
    let parsedContent = undefined;
    try {
        parsedContent = JSON.parse(content);
    } catch (e) {
        $2d789a7ecebf6a19$var$logger.error`Unable to parse content ADF, ${e}`;
    }
    const showBranchingStyle = (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? (isStandaloneComment || isCommentsPanel) && isReply : isFooterComment && isReply || (isStandaloneComment || isCommentsPanel) && isReply;
    // Create a wrapper for the editor component. If we have a branching style, the wrapper needs to use withBranchingStyle, otherwise just return as normal
    const BranchingStyleWrapper = (0, $42omo.useCallback)(({ children: children })=>{
        let customHeight = adjustForFooterReplies ? '25px' : '90px';
        let customLeft = isLastNestedFooterReply ? '-24px' : '-25px';
        if ((0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true)) {
            customHeight = '24px';
            customLeft = isLastNestedFooterReply || isLastUnnestableReply ? '-16px' : '-17px';
        } else if (isStandaloneComment || isCommentsPanel) {
            customHeight = '65px';
            customLeft = isStandaloneComment ? '-24px' : '-25px';
        } else if (isFooterComment) customLeft = '-24px';
        return showBranchingStyle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
            showDefaultStyles: true,
            customStyles: {
                // If we don't have children, line up with the author
                // If we do have children, line up with the bottom of the editor toolbar
                height: customHeight,
                left: customLeft
            }
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    }, [
        adjustForFooterReplies,
        isCommentsPanel,
        isFooterComment,
        isLastNestedFooterReply,
        isLastUnnestableReply,
        isStandaloneComment,
        showBranchingStyle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BranchingStyleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $2d789a7ecebf6a19$var$editorContainerStyle,
            (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $2d789a7ecebf6a19$var$editorContainerStyleV2,
            isCommentsPanel && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $2d789a7ecebf6a19$var$editorContainerStyleV2InlinePadding,
            isReply && !isFooterComment && !(isLastNestedFooterReply || isLastUnnestableReply) && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $2d789a7ecebf6a19$var$editorReplyRelativeLeft,
            isFooterComment && $2d789a7ecebf6a19$var$editorContainerForFooterWrapperStyle,
            isFooterComment && isReply && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $2d789a7ecebf6a19$var$editorContainerForFooterWrapperStyleV2,
            isStandaloneComment && isReply && $2d789a7ecebf6a19$var$standaloneEditorReplyContainerStyle,
            isCommentsPanel && !isReply && $2d789a7ecebf6a19$var$panelEditorParentContainerStyle,
            isCommentsPanel && !isReply && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $2d789a7ecebf6a19$var$panelEditorParentContainerStyleV2,
            (isCommentsPanel || isStandaloneComment) && isReply && $2d789a7ecebf6a19$var$panelEditorReplyContainerStyle,
            isCommentsPanel && isReply && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $2d789a7ecebf6a19$var$panelEditorReplyContainerStyleV2,
            isStandaloneComment && isReply && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $2d789a7ecebf6a19$var$standaloneEditorReplyContainerStyleV2,
            isCommentsPanel && isReply && !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $2d789a7ecebf6a19$var$adjustForBorderStyle
        ],
        "data-cy": "editor-edit-container",
        ref: commentContainerElementRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $daq5m.CommentAuthor), {
        commentMode: "edit",
        userId: userId,
        date: date,
        createdAtNonLocalized: createdAtNonLocalized,
        versionByDisplayName: versionByDisplayName,
        versionDate: versionDate,
        displayName: displayName,
        avatarUrl: avatarUrl,
        resolveProperties: resolveProperties,
        size: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? 'small' : 'medium',
        commentId: isCurrentUserAnonymous ? commentId : null,
        isCommentsPanel: isCommentsPanel,
        isGeneralComments: commentType === (0, $8i27m.CommentType).GENERAL,
        isReply: isReply,
        isEdited: isEdited,
        isFooterComment: isFooterComment,
        isStandaloneComment: isStandaloneComment
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            isFooterComment && $2d789a7ecebf6a19$var$editorBottomPaddingStyle,
            isFooterComment && adjustForFooterReplies && $2d789a7ecebf6a19$var$editorContainerForFooterExtraLeftPaddingWithBorderStyle,
            isFooterComment && adjustForFooterReplies && (0, $9wGTI.fg)('confluence_comment_border_migration') && $2d789a7ecebf6a19$var$editorContainerForFooterExtraLeftPaddingWithBorderStyleUpdated,
            isFooterComment && adjustForFooterReplies && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $2d789a7ecebf6a19$var$editorContainerForFooterExtraLeftPaddingWithBorderStyleV2,
            isStandaloneComment && !isReply && numReplies > 0 && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $2d789a7ecebf6a19$var$editorContainerForStandaloneWithRepliesStyle,
            isStandaloneComment && isReply && $2d789a7ecebf6a19$var$standaloneEditorReplyWrapperStyle,
            isStandaloneComment && isReply && !isLastUnnestableReply && !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $2d789a7ecebf6a19$var$leftBorderStyle,
            isCommentsPanel && !isReply && $2d789a7ecebf6a19$var$editorParentWrapperStyle,
            // eslint-disable-next-line confluence-feature-gating/no-preconditioning
            isCommentsPanel && !isReply && (0, $9wGTI.fg)('confluence_comment_border_migration') && $2d789a7ecebf6a19$var$editorParentWrapperStyleUpdated,
            isCommentsPanel && !isReply && numReplies === 0 && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $2d789a7ecebf6a19$var$editorParentWrapperStyleV2,
            isCommentsPanel && !isReply && numReplies > 0 && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $2d789a7ecebf6a19$var$editorParentWithRepliesWrapperStyleV2
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXzKU.LazyCommentEditor), {
        pageId: pageId,
        pageType: pageType,
        spaceId: spaceId,
        appearance: isFooterComment ? 'comment' : 'chromeless',
        EditorComponent: isFooterComment ? (0, $lesF8.CommentEditor) : (0, $7EEGh.ChromelessEditor),
        commentId: commentId,
        commentMode: "edit",
        commentType: getTypeForCommentEditor(),
        onSaveComment: handleUpdateComment,
        content: parsedContent,
        onCancelComment: handleOnCancel,
        onContentChange: onChange,
        showCancelButton: true,
        useNewWarningModal: true,
        onEditorReady: handleOnEditorReady,
        hideWatchCheckbox: true,
        pageMode: mode,
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        commentContainerElementRef: commentContainerElementRef,
        isStandaloneComment: isStandaloneComment,
        isFooterComment: isFooterComment,
        isCommentsPanel: isCommentsPanel,
        isOffline: isOffline,
        hasParentMaxHeight: hasParentMaxHeight
    }))));
};
const $2d789a7ecebf6a19$export$55ec0e499a2afded = (0, $7aRa9.withFlags)($2d789a7ecebf6a19$var$EditCommentComponent);
module.exports["EditComment"] = $2d789a7ecebf6a19$export$55ec0e499a2afded;

});

parcelRegister("kEmgx", function(module, exports) {
/* CommentBody.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable confluence-feature-gating/no-preconditioning */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $2XqLN = parcelRequire("2XqLN");


var $aXWIB = parcelRequire("aXWIB");


var $dcJ7R = parcelRequire("dcJ7R");


var $5dK2X = parcelRequire("5dK2X");


var $ecnYn = parcelRequire("ecnYn");


var $6f0Oj = parcelRequire("6f0Oj");


var $6mKj3 = parcelRequire("6mKj3");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $c6FO3 = parcelRequire("c6FO3");


var $9wGTI = parcelRequire("9wGTI");


var $8i27m = parcelRequire("8i27m");


var $kgNLQ = parcelRequire("kgNLQ");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $cAdj8 = parcelRequire("cAdj8");


var $c1UWH = parcelRequire("c1UWH");


var $d3bcC = parcelRequire("d3bcC");


var $e4kZB = parcelRequire("e4kZB");


var $9CnRS = parcelRequire("9CnRS");


var $frIzR = parcelRequire("frIzR");











var $bUlM5 = parcelRequire("bUlM5");








var $1qfLF = parcelRequire("1qfLF");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $gKvd9 = parcelRequire("gKvd9");


var $3gadb = parcelRequire("3gadb");







const $5d918c8bb7f43d99$var$expandedContentStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.150'
});
const $5d918c8bb7f43d99$export$a47b1fe1225a164 = (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { annotatedText: annotatedText } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isDanglingContentExpanded, setIsDanglingContentExpanded] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== formatMessage) {
        t1 = ()=>{
            if ((0, $9wGTI.fg)("confluence_frontend_new_dangling_comments_ux")) return formatMessage((0, $9CnRS.i18n).thisContentWasDeleted);
            return formatMessage((0, $9CnRS.i18n).contentDeleted);
        };
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    const getContentMessage = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = !(0, $9wGTI.fg)("confluence_frontend_new_dangling_comments_ux") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
            label: "",
            color: "var(--ds-icon-subtlest, #6B6E76)"
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== getContentMessage) {
        t3 = getContentMessage();
        $[3] = getContentMessage;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            gap: "space.100",
            alignItems: "center"
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            size: "small",
            maxLines: 3,
            color: (0, $9wGTI.fg)("confluence_frontend_new_dangling_comments_ux") ? "color.text" : "color.text.subtle",
            weight: (0, $9wGTI.fg)("confluence_frontend_new_dangling_comments_ux") ? "bold" : "regular"
        }, t3));
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== formatMessage || $[8] !== isDanglingContentExpanded) {
        t5 = (0, $9wGTI.fg)("confluence_frontend_new_dangling_comments_ux") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: isDanglingContentExpanded ? formatMessage((0, $9CnRS.i18n).collapseDeletedContent) : formatMessage((0, $9CnRS.i18n).viewDeletedContent)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            appearance: "subtle",
            icon: isDanglingContentExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))) : (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))),
            label: isDanglingContentExpanded ? formatMessage((0, $9CnRS.i18n).collapseDeletedContent) : formatMessage((0, $9CnRS.i18n).viewDeletedContent),
            onClick: ()=>setIsDanglingContentExpanded(!isDanglingContentExpanded),
            testId: isDanglingContentExpanded ? "dangling-content-toggle-collapse" : "dangling-content-toggle-expand",
            spacing: "compact"
        }));
        $[7] = formatMessage;
        $[8] = isDanglingContentExpanded;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t4 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            gap: "space.100",
            alignItems: "center",
            justifyContent: "space-between"
        }, t4, t5);
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== annotatedText || $[14] !== isDanglingContentExpanded) {
        t7 = isDanglingContentExpanded && (0, $9wGTI.fg)("confluence_frontend_new_dangling_comments_ux") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $5d918c8bb7f43d99$var$expandedContentStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            size: "small",
            color: "color.text.subtlest",
            maxLines: 3
        }, annotatedText));
        $[13] = annotatedText;
        $[14] = isDanglingContentExpanded;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== t6 || $[17] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, t6, t7);
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    return t8;
};



var $daq5m = parcelRequire("daq5m");


var $1Sjzs = parcelRequire("1Sjzs");




/**
 * @generated SignedSource<<25df43ed7e25e41f18199ed2c50e0fab>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8d419c1f5019bed5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useCommentActionsWriteReactionsSummaryFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "ari"
        },
        {
            "kind": "ScalarField",
            "name": "containerAri"
        },
        {
            "kind": "ScalarField",
            "name": "reactionsCount"
        },
        {
            "concreteType": "ReactionsSummaryForEmoji",
            "kind": "LinkedField",
            "name": "reactionsSummaryForEmoji",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "emojiId"
                },
                {
                    "kind": "ScalarField",
                    "name": "count"
                },
                {
                    "kind": "ScalarField",
                    "name": "reacted"
                }
            ]
        }
    ],
    "type": "ReactionsSummaryResponse"
};
$8d419c1f5019bed5$var$node.hash = "f6aafe0b5386657eb31d9d2871489adf";
var $8d419c1f5019bed5$export$2e2bcd8739ae039 = $8d419c1f5019bed5$var$node;


/**
 * @generated SignedSource<<115cde05783c8fa36dea17bee8b862f5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $45f1cc32cc5f3b88$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useCommentActionsReadReactionsSummaryFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "ari"
        },
        {
            "kind": "ScalarField",
            "name": "containerAri"
        },
        {
            "kind": "ScalarField",
            "name": "reactionsCount"
        },
        {
            "concreteType": "ReactionsSummaryForEmoji",
            "kind": "LinkedField",
            "name": "reactionsSummaryForEmoji",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "emojiId"
                },
                {
                    "kind": "ScalarField",
                    "name": "count"
                },
                {
                    "kind": "ScalarField",
                    "name": "reacted"
                }
            ]
        }
    ],
    "type": "ReactionsSummaryResponse"
};
$45f1cc32cc5f3b88$var$node.hash = "9642a68f9c63ffd5916eb7291af87c98";
var $45f1cc32cc5f3b88$export$2e2bcd8739ae039 = $45f1cc32cc5f3b88$var$node;


/**
 * @generated SignedSource<<c6a296dd25d34567e014e3a9c98131ac>>
 * @relayHash 81dcf359b30000a517e5ce087cc79e86
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b063ba228370d5fba218c9ac6f8f6f02b4a7bf51cadbab48b4ff24c5a59ed372
const $e678d3323a378731$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "contentStatus",
                    "value": [
                        "DRAFT",
                        "CURRENT"
                    ]
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "childType",
                                    "value": "comment"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "contentType",
                                    "value": "page"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "pageId",
                                    "variableName": "containerId"
                                }
                            ],
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "reactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        },
                                        v2 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCommentActionsReactionsCommentsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCommentActionsReactionsCommentsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "81dcf359b30000a517e5ce087cc79e86",
            "id": "b063ba228370d5fba218c9ac6f8f6f02b4a7bf51cadbab48b4ff24c5a59ed372",
            "metadata": {},
            "name": "useCommentActionsReactionsCommentsQuery",
            "operationKind": "query",
            "text": "query useCommentActionsReactionsCommentsQuery($contentId:ID!,$containerId:ID!){comments(commentId:$contentId,contentStatus:[DRAFT,CURRENT]){nodes{id,reactionsSummary(pageId:$containerId,contentType:\"page\",childType:\"comment\"){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$e678d3323a378731$var$node.hash = "fce76fc1c4120dae9d5f8be1dcf92955";
var $e678d3323a378731$export$2e2bcd8739ae039 = $e678d3323a378731$var$node;















var $9VJDA = parcelRequire("9VJDA");


var $cvXh8 = parcelRequire("cvXh8");


var $52EPl = parcelRequire("52EPl");


var $dAYOx = parcelRequire("dAYOx");


var $ahaN7 = parcelRequire("ahaN7");








var $3sFtD = parcelRequire("3sFtD");


var $c6fYi = parcelRequire("c6fYi");


var $1pSma = parcelRequire("1pSma");


var $eEJlK = parcelRequire("eEJlK");








var $8Ss4E = parcelRequire("8Ss4E");


var $gtj7V = parcelRequire("gtj7V");


var $4luml = parcelRequire("4luml");

/* DisabledCommentAction.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $lsxnT = parcelRequire("lsxnT");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $46066c9f9a854335$var$PopupPaddingContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ppf _bfhk1aqn _syaz15cr",
            __cmplp.className
        ])
    });
});
const $46066c9f9a854335$var$DisabledActionContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isReply: isReply, isInOverflowMenu: isInOverflowMenu, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _80omtlke _uiztglyw",
            __cmplp.isReply ? "_syazazsu" : "_syaz1rpy",
            __cmplp.isInOverflowMenu ? "_1yt4zc28" : "_ca0q1wug _u5f31wug _n3td1wug _19bv1wug",
            __cmplp.className
        ])
    });
});
const $46066c9f9a854335$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _1bsbuuw1 _uiztglyw _o5724jg8",
            __cmplp.className
        ])
    });
});
const $46066c9f9a854335$var$StyledLink = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz1oa5 _1e0c1nu9 _80omtlke _9oik1r31 _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $46066c9f9a854335$export$fa26121f031ea499 = ({ action: action, isReply: isReply, isInOverflowMenu: isInOverflowMenu })=>{
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    const [showDialog, setShowDialog] = (0, $42omo.useState)(false);
    // make the dialog visible over the dropdown menu portal
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const dropdownMenu = document.querySelector(`[data-testid="comment-overflow-menu--content"]`);
    if (dropdownMenu && dropdownMenu.style) dropdownMenu.style.overflow = 'visible';
    const toggleDialog = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        setShowDialog(!showDialog);
    }, [
        showDialog
    ]);
    const triggerReplyEditor = ()=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const textArea = document.querySelector(`[placeholder="Reply"]`);
        if (textArea) {
            textArea.focus();
            setShowDialog(false);
        }
    };
    const DialogContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46066c9f9a854335$var$Container, {
        "data-testid": "disabled-explanation-dialog"
    }, action === 'edit' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46066c9f9a854335$var$StyledLink, {
        "data-testid": "disabled-edit-action-link",
        onClick: triggerReplyEditor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "comment.no.edit.action.text",
        defaultMessage: "Add a new comment"
    })), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "comment.no.edit.reason.text",
        defaultMessage: "since this one cannot be edited; it contains content created in a legacy version of Confluence."
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "comment.no.delete.reason.text",
        defaultMessage: "You can\u2019t delete this comment because it has replies."
    }));
    const renderActionText = ()=>{
        if (action === 'edit') return isReply ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "comment.no.edit.inline.label",
            defaultMessage: "Edit is not available"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "comment.no.edit.overflow.menu.label",
            defaultMessage: "Edit"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "comment.no.delete.overflow.menu.label",
            defaultMessage: "Delete"
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Popup, {
        messageType: "transactional",
        messageId: "disabled-comment-action",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46066c9f9a854335$var$PopupPaddingContainer, null, DialogContent),
        isOpen: showDialog,
        placement: isReply ? 'bottom' : 'bottom-end',
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46066c9f9a854335$var$DisabledActionContainer, {
                "data-testid": "disabled-action-container",
                onClick: toggleDialog,
                isReply: isReply,
                isInOverflowMenu: isInOverflowMenu,
                ...triggerProps
            }, renderActionText())
    });
};






var $cMvMc = parcelRequire("cMvMc");


var $3FlVr = parcelRequire("3FlVr");


var $1NF8X = parcelRequire("1NF8X");


var $bSvtO = parcelRequire("bSvtO");


var $8SCD6 = parcelRequire("8SCD6");


var $3jwuS = parcelRequire("3jwuS");


var $9sGCn = parcelRequire("9sGCn");





var $8aF6s = parcelRequire("8aF6s");





var $aHcFH = parcelRequire("aHcFH");


var $en1dX = parcelRequire("en1dX");








var $6hmtW = parcelRequire("6hmtW");





var $dYU3e = parcelRequire("dYU3e");


var $d9uxk = parcelRequire("d9uxk");

const $38c035d26bf2ba1b$export$d9882c6824bd8ea0 = async ({ cloudId: cloudId })=>{
    if (!cloudId || !(0, $9wGTI.fg)('dlp-dlm-data-retention-policy')) return;
    return (0, $dYU3e.query)({
        query: (0, $d9uxk.default),
        variables: {
            cloudId: cloudId
        },
        errorPolicy: 'all',
        __callerPackage__: "@confluence/data-lifecycle-management"
    });
};



var $3ejfs = parcelRequire("3ejfs");


var $fFmJj = parcelRequire("fFmJj");


var $ij4CE = parcelRequire("ij4CE");


var $ad6ZE = parcelRequire("ad6ZE");


var $kmHPt = parcelRequire("kmHPt");


var $666Tc = parcelRequire("666Tc");





var $g0DaR = parcelRequire("g0DaR");


var $5U5Co = parcelRequire("5U5Co");


















var $3mVfX = parcelRequire("3mVfX");


var $i6UMJ = parcelRequire("i6UMJ");

const $c48a1b87d3790043$export$a73b7d942dfe6f4b = (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { commentId: commentId, parentCommentId: parentCommentId, isFooterComment: isFooterComment, replyToComment: replyToComment } = t0;
    const replyPressTracing = (0, $1pSma.default)("start-reply-comment-action");
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    let t1;
    if ($[0] !== hasContentChanged || $[1] !== resetContentChanged || $[2] !== showModal) {
        t1 = (replyAction)=>{
            if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged();
                    replyAction();
                }
            });
            else replyAction();
        };
        $[0] = hasContentChanged;
        $[1] = resetContentChanged;
        $[2] = showModal;
        $[3] = t1;
    } else t1 = $[3];
    const handleReplyAction = t1;
    let t2;
    if ($[4] !== commentId || $[5] !== handleReplyAction || $[6] !== isFooterComment || $[7] !== parentCommentId || $[8] !== replyPressTracing || $[9] !== replyToComment || $[10] !== setReplyToCommentId) {
        const handleReply = ()=>{
            const replyToCommentId = isFooterComment ? commentId : parentCommentId || commentId;
            handleReplyAction(()=>replyToCommentWithPressTracing(replyToCommentId));
        };
        let handleReplyWithoutMention;
        if ($[12] !== commentId || $[13] !== handleReplyAction || $[14] !== isFooterComment || $[15] !== parentCommentId || $[16] !== replyPressTracing || $[17] !== setReplyToCommentId) {
            handleReplyWithoutMention = ()=>{
                handleReplyAction(()=>replyWithPressTracing());
            };
            const replyWithPressTracing = ()=>{
                replyPressTracing();
                setReplyToCommentId({
                    parentCommentId: parentCommentId || commentId,
                    location: isFooterComment ? (0, $i6UMJ.LocationValue).FOOTER : (0, $i6UMJ.LocationValue).PANEL
                });
            };
            $[12] = commentId;
            $[13] = handleReplyAction;
            $[14] = isFooterComment;
            $[15] = parentCommentId;
            $[16] = replyPressTracing;
            $[17] = setReplyToCommentId;
            $[18] = handleReplyWithoutMention;
        } else handleReplyWithoutMention = $[18];
        const replyToCommentWithPressTracing = (replyToCommentId_0)=>{
            if (replyToComment) {
                replyPressTracing();
                replyToComment(replyToCommentId_0);
            }
        };
        t2 = {
            handleReply: handleReply,
            handleReplyWithoutMention: handleReplyWithoutMention
        };
        $[4] = commentId;
        $[5] = handleReplyAction;
        $[6] = isFooterComment;
        $[7] = parentCommentId;
        $[8] = replyPressTracing;
        $[9] = replyToComment;
        $[10] = setReplyToCommentId;
        $[11] = t2;
    } else t2 = $[11];
    return t2;
};



var $cvKwQ = parcelRequire("cvKwQ");


var $jMyy4 = parcelRequire("jMyy4");

const $68b72e61aafb20d2$var$useCommentActionsReactionsCommentsQuery = (0, $e678d3323a378731$export$2e2bcd8739ae039);
const $68b72e61aafb20d2$var$reactionBelowCommentBodyStyle = (0, $ecnYn.xcss)({
    marginTop: 'space.0'
});
const $68b72e61aafb20d2$var$itemStyles = null;
const $68b72e61aafb20d2$var$reactionInCommentPanelStyle = (0, $ecnYn.xcss)({
    paddingTop: 'space.050',
    marginLeft: 'space.200',
    paddingLeft: 'space.300',
    paddingBottom: 'space.100'
});
const $68b72e61aafb20d2$var$reactionInCommentPanelStyleV2 = (0, $ecnYn.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.100'
});
const $68b72e61aafb20d2$var$reactionInCommentPanelStyleV3 = (0, $ecnYn.xcss)({
    marginLeft: 'space.150',
    paddingTop: 'space.050',
    paddingBottom: 'space.100'
});
const $68b72e61aafb20d2$var$replyReactionInCommentPanelStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.0',
    paddingLeft: 'space.0',
    paddingTop: 'space.150',
    paddingBottom: 'space.0'
});
const $68b72e61aafb20d2$var$replyReactionInCommentPanelStyleV2 = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100',
    paddingTop: 'space.0'
});
const $68b72e61aafb20d2$var$standaloneNewDesign = (0, $ecnYn.xcss)({
    marginLeft: 'space.0'
});
const $68b72e61aafb20d2$var$withLeftBorderStyle = (0, $ecnYn.xcss)({
    borderLeft: `1.5px solid ${"var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"}`
});
const $68b72e61aafb20d2$var$withLeftBorderStyleUpdated = (0, $ecnYn.xcss)({
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"}`
});
const $68b72e61aafb20d2$var$customPaddingStyle = (0, $ecnYn.xcss)({
    paddingLeft: 'space.0'
});
const $68b72e61aafb20d2$var$multipleActionsStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    gap: 'space.150'
});
const $68b72e61aafb20d2$var$standaloneParentStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.150',
    paddingLeft: 'space.250'
});
const $68b72e61aafb20d2$var$standaloneParentWithNoRepliesStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.150',
    paddingLeft: 'space.300'
}); // As footer does not have isDangling
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $68b72e61aafb20d2$var$OverflowDisabledDropdownItem = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $dAYOx.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $68b72e61aafb20d2$var$clickableItemStyle = (0, $ecnYn.xcss)({
    cursor: 'pointer'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $68b72e61aafb20d2$var$ReplyContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_ae4v1h6o _80omtlke",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $68b72e61aafb20d2$var$ReactionsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { hasReactions: hasReactions, isCommentsPanel: isCommentsPanel, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "",
            __cmplp.hasReactions ? "_1e0c1ule" : "_1e0c116y",
            __cmplp.hasReactions ? "_i0dl1osq" : "_i0dl1wug",
            !__cmplp.isCommentsPanel && !__cmplp.hasReactions ? "_19pk1b66" : "_19pkze3t",
            !__cmplp.isCommentsPanel && !__cmplp.hasReactions ? "_18u01b66" : "_18u0ze3t",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $68b72e61aafb20d2$var$ActionItem = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "li" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2lx2vrvc _1n261q9c _1e0c116y _syazazsu _1tke1tcg _4cvr1h6o _xrwlcs5v _144bkb7n _14p1f1ug _ekv6wadc _6wjiesu3 _43ds1oa5 _1pzmusic _ep9t1b66 _5lhmtlke _1tzjf4df _8bo21mp2 _nqnuazsu _d32vazsu _nlwjglyw _49cd7g83",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $68b72e61aafb20d2$var$ActionButton = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "button" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu21kw7 _12y31o36 _syaz1kw7 _1wyb1kw7 _80omtlke _1as91r31 _j4qy8stv _1wwgnqa1 _y2mv7g83 _1bg4yh40",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $68b72e61aafb20d2$var$rightAlignedActionItemsStyle = (0, $ecnYn.xcss)({
    position: 'absolute',
    right: 'space.0',
    display: 'flex',
    gap: 'space.075',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 'space.150'
});
const $68b72e61aafb20d2$var$rightAlignedActionItemsCommentsPanelStyle = (0, $ecnYn.xcss)({
    top: 'space.0'
});
const $68b72e61aafb20d2$var$rightAlignedItemsStandaloneStyle = (0, $ecnYn.xcss)({
    top: 'space.150',
    right: 'space.200'
});
const $68b72e61aafb20d2$var$rightAlignedActionItemsFooterCommentStyle = (0, $ecnYn.xcss)({
    top: 'space.100'
});
const $68b72e61aafb20d2$var$commentsPanelActionItemsStyle = (0, $ecnYn.xcss)({
    top: 'space.050'
});
const $68b72e61aafb20d2$var$replyOrFooterActionItemsStyle = (0, $ecnYn.xcss)({
    top: 'space.150'
});
const $68b72e61aafb20d2$var$actionItemsStyle = (0, $ecnYn.xcss)({
    top: 'space.200'
});
const $68b72e61aafb20d2$var$hoveredBackgroundInSidePanel = (0, $ecnYn.xcss)({
    background: "var(--ds-surface-raised, #FFFFFF)"
});
const $68b72e61aafb20d2$var$hoveredBackgroundOutOfSidePanel = (0, $ecnYn.xcss)({
    background: "var(--ds-surface, #FFFFFF)"
});
const $68b72e61aafb20d2$var$selectedBackground = (0, $ecnYn.xcss)({
    background: "var(--ds-background-input-hovered, #F8F8F8)"
});
const $68b72e61aafb20d2$var$softBorderBase = null;
const $68b72e61aafb20d2$var$resolvedCommentActionItemsStyle = (0, $ecnYn.xcss)({
    top: 'space.100'
});
const $68b72e61aafb20d2$var$softBorderPaddingOverride = (0, $ecnYn.xcss)({
    paddingLeft: 'space.050'
});
const $68b72e61aafb20d2$export$fd00fdc8de7d175d = ({ pageId: pageId, pageType: pageType, commentId: commentId, permissions: permissions, isReply: isReply, parentCommentId: parentCommentId, restrictEdit: restrictEdit, restrictDelete: restrictDelete, deleteComment: deleteComment, editComment: editComment, resolveComment: resolveComment, mode: mode, supportedActions: supportedActions, isCommentsPanel: isCommentsPanel = false, isHovered: isHovered, annotationId: annotationId, resolveProperties: resolveProperties, reopenComment: reopenComment, replyToComment: replyToComment, inheritedReactionsData: inheritedReactionsData, reactionsCacheUpdateFn: reactionsCacheUpdateFn, commentDateUrl: commentDateUrl, isResolvedByAnotherUser: isResolvedByAnotherUser, commentType: commentType, hideBranchingStyle: hideBranchingStyle = false, canAddComments: canAddComments = true, isDeletedByAnotherUser: isDeletedByAnotherUser = false, isSelected: isSelected = false, isParentCommentOpen: isParentCommentOpen = true, isFooterComment: isFooterComment = false, isStandaloneComment: isStandaloneComment = false, isOffline: isOffline = false, numReplies: numReplies, isFabricPage: isFabricPage = true, authorName: authorName, isArchived: isArchived })=>{
    const deletePressTracing = (0, $1pSma.default)('delete-comment-action');
    const editPressTracing = (0, $1pSma.default)('start-edit-comment-action');
    const resolvePressTracing = (0, $1pSma.default)('resolve-comment-action');
    const [isDropdownOpen, setIsDropdownOpen] = (0, $42omo.useState)(false); // When tuneup is on, dropdown open counts as hovered for visibility and close logic
    const effectiveHover = (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? isHovered || isDropdownOpen : isHovered;
    const [showCommentActionItems, setShowCommentActionItems] = (0, $42omo.useState)(false);
    const [isEditable, setIsEditable] = (0, $42omo.useState)(false);
    const [isRemovable, setIsRemovable] = (0, $42omo.useState)(false);
    const [isResolvable, setIsResolvable] = (0, $42omo.useState)(false);
    const [canBeReopened, setCanBeReopened] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isReactionsEnabled: isReactionsEnabled } = (0, $42omo.useContext)((0, $8SCD6.ReactionsContext));
    const [reactionsCount, setReactionsCount] = (0, $42omo.useState)(inheritedReactionsData?.reactionsCount || 0);
    const [reactionParticleEffectByEmoji, setReactionParticleEffectByEmoji] = (0, $42omo.useState)({});
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { updateReactionsSummary: updateReactionsSummary } = (0, $8i27m.useCommentsDataActions)();
    const { handleReply: handleReply, handleReplyWithoutMention: handleReplyWithoutMention } = (0, $c48a1b87d3790043$export$a73b7d942dfe6f4b)({
        commentId: commentId,
        parentCommentId: parentCommentId,
        isFooterComment: isFooterComment,
        replyToComment: replyToComment
    });
    const readReactionsSummaryFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $45f1cc32cc5f3b88$export$2e2bcd8739ae039),
        __callerPackage__: "@confluence/inline-comments-common"
    });
    const writeReactionsSummaryFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $8d419c1f5019bed5$export$2e2bcd8739ae039),
        fragmentSpec: (0, $8d419c1f5019bed5$export$2e2bcd8739ae039),
        __callerPackage__: "@confluence/inline-comments-common"
    });
    const { updateReactionInCache: updateReactionInCache } = (0, $4luml.useUpdateReactionInCache)();
    const { edition: edition, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { commentService: commentService } = (0, $6hmtW.useCommentService)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { subType: subType } = (0, $9sGCn.getCachedPageData)(contentId);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const handleGqlError = (error)=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.VIEW_REACTIONS_EXPERIENCE),
            error: error
        });
    };
    const { data: reactionsData, loading: reactionsLoading } = (0, $jMyy4.useQueryInterop)($68b72e61aafb20d2$var$useCommentActionsReactionsCommentsQuery, {
        variables: {
            contentId: commentId,
            containerId: pageId
        },
        onError: handleGqlError,
        fetchPolicy: 'cache-and-network',
        // If we have the reactions from a higher component, skip the query
        skip: Boolean(inheritedReactionsData),
        __callerPackage__: "@confluence/inline-comments-common"
    });
    (0, $42omo.useEffect)(()=>{
        // If we have the reactions from a higher component, use that count
        const count = (inheritedReactionsData === undefined || inheritedReactionsData === null ? reactionsData?.comments?.nodes?.[0]?.reactionsSummary?.reactionsCount : inheritedReactionsData?.reactionsCount) || 0;
        setReactionsCount(count);
    }, [
        reactionsData,
        inheritedReactionsData
    ]);
    (0, $42omo.useEffect)(()=>{
        const disabledByOfflineMode = isOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false); // Actions are decided by the mode we're displaying
        // and the permissions available for the user
        const canEdit = Boolean(permissions?.isEditable && editComment && supportedActions.includes('edit') && !disabledByOfflineMode);
        const canDelete = Boolean(permissions?.isRemovable && deleteComment && supportedActions.includes('delete') && !disabledByOfflineMode);
        const canResolve = Boolean(permissions?.isResolvable && resolveComment && supportedActions.includes('resolve') && !disabledByOfflineMode); // if user doesn't have resolve comment permission then they shouldn't have reopen permission too
        const hasPermissionToReopen = reopenComment && supportedActions.includes('reopen') && permissions?.isResolvable;
        const canReopen = Boolean(hasPermissionToReopen && !isReply) && !disabledByOfflineMode; // handle reopening dangling comments
        if (resolveProperties?.resolved && resolveProperties?.isDangling) setCanBeReopened(canReopen); // handle reopening non-dangling comments
        else setCanBeReopened(Boolean(canReopen && (resolveProperties?.resolved || isResolvedByAnotherUser) && (annotationId && (0, $g0DaR.inlineCommentExists)(annotationId) || commentType === (0, $8i27m.CommentType).GENERAL)));
        if (mode === 'view' || mode === 'edit') {
            if (!isReply) setIsResolvable(canResolve); // Parent comments are resolvable if allowed
            else setIsResolvable(false); // Replies cannot be resolved
             // Comments panel is only rendered for fabric pages not on the legacy
            if (isCommentsPanel || isFabricPage) {
                const hasPermissions = canEdit || canDelete || canResolve;
                const shouldShowDropdownMenu = !!effectiveHover && hasPermissions; // Set the state for using the dropdown menu
                setShowCommentActionItems(shouldShowDropdownMenu);
            } else if (!isReply && (canEdit || canDelete || canResolve)) setShowCommentActionItems(true); // Parent comments or replies outside panel can show menu
             // Users can delete the replies they created
            setIsRemovable(canDelete);
            setIsEditable(canEdit);
        } else {
            setIsRemovable(canDelete);
            setIsEditable(canEdit);
            setIsResolvable(canResolve && !isReply);
        }
    }, [
        mode,
        permissions,
        effectiveHover,
        isReply,
        isCommentsPanel,
        supportedActions,
        deleteComment,
        editComment,
        resolveComment,
        reopenComment,
        resolveProperties?.isDangling,
        annotationId,
        resolveProperties?.resolved,
        isResolvedByAnotherUser,
        commentType,
        isOffline,
        isFabricPage
    ]);
    (0, $42omo.useEffect)(()=>{
        // If the user leaves this comment and the dropdown menu is open, close the dropdown menu so
        // they don't see it when they return
        if (isDropdownOpen && !effectiveHover) setIsDropdownOpen(false);
    }, [
        isCommentsPanel,
        isDropdownOpen,
        effectiveHover,
        setIsDropdownOpen
    ]);
    const getInlineCommentModeConstant = ()=>{
        switch(mode){
            case 'view':
                return (0, $ad6ZE.InlineCommentMode).VIEW;
            case 'edit':
                if (isLivePage) return (0, $ad6ZE.InlineCommentMode).LIVE;
                return (0, $ad6ZE.InlineCommentMode).EDIT;
        }
    };
    const handleDelete = ()=>{
        if (commentType === (0, $8i27m.CommentType).INLINE) experienceTracker.start({
            name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                mode: getInlineCommentModeConstant(),
                framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                isReply: isReply,
                source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                annotationId: annotationId
            }
        });
        else experienceTracker.start({
            name: (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE),
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                isReply: isReply
            }
        });
        showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                deleteCommentWithPressTracing();
            },
            isDelete: true,
            onCancel: ()=>{
                // abort delete experience if dialog is closed
                experienceTracker.abort({
                    name: commentType === (0, $8i27m.CommentType).INLINE ? (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE) : (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE),
                    reason: 'delete dialog closed'
                });
            }
        });
    };
    const deleteCommentWithPressTracing = ()=>{
        if (!!deleteComment) {
            deletePressTracing();
            deleteComment();
        }
    };
    const handleEditComment = ()=>{
        if (commentType === (0, $8i27m.CommentType).INLINE) (0, $8Ss4E.startEditorExperiences)(/* compoundExperience */ {
            name: (0, $irVI7.EDIT_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                mode: getInlineCommentModeConstant(),
                framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                isReply: isReply,
                type: isReply ? 'reply' : 'topLevel',
                annotationId: annotationId
            }
        }, /* editorLoadExperience */ {
            name: (0, $irVI7.EDIT_INLINE_COMMENT_LOAD_EXPERIENCE)
        }, /* editorPublishExperience */ {
            name: (0, $irVI7.EDIT_INLINE_COMMENT_PUBLISH_EXPERIENCE)
        });
        else (0, $8Ss4E.startEditorExperiences)(/* compoundExperience */ {
            name: (0, $irVI7.EDIT_PAGE_COMMENT_EXPERIENCE),
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                editor: 'FABRIC',
                isSingleExperience: true,
                edition: edition,
                type: isReply ? 'reply' : 'topLevel',
                source: isFooterComment ? (0, $en1dX.AnalyticsSource).PAGE_FOOTER : (0, $en1dX.AnalyticsSource).COMMENTS_PANEL
            }
        }, /* editorLoadExperience */ {
            name: (0, $irVI7.EDIT_PAGE_COMMENT_LOAD_EXPERIENCE)
        }, /* editorPublishExperience */ {
            name: (0, $irVI7.EDIT_PAGE_COMMENT_PUBLISH_EXPERIENCE)
        });
        editComment && editComment();
    };
    const handleEditCommentWithPressTracing = ()=>{
        editPressTracing();
        handleEditComment();
    };
    const handleCopyLink = async ()=>{
        const linkToComment = `${window.location.origin}/wiki${commentDateUrl}`;
        await (0, $aHcFH.copyToClipboard)(linkToComment);
    };
    const handleResolveComment = ()=>{
        const doResolve = ()=>{
            if (commentType === (0, $8i27m.CommentType).INLINE) experienceTracker.start({
                name: (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE),
                id: commentId,
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    mode: getInlineCommentModeConstant(),
                    framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                    annotationId: annotationId
                }
            });
            else experienceTracker.start({
                name: (0, $irVI7.RESOLVE_PAGE_COMMENT_EXPERIENCE),
                id: commentId,
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    annotationId: annotationId
                }
            });
            resolveCommentWithPressTracing();
        };
        if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                doResolve();
            }
        });
        else doResolve();
    };
    const resolveCommentWithPressTracing = ()=>{
        if (!!resolveComment) {
            resolvePressTracing();
            resolveComment();
        }
    };
    const handleReopenComment = ()=>{
        reopenComment && reopenComment();
    };
    const handleParticleEffectChange = (0, $42omo.useCallback)((emojiId, show)=>{
        setReactionParticleEffectByEmoji((prev)=>({
                ...prev,
                [emojiId]: show
            }));
    }, []);
    const renderEditAction = (isRestricted, isDropdownMenu)=>{
        if (isDropdownMenu) return isRestricted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$OverflowDisabledDropdownItem, {
            testId: "disabled-edit-comment-dropdown-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46066c9f9a854335$export$fa26121f031ea499), {
            action: "edit",
            isReply: isReply,
            isInOverflowMenu: true
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            shouldTitleWrap: !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true),
            testId: "edit-comment-dropdown-action",
            "data-cy": "edit-comment-action",
            onClick: handleEditComment,
            interactionName: "start-edit-comment-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).edit));
        return isRestricted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46066c9f9a854335$export$fa26121f031ea499), {
            action: "edit",
            isReply: isReply,
            isInOverflowMenu: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$ActionButton, {
            "data-testid": "edit-comment-action",
            "data-cy": "edit-comment-action",
            onClick: handleEditCommentWithPressTracing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).edit));
    };
    const renderDeleteAction = (isRestricted_0, isDropdownMenu_0)=>{
        if (isDropdownMenu_0) return isRestricted_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$OverflowDisabledDropdownItem, {
            testId: "disabled-delete-comment-dropdown-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46066c9f9a854335$export$fa26121f031ea499), {
            action: "delete",
            isReply: isReply,
            isInOverflowMenu: true
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            shouldTitleWrap: !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true),
            testId: "delete-comment-dropdown-action",
            onClick: handleDelete
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).delete));
        return isRestricted_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46066c9f9a854335$export$fa26121f031ea499), {
            action: "delete",
            isReply: isReply
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$ActionButton, {
            "data-testid": "delete-comment-action",
            onClick: handleDelete,
            onMouseEnter: ()=>(0, $38c035d26bf2ba1b$export$d9882c6824bd8ea0)({
                    cloudId: cloudId
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).delete));
    };
    const renderReopenComment = ()=>{
        return canBeReopened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_zulp12x7 _1e0c1txw _1bah1h6o _4cvr1h6o"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                    ...iconProps,
                    spacing: "spacious",
                    color: "var(--ds-icon-success, #6A9A23)",
                    label: formatMessage((0, $9CnRS.i18n).reopen)
                }),
            label: formatMessage((0, $9CnRS.i18n).reopen),
            isTooltipDisabled: false,
            onClick: handleReopenComment,
            appearance: "subtle",
            testId: "reopen-comment-action",
            analyticsContext: {
                attributes: {
                    name: (0, $en1dX.ActionName).REOPEN_COMMENT,
                    source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                    isDanglingComment: resolveProperties?.isDangling // all dangling comments are inline comments
                }
            }
        }));
    };
    const renderReplyAction = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$ReplyContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$ActionButton, {
            "data-testid": "reply-comment-action",
            "data-cy": "reply-comment-action",
            onClick: handleReply
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).replyPlaceholder)));
    };
    const renderCopyButton = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            shouldTitleWrap: !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true),
            testId: "copy-link-dropdown-action",
            onClick: handleCopyLink
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).copyLink));
    };
    const renderResolveOption = ()=>{
        if (isCommentsPanel && isReply) return;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            shouldTitleWrap: !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true),
            testId: "resolve-comment-dropdown-action",
            onClick: handleResolveComment
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).resolve));
    };
    const renderDropdownMenu = (editRestricted, deleteRestricted)=>{
        // hide the dropdown if not the comments panel and does not have permissions to edit/delete/resolve
        const hasNoCommmentPermissions = !isEditable && !isRemovable && (isReply || !isResolvable); // For old UI, use the existing logic
        const shouldHideDropdownForStandalone = !isCommentsPanel && hasNoCommmentPermissions;
        if (shouldHideDropdownForStandalone) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-cy": "comment-overflow-actions-menu",
            "data-testid": "comment-overflow-actions-menu"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
            strategy: "absolute",
            shouldRenderToParent: true,
            testId: "comment-overflow-menu",
            isOpen: isDropdownOpen,
            zIndex: 501,
            onOpenChange: ({ isOpen: isOpen, event: event })=>{
                event?.stopPropagation();
                setIsDropdownOpen(isOpen);
                if (isRemovable) (0, $38c035d26bf2ba1b$export$d9882c6824bd8ea0)({
                    cloudId: cloudId
                });
            },
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                    ...props,
                    ref: triggerRef,
                    testId: "comment-overflow-menu-trigger",
                    label: formatMessage((0, $9CnRS.i18n).commentActionsMenuLabel),
                    appearance: "subtle",
                    spacing: "compact",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                    isTooltipDisabled: false,
                    isSelected: isDropdownOpen,
                    analyticsContext: {
                        attributes: {
                            name: 'moreActionsButton',
                            source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                            commentType: commentType
                        }
                    }
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, isFabricPage && renderCopyButton(), !isFabricPage && !isFooterComment && isResolvable && renderResolveOption(), isEditable && renderEditAction(editRestricted, showCommentActionItems), isRemovable && renderDeleteAction(deleteRestricted, showCommentActionItems))));
    };
    const reactionsUpdateFn = (0, $42omo.useMemo)(()=>{
        if (reactionsCacheUpdateFn) return reactionsCacheUpdateFn;
        return inheritedReactionsData !== undefined && isCommentsPanel ? (emojiId_0, actionType, objectId, containerId, result, onCacheUpdateError)=>{
            // This shouldn't happen because no result means the mutation failed, but the test makes
            // TypeScript happy
            if (!result) return;
             // Update particle effect state when adding/removing reactions
            setReactionParticleEffectByEmoji((prev_0)=>({
                    ...prev_0,
                    [emojiId_0]: actionType === 'add'
                }));
            if (annotationId && emojiId_0 && actionType) // Update the reaction in the content types bridge
            commentService?.onUpdateReaction(annotationId, emojiId_0, actionType);
             // Update the GQL cache when using the new Comments Data Manager
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return updateReactionInCache({
                mutationResult: result,
                commentId: objectId,
                pageId: containerId || '',
                contentType: 'page',
                actionType: actionType,
                emojiId: emojiId_0,
                onError: onCacheUpdateError
            });
             // Manually update the legacy query cache when not using the new Comments Data Manager
            return updateReactionsSummary(emojiId_0, actionType, objectId, commentType, readReactionsSummaryFragment, writeReactionsSummaryFragment, containerId, annotationId);
        } : undefined;
    }, [
        inheritedReactionsData,
        reactionsCacheUpdateFn,
        isCommentsPanel,
        annotationId,
        commentType,
        updateReactionsSummary,
        commentService,
        readReactionsSummaryFragment,
        writeReactionsSummaryFragment,
        updateReactionInCache
    ]);
    const renderReplyButton = ()=>{
        const labelText = formatMessage((0, $9CnRS.i18n).replyPlaceholderWithName, {
            name: authorName || formatMessage((0, $3ejfs.commentsi18n).anonymous)
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: "comment-reply-button-container",
            "aria-label": labelText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            testId: "comment-reply-button",
            label: formatMessage((0, $9CnRS.i18n).replyPlaceholderWithName, {
                name: authorName || formatMessage((0, $3ejfs.commentsi18n).anonymous)
            }),
            appearance: "subtle",
            spacing: "compact",
            icon: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? (0, (/*@__PURE__*/$parcel$interopDefault($eEJlK))) : (0, (/*@__PURE__*/$parcel$interopDefault($c6fYi))),
            onClick: handleReply,
            isTooltipDisabled: false
        }));
    };
    const renderResolveActionButton = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            testId: "comment-resolve-action-item",
            label: formatMessage((0, $9CnRS.i18n).resolveThread),
            appearance: "subtle",
            spacing: "compact",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))),
            onClick: handleResolveComment,
            isTooltipDisabled: false,
            analyticsContext: {
                attributes: {
                    name: 'resolveActionsButton',
                    source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                    commentType: commentType
                }
            },
            className: (0, $gMc0m.default)([
                "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
            ])
        });
    };
    const renderReactions = ({ onlyRenderPicker: onlyRenderPicker = false, readOnly: readOnly = false } = {})=>{
        const reactionPickerPlacement = isCommentsPanel && !isFooterComment ? 'bottom-end' : 'bottom-start';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$ReactionsContainer, {
            hasReactions: reactionsCount > 0,
            isCommentsPanel: isFabricPage,
            onClick: (e)=>// Stop the click event from propagating to the outer comments container to prevent triggering the scroll-to-comment function
                e.stopPropagation(),
            "aria-label": formatMessage((0, $9CnRS.i18n).reactionAriaLabelWithName, {
                name: authorName || formatMessage((0, $3ejfs.commentsi18n).anonymous)
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1NF8X.ReactionsLoader), {
            sort: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? 'desc' : undefined,
            readOnly: readOnly,
            contentId: commentId,
            containerId: pageId,
            containerType: pageType,
            reactionPickerPlacement: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? reactionPickerPlacement : undefined,
            location: mode === 'edit' ? (0, $3FlVr.ReactionLocation).EDITOR_INLINE_COMMENT : (0, $3FlVr.ReactionLocation).INLINE_COMMENT,
            hidePlaceholder: reactionsCount === 0 || inheritedReactionsData !== undefined,
            reactionsData: inheritedReactionsData === undefined || inheritedReactionsData === null ? reactionsData?.comments?.nodes?.[0]?.reactionsSummary : inheritedReactionsData,
            updateCache: reactionsUpdateFn,
            getOptimisticResponse: (0, $cvKwQ.getOptimisticResponse),
            onlyRenderPicker: onlyRenderPicker,
            isSubtle: true,
            showAddReactionText: false,
            customAnalyticsAttributes: {
                source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                isReply: isReply,
                mode: mode
            },
            contentSubType: subType,
            isListItem: false,
            particleEffectByEmoji: reactionParticleEffectByEmoji,
            onParticleEffectChange: handleParticleEffectChange
        }));
    }; // An abstraction made by tracing through the custom xcss returned in renderActionItemsOnHover to return the correct
    // background color. When migrating to compiled, the conditional styling needs to be simplified to reduce duplication
    const getActionItemsBackgroundColor = ()=>{
        if (isCommentsPanel) {
            if (isSelected) return "var(--ds-background-input-hovered, #F8F8F8)";
            else if (effectiveHover) return "var(--ds-surface-raised, #FFFFFF)";
        }
        return "var(--ds-surface, #FFFFFF)";
    };
    const renderActionItemsOnHover = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            "data-testId": "comment-action-items",
            xcss: [
                $68b72e61aafb20d2$var$rightAlignedActionItemsStyle,
                $68b72e61aafb20d2$var$clickableItemStyle,
                effectiveHover && (isFooterComment || isStandaloneComment || !isCommentsPanel ? $68b72e61aafb20d2$var$hoveredBackgroundOutOfSidePanel : $68b72e61aafb20d2$var$hoveredBackgroundInSidePanel),
                isSelected && isCommentsPanel && $68b72e61aafb20d2$var$selectedBackground,
                isFooterComment && $68b72e61aafb20d2$var$rightAlignedActionItemsFooterCommentStyle,
                isFabricPage && !isFooterComment && $68b72e61aafb20d2$var$rightAlignedActionItemsCommentsPanelStyle,
                !isCommentsPanel && !isFooterComment && isFabricPage && $68b72e61aafb20d2$var$rightAlignedItemsStandaloneStyle,
                isCommentsPanel && isReply && $68b72e61aafb20d2$var$rightAlignedActionItemsFooterCommentStyle,
                (0, $6mKj3.expValEquals)('confluence_cohiti_comment_hover_actions', 'isEnabled', true) && $68b72e61aafb20d2$var$softBorderPaddingOverride,
                (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $68b72e61aafb20d2$var$actionItemsStyle,
                isCommentsPanel && !isReply && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $68b72e61aafb20d2$var$commentsPanelActionItemsStyle,
                (isReply || isFooterComment) && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $68b72e61aafb20d2$var$replyOrFooterActionItemsStyle,
                isStandaloneComment && !isReply && !!resolveProperties?.resolvedTime && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $68b72e61aafb20d2$var$resolvedCommentActionItemsStyle
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                boxShadow: (0, $6mKj3.expValEquals)('confluence_cohiti_comment_hover_actions', 'isEnabled', true) ? `-10px 0 10px 0px ${getActionItemsBackgroundColor()}` : ''
            },
            "data-testId": "comment-hover-actions-container",
            className: (0, $gMc0m.default)([
                "_zulp12x7 _1e0c1txw _1bah1h6o _4cvr1h6o",
                (0, $6mKj3.expValEquals)('confluence_cohiti_comment_hover_actions', 'isEnabled', true) && "_2rko12b0 _kqswh2mm _c71l1kw7"
            ])
        }, !resolveProperties?.resolved && !isResolvedByAnotherUser && (!isReply || isFooterComment || isCommentsPanel) && // Footer replies can be replied to
        !isArchived && canAddComments && renderReplyButton(), isReactionsEnabled && !reactionsLoading && !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, renderReactions({
            onlyRenderPicker: true,
            readOnly: isOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
        })), !isReply && !resolveProperties?.resolved && !isResolvedByAnotherUser && isResolvable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, renderResolveActionButton()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, renderDropdownMenu(restrictEdit, restrictDelete))));
    const renderStaticActionsItemsForCommentsPanel = ()=>{
        const isResolved = resolveProperties?.resolved || isResolvedByAnotherUser;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isResolved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $68b72e61aafb20d2$var$rightAlignedActionItemsStyle,
                isFabricPage && !isFooterComment && $68b72e61aafb20d2$var$rightAlignedActionItemsCommentsPanelStyle,
                isFooterComment && $68b72e61aafb20d2$var$rightAlignedActionItemsFooterCommentStyle
            ],
            testId: "static-actions-items"
        }, renderReopenComment()));
    };
    const getCommentsPanelActionItems = ()=>{
        const isReadOnlyForResolved = resolveProperties?.resolved || isReply && !isParentCommentOpen; // Using a function here to make sure experiment exposure is only captured when this isn't already read only by the resolved state
        const isDisabledByOfflineMode = ()=>isOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false);
        const commonElements = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isReactionsEnabled && !reactionsLoading && (reactionsCount > 0 || !isReadOnlyForResolved && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $68b72e61aafb20d2$var$reactionBelowCommentBodyStyle,
                isFabricPage && $68b72e61aafb20d2$var$reactionInCommentPanelStyle,
                isFabricPage && $68b72e61aafb20d2$var$reactionInCommentPanelStyleV2,
                isCommentsPanel && isFabricPage && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $68b72e61aafb20d2$var$reactionInCommentPanelStyleV3,
                isFabricPage && isReply && $68b72e61aafb20d2$var$replyReactionInCommentPanelStyle,
                isFabricPage && isReply && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $68b72e61aafb20d2$var$replyReactionInCommentPanelStyleV2,
                isFabricPage && !isReply && (!hideBranchingStyle && canAddComments || isReadOnlyForResolved && numReplies !== 0) && $68b72e61aafb20d2$var$withLeftBorderStyle,
                // eslint-disable-next-line confluence-feature-gating/no-preconditioning
                isFabricPage && !isReply && (!hideBranchingStyle && canAddComments || isReadOnlyForResolved && numReplies !== 0) && (0, $9wGTI.fg)('confluence_comment_border_migration') && $68b72e61aafb20d2$var$withLeftBorderStyleUpdated,
                !isCommentsPanel && isFabricPage && $68b72e61aafb20d2$var$standaloneNewDesign,
                !isCommentsPanel && !isFooterComment && hideBranchingStyle && isFabricPage && $68b72e61aafb20d2$var$customPaddingStyle,
                !isReply && numReplies === 0 && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $68b72e61aafb20d2$var$multipleActionsStyle,
                !isCommentsPanel && !isReply && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $68b72e61aafb20d2$var$standaloneParentStyle,
                !isCommentsPanel && numReplies === 0 && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $68b72e61aafb20d2$var$standaloneParentWithNoRepliesStyle
            ]
        }, !isReply && numReplies === 0 && canAddComments && isParentCommentOpen && !isStandaloneComment && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5U5Co.ReplyButton), {
            spacing: "compact",
            isOffline: isOffline,
            handleReplyButtonClick: handleReplyWithoutMention
        }), renderReactions({
            readOnly: isReadOnlyForResolved || isDisabledByOfflineMode()
        }))); // no hover state for resolved comments
        const shouldRenderHoverState = ()=>{
            if (isReply && !isParentCommentOpen) return false;
            else return effectiveHover && !resolveProperties?.resolved && !isDeletedByAnotherUser;
        };
        const stateSpecificElements = shouldRenderHoverState() ? renderActionItemsOnHover() : renderStaticActionsItemsForCommentsPanel();
        return {
            mainCommentActions: commonElements,
            hoveredActionItems: stateSpecificElements,
            isDropdownOpen: isDropdownOpen
        };
    };
    const renderStandaloneCommentActions = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.ActionsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$ActionItem, {
            "aria-hidden": "true"
        }), !isReply && isResolvable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$ActionItem, {
            mode: mode,
            isReply: isReply
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$ActionButton, {
            "data-testid": "resolve-comment-action",
            "data-cy": "resolve-comment-action",
            onClick: handleResolveComment
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).resolve))), !showCommentActionItems && isEditable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$ActionItem, {
            mode: mode,
            isReply: isReply
        }, renderEditAction(restrictEdit, showCommentActionItems)), !showCommentActionItems && isRemovable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$ActionItem, {
            mode: mode,
            isReply: isReply
        }, renderDeleteAction(restrictDelete, showCommentActionItems)), isReactionsEnabled && !reactionsLoading && !resolveProperties?.resolved && renderReactions({
            readOnly: isOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
        }), !resolveProperties?.resolved || // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        isCommentsPanel && renderReplyAction());
    };
    const renderStandaloneCommentActionItems = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !isReply && renderDropdownMenu(restrictEdit, restrictDelete), renderStandaloneCommentActions());
    };
    return isFabricPage ? getCommentsPanelActionItems() : {
        mainCommentActions: renderStandaloneCommentActionItems(),
        hoveredActionItems: null,
        isDropdownOpen: isDropdownOpen
    };
};








const $ce87683ee211df83$export$683480f191c0e3ea = ()=>{
    const $ = (0, $frIzR.c)(4);
    const [height, setHeight] = (0, $42omo.useState)(0);
    const ref = (0, $42omo.useRef)(null);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            const observeTarget = ref.current;
            const resizeObserver = new ResizeObserver((entries)=>{
                entries.forEach((entry)=>{
                    setHeight(entry.contentRect.height);
                });
            });
            if (observeTarget) {
                resizeObserver.observe(observeTarget);
                return ()=>{
                    resizeObserver.unobserve(observeTarget);
                };
            }
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $42omo.useLayoutEffect)(t0, t1);
    let t2;
    if ($[2] !== height) {
        t2 = [
            ref,
            height
        ];
        $[2] = height;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};


'use no memo';
const $c5a7cd205687b023$var$fadeOut = null;
const $c5a7cd205687b023$var$unreadIconStyle = null;
const $c5a7cd205687b023$var$unreadStyleInCommentsPanel = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5a7cd205687b023$var$CommentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCommentsTuneupActive: isCommentsTuneupActive, isFabricPage: isFabricPage, isCommentsPanel: isCommentsPanel, isRemoving: isRemoving, isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1u4c1h7": (0, $7sObp.default)((()=>{
                const horizontalSpacing = __cmplp.isCommentsTuneupActive ? "var(--ds-space-150, 12px)" : "var(--ds-space-200, 16px)";
                const padding = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                __cmplp.isFabricPage ? `${"var(--ds-space-150, 12px)"} ${horizontalSpacing} ${"var(--ds-space-0, 0px)"} ${horizontalSpacing}` : `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-200, 16px)"}`;
                const contextDependentPadding = __cmplp.isCommentsPanel === true ? 'inherit' : padding;
                return __cmplp.mode === 'view-all' ? "var(--ds-space-400, 32px)" : contextDependentPadding;
            })())
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41l4q _12ji1r31 _1qu2glyw _12y31o36 _1kl7idpf _x3doidpf _1e0c1txw _2lx21bp4 _5sag1bs3 _1o51q7pw _tip812c5 _1pglp3kn _1ragidpf _ha8h1rpy",
            __cmplp.isRemoving ? "_80om13gf" : "_80om1kw7",
            __cmplp.isFocused && !__cmplp.isCommentsPanel && "_11q715s3",
            Boolean(__cmplp.isRemoving) && "",
            Boolean(__cmplp.isRemoving) && "_y44vy8h8",
            __cmplp.className
        ])
    });
});
const $c5a7cd205687b023$var$standaloneStyle = null;
const $c5a7cd205687b023$var$standaloneCommentWithoutRepliesStyle = null;
const $c5a7cd205687b023$var$withLeftBorderStyle = null;
const $c5a7cd205687b023$var$withLeftBorderStyleUpdated = null;
const $c5a7cd205687b023$var$withLeftBorderStyleV2 = null;
const $c5a7cd205687b023$var$withoutLeftBorderStyle = null;
const $c5a7cd205687b023$var$commentBodyStyles = null;
const $c5a7cd205687b023$var$commentBodyStylesV2 = null;
const $c5a7cd205687b023$var$commentReplyStyles = null;
const $c5a7cd205687b023$var$commentBodyReplyStyles = null;
const $c5a7cd205687b023$var$commentBodyNestedReplyStyle = null;
const $c5a7cd205687b023$var$warningMessageStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    fontStyle: 'italic',
    padding: 'space.150'
});
const $c5a7cd205687b023$var$replyCommentBodyStyle = null;
const $c5a7cd205687b023$var$annotatedTextBodyStyle = (0, $ecnYn.xcss)({
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'radius.small',
    padding: 'space.200',
    width: '100%',
    backgroundColor: 'elevation.surface',
    marginBottom: 'space.150'
});
const $c5a7cd205687b023$var$danglingAnnotatedTextBodyStyle = (0, $ecnYn.xcss)({
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'radius.small',
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.200',
    paddingRight: 'space.200',
    width: '100%',
    backgroundColor: 'elevation.surface',
    marginBottom: 'space.150'
});
const $c5a7cd205687b023$var$annotatedTextBodyWithPressedStyle = (0, $ecnYn.xcss)({
    background: "var(--ds-surface-pressed, #DDDEE1)"
});
const $c5a7cd205687b023$var$dotBaseStyles = (0, $ecnYn.xcss)({
    height: "var(--ds-space-100, 8px)",
    width: "var(--ds-space-100, 8px)",
    backgroundColor: 'color.background.brand.bold',
    borderRadius: 'radius.full',
    margin: 'space.050',
    transition: 'opacity 300ms ease-in-out'
});
const $c5a7cd205687b023$var$dotVisibleStyles = (0, $ecnYn.xcss)({
    opacity: 1
});
const $c5a7cd205687b023$var$dotHiddenStyles = (0, $ecnYn.xcss)({
    opacity: 0
});
const $c5a7cd205687b023$var$replyBranchStyles = null;
const $c5a7cd205687b023$var$replyBranchStylesUpdated = null;
const $c5a7cd205687b023$var$replyBranchStylesV2 = null;
const $c5a7cd205687b023$var$footerCommentAuthorStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.100'
});
const $c5a7cd205687b023$var$replyCommentAuthorStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.050'
});
const $c5a7cd205687b023$var$parseContent = (0, $2XqLN.default)((content, experienceTracker)=>{
    if (!content?.length) return null;
    try {
        return JSON.parse(content);
    } catch (error) {
        experienceTracker.stopOnError({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            error: error,
            attributes: {
                stopPoint: 'inline-comments-common/CommentBody'
            }
        });
        return null;
    }
});
const $c5a7cd205687b023$var$STABLE_SUPPORTED_ACTIONS_DEFAULT = [
    'edit',
    'delete',
    'resolve'
];
const $c5a7cd205687b023$export$286a50103f692ed6 = ({ pageId: pageId, pageType: pageType, avatarUrl: avatarUrl, commentId: commentId, content: content, date: date, createdAt: createdAt, createdAtNonLocalized: createdAtNonLocalized, versionByDisplayName: versionByDisplayName, versionDate: versionDate, displayName: displayName, permissions: permissions, dateUrl: dateUrl, userId: userId, deleteComment: deleteComment, editComment: editComment, resolveComment: resolveComment, isReply: isReply, isEdited: isEdited, parentCommentId: parentCommentId, isFocused: isFocused, shouldScrollIntoView: _shouldScrollIntoView, isRemoving: isRemoving, numReplies: numReplies, isFabricPage: isFabricPage, isCommentActive: isCommentActive, isCurrentUserAnonymous: isCurrentUserAnonymous, mode: mode, onRendered: onRendered, shouldAutofocus: shouldAutofocus, onAutoFocused: onAutoFocused, permissionType: permissionType, maxHeight: maxHeight, fadeOutHeight: fadeOutHeight, onComplete: onComplete, supportedActions: supportedActions = $c5a7cd205687b023$var$STABLE_SUPPORTED_ACTIONS_DEFAULT, isUnread: isUnread = false, isCommentsPanel: isCommentsPanel = false, isHovered: isHovered, isResolvedByAnotherUser: isResolvedByAnotherUser = false, resolveProperties: resolveProperties, annotationId: annotationId, annotatedText: annotatedText, hideAiSuggestEdit: hideAiSuggestEdit = false, reopenComment: reopenComment, replyToComment: replyToComment, inheritedReactionsData: inheritedReactionsData, reactionsCacheUpdateFn: reactionsCacheUpdateFn, isDeletedByAnotherUser: isDeletedByAnotherUser, currentlySelectedThreadKey: currentlySelectedThreadKey, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, isAnnotatedTextPressed: isAnnotatedTextPressed, setAnnotatedTextPressed: setAnnotatedTextPressed, commentType: commentType = (0, $8i27m.CommentType).INLINE, adjustForNestedReplies: adjustForNestedReplies = false, extraReplyBranchHeight: extraReplyBranchHeight = 0, hideBranchingStyle: hideBranchingStyle = false, canAddComments: canAddComments = true, isThreadHovered: isThreadHovered, isParentCommentOpen: isParentCommentOpen, isStandalonehovered: isStandalonehovered, isFooterComment: isFooterComment = false, adjustForFooterNestedReplies: adjustForFooterNestedReplies = false, isStandaloneComment: isStandaloneComment = false, isOffline: isOffline = false, showRepliesWithCurvedBorders: showRepliesWithCurvedBorders, replyHasNestedObjects: replyHasNestedObjects = false, contributors: contributors })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [hasFallbackContent, setHasFallbackContent] = (0, $42omo.useState)(false);
    const [isHoveredLocal, setIsHoveredLocal] = (0, $42omo.useState)(false);
    const isMouseOverContainerRef = (0, $42omo.useRef)(false);
    const isSelected = currentlySelectedThreadKey === annotationId && !isStandalonehovered;
    const [contentType] = (0, $ep3mz.useContentType)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [containerRef, replyBranchHeight] = (0, $ce87683ee211df83$export$683480f191c0e3ea)(); // Track the currently observed element for cleanup
    const [observedElement, setObservedElement] = (0, $42omo.useState)(null);
    const { getViewedCommentsCacheOnly: getViewedCommentsCacheOnly } = (0, $d3bcC.useViewedComments)({
        pageId: pageId || ''
    });
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)(); // Create a ref callback to set the ref and observe when the DOM element is available
    const handleUnreadCommentRef = (0, $42omo.useCallback)((node)=>{
        // isUnread comes from unreadCommentIDSet and doesn't contain dangling and resolved, we're only using that for the unread indicators
        // for observing unread comments, we'll rely on the viewedComments set as the source of truth
        const viewedCommentsResult = getViewedCommentsCacheOnly();
        const viewedComments = viewedCommentsResult.success && viewedCommentsResult.data ? viewedCommentsResult.data : new Set();
        const commentForValidation = (0, $e4kZB.buildValidationObjectFromProps)({
            commentId: commentId,
            userId: userId,
            createdAt: createdAt,
            commentType: commentType === (0, $8i27m.CommentType).INLINE ? 'INLINE' : 'FOOTER',
            resolveProperties: {
                resolved: false
            } // overriding resolveProperties since we still want to observe resolved comments for unread
        });
        const isValidUnread = (0, $e4kZB.isValidUnreadComment)({
            comment: commentForValidation,
            currentUserId: currentUserId || '',
            viewedComments: viewedComments
        });
        const shouldObserve = node && isValidUnread;
        if (shouldObserve) {
            const observer = (0, $c1UWH.getUnreadCommentsIntersectionObserver)();
            observer.observeComment(node);
            setObservedElement(node);
        } else // If we shouldn't observe this node, clear the observed element
        setObservedElement(null);
    }, [
        commentId,
        userId,
        createdAt,
        commentType,
        getViewedCommentsCacheOnly,
        currentUserId
    ]);
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)();
    const isArchived = pageInfo?.status === 'archived';
    const { mainCommentActions: mainCommentActions, hoveredActionItems: hoveredActionItems, isDropdownOpen: isDropdownOpen } = (0, $68b72e61aafb20d2$export$fd00fdc8de7d175d)({
        pageId: pageId,
        pageType: pageType,
        commentId: commentId,
        permissions: permissions,
        isReply: isReply,
        parentCommentId: parentCommentId,
        deleteComment: deleteComment,
        editComment: editComment,
        resolveComment: resolveComment,
        restrictEdit: hasFallbackContent,
        restrictDelete: Boolean(numReplies),
        numReplies: numReplies,
        mode: mode,
        commentDateUrl: dateUrl,
        supportedActions: supportedActions,
        isCommentsPanel: isCommentsPanel,
        isHovered: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? isHoveredLocal : isHovered ?? false,
        annotationId: annotationId,
        resolveProperties: resolveProperties,
        reopenComment: reopenComment,
        replyToComment: replyToComment,
        inheritedReactionsData: inheritedReactionsData,
        reactionsCacheUpdateFn: reactionsCacheUpdateFn,
        isResolvedByAnotherUser: isResolvedByAnotherUser,
        commentType: commentType,
        hideBranchingStyle: hideBranchingStyle,
        canAddComments: canAddComments,
        isDeletedByAnotherUser: isDeletedByAnotherUser,
        isSelected: isSelected,
        isParentCommentOpen: isParentCommentOpen,
        isFooterComment: isFooterComment,
        isStandaloneComment: isStandaloneComment,
        isOffline: isOffline,
        isFabricPage: isFabricPage,
        isArchived: isArchived,
        authorName: displayName
    });
    const isHoveredComment = (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? isHoveredLocal || isDropdownOpen : isHovered ?? false;
    const adf = $c5a7cd205687b023$var$parseContent(content, experienceTracker);
    (0, $42omo.useEffect)(()=>{
        if (shouldAutofocus) {
            containerRef.current && containerRef.current.focus({
                preventScroll: true
            });
            onAutoFocused && onAutoFocused();
        }
    }, [
        containerRef,
        shouldAutofocus,
        onAutoFocused
    ]); // clean up the observer when the component unmounts
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (observedElement) {
                const observer_0 = (0, $c1UWH.getUnreadCommentsIntersectionObserver)();
                observer_0.unobserveComment(observedElement);
            }
        };
    }, [
        observedElement
    ]);
    const onCommentContentFallback = (0, $42omo.useCallback)(()=>setHasFallbackContent(true), []);
    const handleMouseEventOnWrapper = (eventType)=>()=>{
            isMouseOverContainerRef.current = eventType === 'enter';
            if ((0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true)) {
                if (commentId !== (0, $kgNLQ.OPTIMISTIC_SAVE_COMMENT_ID) || !(0, $6mKj3.expValEquals)('confluence_fe_no_hover_actions_on_optimistic_save', 'isEnabled', true)) setIsHoveredLocal(eventType === 'enter');
            }
        };
    const shouldShowOverflowMenu = supportedActions.length > 0;
    const showDefaultReplyStyle = showRepliesWithCurvedBorders ?? (isCommentsPanel && isReply);
    const getHighlightBackgroundColor = ()=>{
        if (isAnnotatedTextPressed) return "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)";
        if (isSelected) return "var(--ds-background-accent-yellow-subtle, #EED12B)";
        if (isThreadHovered) return "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)";
        return 'inherit';
    };
    const handleMouseUp = ()=>{
        if (annotationId && setCurrentlySelectedThreadKey) setAnnotatedTextPressed && setAnnotatedTextPressed(false);
    };
    const shouldShowCommentContentContext = annotatedText && isCommentsPanel && !isReply;
    const showContentUnavailableForDanglingComment = resolveProperties?.isDangling;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c5a7cd205687b023$var$CommentContainer, {
        ref: containerRef,
        "data-comment-id": commentId,
        "data-testid": commentId,
        isFocused: isFocused,
        isRemoving: isRemoving,
        mode: mode,
        isCommentsPanel: isCommentsPanel,
        role: "article",
        tabIndex: -1,
        onMouseEnter: handleMouseEventOnWrapper('enter'),
        onMouseLeave: handleMouseEventOnWrapper('leave'),
        onFocusCapture: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? ()=>{
            if (commentId !== (0, $kgNLQ.OPTIMISTIC_SAVE_COMMENT_ID) || !(0, $6mKj3.expValEquals)('confluence_fe_no_hover_actions_on_optimistic_save', 'isEnabled', true)) setIsHoveredLocal(true);
        } : undefined,
        onBlurCapture: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? (e)=>{
            const next = e.relatedTarget;
            const container = e.currentTarget;
            if (next && container.contains(next)) return; // Only clear hover when focus leaves if the mouse has left too – mouse takes precedence
            if (!isMouseOverContainerRef.current) setIsHoveredLocal(false);
        } : undefined,
        isFabricPage: isFabricPage,
        isCommentsTuneupActive: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true),
        className: (0, $gMc0m.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: handleUnreadCommentRef,
        "data-comment-id": commentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // We need to adjust the size of the border if we have a nested reply scroller below this
    , {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: !hideBranchingStyle ? {
            '--replyBranchHeight': `${replyBranchHeight + (adjustForNestedReplies ? 53 : 0) + extraReplyBranchHeight}px`
        } : {},
        className: (0, $gMc0m.default)([
            isReply && isCommentsPanel && !hideBranchingStyle && "_kqswh2mm _1n1j11qs _1kt9b3bt _1cs8stnw _qnec2bgk _1auk7vkz _kfgt1q5s _19wo1ul9 _syaypxbi",
            isReply && isCommentsPanel && !hideBranchingStyle && (0, $9wGTI.fg)('confluence_comment_border_migration') && "_kqswh2mm _1n1j1h4i _1kt9b3bt _1cs8stnw _qnec2bgk _1auk7vkz _kfgt1q5s _19wo1ul9 _syaypxbi",
            isReply && isCommentsPanel && !hideBranchingStyle && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_qnec1h22"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
        showDefaultStyles: showDefaultReplyStyle,
        customStyles: {
            ...isCommentsPanel ? {
                height: '28px'
            } : {},
            // Have to adjust for padding on author (vs reply thread parent) with flag on
            ...isFooterComment ? {
                height: '25px'
            } : {},
            // Accounts for additional padding added to the author
            ...adjustForFooterNestedReplies ? {
                left: '-25px'
            } : {},
            // Accounts for the left border of the parent comment
            ...(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? {
                left: '-16px',
                height: '24px'
            } : {}
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            isFooterComment || isCommentsPanel && isReply ? $c5a7cd205687b023$var$footerCommentAuthorStyles : undefined,
            isCommentsPanel && isReply && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $c5a7cd205687b023$var$replyCommentAuthorStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        testId: "comment-author-box",
        spread: "space-between",
        alignBlock: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? 'center' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $daq5m.CommentAuthor), {
        commentMode: "view",
        userId: userId,
        date: date,
        createdAtNonLocalized: createdAtNonLocalized,
        versionByDisplayName: versionByDisplayName,
        versionDate: versionDate,
        displayName: displayName,
        avatarUrl: avatarUrl,
        commentId: isCurrentUserAnonymous ? commentId : null,
        permissionType: permissionType,
        isInactiveComment: Boolean(mode === 'view-all' && !isCommentActive),
        contributors: contributors,
        resolveProperties: resolveProperties,
        size: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? 'small' : 'medium',
        isCommentsPanel: isCommentsPanel,
        isGeneralComments: commentType === (0, $8i27m.CommentType).GENERAL,
        isReply: isReply,
        isEdited: isEdited,
        isFooterComment: isFooterComment,
        isStandaloneComment: isStandaloneComment
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": `unread-comment-indicator-${commentId}`,
        // and the layout is recalculated, so we're using css to hide it instead
        style: {
            visibility: isHoveredComment ? 'hidden' : 'visible'
        },
        "aria-hidden": isHoveredComment || !isUnread,
        className: (0, $gMc0m.default)([
            !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_ca0q1b66",
            isCommentsPanel && !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_kqswh2mm _154iv77o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $c5a7cd205687b023$var$dotBaseStyles,
            isUnread ? $c5a7cd205687b023$var$dotVisibleStyles : $c5a7cd205687b023$var$dotHiddenStyles
        ]
    })))))), shouldShowOverflowMenu && hoveredActionItems, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            isCommentsPanel && "_19pkutpp _18u0pxbi _19bv1ejb _u5f31b66",
            isCommentsPanel && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_19pku2gc _18u0utpp",
            isCommentsPanel && isReply && "_18u0ze3t _19bvze3t",
            isCommentsPanel && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_n3tdu2gc",
            isCommentsPanel && !isReply && !hideBranchingStyle && (numReplies !== 0 || canAddComments) && "_1kl711qs _n3tdu2gc",
            isCommentsPanel && !isReply && !hideBranchingStyle && (numReplies !== 0 || canAddComments) && (0, $9wGTI.fg)('confluence_comment_border_migration') && "_1kl71h4i _n3tdu2gc",
            isStandaloneComment && !isReply && !hideBranchingStyle && (numReplies !== 0 || canAddComments) && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_1kl71h4i _19bvv47k _n3tdze3t",
            isFooterComment && isReply && "_19pku2gc",
            isFooterComment && isReply && replyHasNestedObjects && "_18u0u2gc",
            isStandaloneComment && isReply && "_19pku2gc",
            isCommentsPanel && isReply && "_19pku2gc",
            !isCommentsPanel && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_18u0utpp",
            !isCommentsPanel && numReplies === 0 && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_19bv1ejb"
        ])
    }, shouldShowCommentContentContext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, contentType !== 'database' && contentType !== 'slide' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.150",
        alignBlock: "center",
        testId: "highlight-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        "data-testId": "annotated-section-for-inlineComment",
        xcss: [
            showContentUnavailableForDanglingComment && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux') ? $c5a7cd205687b023$var$danglingAnnotatedTextBodyStyle : $c5a7cd205687b023$var$annotatedTextBodyStyle,
            !isResolvedByAnotherUser && isAnnotatedTextPressed && !showContentUnavailableForDanglingComment && $c5a7cd205687b023$var$annotatedTextBodyWithPressedStyle
        ],
        onMouseDown: ()=>{
            if (annotationId) setAnnotatedTextPressed && setAnnotatedTextPressed(true);
        },
        onMouseUp: handleMouseUp
    }, showContentUnavailableForDanglingComment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5d918c8bb7f43d99$export$a47b1fe1225a164), {
        annotatedText: annotatedText
    }) : annotatedText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small",
        maxLines: 3
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        style: {
            background: getHighlightBackgroundColor(),
            borderBottom: isAnnotatedTextPressed || isSelected || isThreadHovered ? `2px solid ${"var(--ds-icon-accent-yellow, #B38600)"}` : ''
        }
    }, annotatedText))))), adf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            isCommentsPanel && isReply && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_19bvu2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c6FO3.CommentRenderer), {
        commentId: commentId,
        adf: adf,
        onContentFallback: onCommentContentFallback,
        isTruncatedContent: mode === 'view-all' && !isCommentActive,
        onRendered: onRendered,
        onComplete: onComplete,
        maxHeight: maxHeight,
        fadeOutHeight: fadeOutHeight,
        isInlineComment: true,
        isCommentsPanel: isCommentsPanel,
        isEdited: isEdited,
        versionByDisplayName: versionByDisplayName,
        versionDate: versionDate,
        commentType: commentType,
        annotationId: annotationId,
        annotatedText: annotatedText ?? undefined,
        hideAiSuggestEdit: hideAiSuggestEdit,
        isReply: isReply
    })), isDeletedByAnotherUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $c5a7cd205687b023$var$warningMessageStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        weight: "bold"
    }, formatMessage((0, $9CnRS.i18n).deletedCommentActionLabel))))), shouldShowOverflowMenu && mainCommentActions));
};
module.exports["CommentBody"] = $c5a7cd205687b023$export$286a50103f692ed6;

});

parcelRegister("cTi4A", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cc83db68e6b20fd7$export$252468a40935f116 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "pK0Yb",
    name: "AvatarWithActionButtonAsync",
    loader: async ()=>(await (parcelRequire("7pjDo"))).AvatarWithActionButton
});
module.exports["AvatarWithActionButtonAsync"] = $cc83db68e6b20fd7$export$252468a40935f116;

});

parcelRegister("7pjDo", function(module, exports) {

let $564a192bbe49208d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $564a192bbe49208d$var$load("6wr18"),
    $564a192bbe49208d$var$load("ffEVr"),
    $564a192bbe49208d$var$load("7WH29")
]).then(()=>parcelRequire('iriC4'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("mzXSs", function(module, exports) {
/**
 * @generated SignedSource<<113d5941bdbe758a6c86b90d1a918541>>
 * @relayHash a5eca063ad29243565328e156e2cec22
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 28685f8ed3a81c39e524cd202fdbe2ebcf3caad6e330eebf0196b4d2a6472b75
const $848ce48367e3d60c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "conversationId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "conversationId",
                    "variableName": "conversationId"
                }
            ],
            "kind": "LinkedField",
            "name": "convoai_onAgentSessionUpdate",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "messageTemplate"
                        }
                    ],
                    "type": "ConvoAiTraceMessage"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "role"
                        },
                        {
                            "concreteType": "ConvoAiAgentAction",
                            "kind": "LinkedField",
                            "name": "actions",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ],
                    "type": "ConvoAiConversationMessage"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": "errorMessageTemplate",
                            "kind": "ScalarField",
                            "name": "messageTemplate"
                        }
                    ],
                    "type": "ConvoAiErrorMessage"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCommentAgentSessionStatusSubscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCommentAgentSessionStatusSubscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a5eca063ad29243565328e156e2cec22",
            "id": "28685f8ed3a81c39e524cd202fdbe2ebcf3caad6e330eebf0196b4d2a6472b75",
            "metadata": {},
            "name": "useCommentAgentSessionStatusSubscription",
            "operationKind": "subscription",
            "text": "subscription useCommentAgentSessionStatusSubscription($cloudId:ID!,$conversationId:ID!){convoai_onAgentSessionUpdate(cloudId:$cloudId,conversationId:$conversationId)@optIn(to:\"ConvoAiAgentSessionUpdate\"){__typename,...on ConvoAiTraceMessage{messageTemplate},...on ConvoAiConversationMessage{role,actions{key}},...on ConvoAiErrorMessage{errorMessageTemplate:messageTemplate}}}"
        }
    };
}();
$848ce48367e3d60c$var$node.hash = "3ac36cfd8a0cf83161bbc8f3293a6bbb";
var $848ce48367e3d60c$export$2e2bcd8739ae039 = $848ce48367e3d60c$var$node;



var $42omo = parcelRequire("42omo");


var $fD0Uz = parcelRequire("fD0Uz");


var $bQm3c = parcelRequire("bQm3c");

/**
 * Live status subscription for a single comment's agent conversation.
 *
 * This is an *observe-only* channel: it streams session-status updates for the given
 * conversation without competing with the conversation's own message stream (owned by the
 * open CwR sidebar right after a mention) — which is what made a direct POST to the chat
 * `message/stream/sse` endpoint unreliable for freshly-mentioned agents.
 *
 * The union member's `__typename` drives our ConversationState:
 *   - ConvoAiTraceMessage                                  → WORKING
 *   - ConvoAiConversationMessage (ASSISTANT, has actions)  → INPUT_REQUIRED
 *   - ConvoAiConversationMessage (ASSISTANT, no actions)   → ARTEFACT_READY
 *   - ConvoAiErrorMessage                                  → FAILED
 *   - ConvoAiEmptyConversation / other                     → ignored
 *
 * Modelled on jira-ai/agent-stack-unconnected's AgentSessionStatusSubscription. Defined inline
 * (not a separate module) per graphql-relay-compat/no-import-relay-graphql-operations.
 */ const $738882cc71046357$var$CommentAgentSessionStatusSubscription = (0, $848ce48367e3d60c$export$2e2bcd8739ae039);
// Snapshot states for which the agent's turn has genuinely ended, so there is nothing left to
// stream — we surface the snapshot directly and skip opening a live subscription (a perf win on
// page load, where most sessions are already settled).
//
// INPUT_REQUIRED is deliberately excluded: it is NOT terminal — it means the agent is paused
// waiting for the user. When the user replies (via the Rovo sidebar) the conversation resumes
// with fresh WORKING → ARTEFACT_READY messages, so the subscription must stay open to receive
// them. Treating it as terminal would freeze the badge on "Waiting for your input" for the
// rest of the session.
const $738882cc71046357$var$TERMINAL_STATES = new Set([
    'ARTEFACT_READY',
    'FAILED'
]);
/**
 * Maps a single `convoai_onAgentSessionUpdate` message to a ConversationState, or null when
 * the message carries no status signal (and should be ignored).
 *
 * Only an explicit `ConvoAiErrorMessage` maps to FAILED — transport/connection problems are
 * handled by the subscription layer and never surface as a (false) chat failure here.
 */ function $738882cc71046357$var$mapMessageToState(message) {
    switch(message?.__typename){
        case 'ConvoAiTraceMessage':
            return 'WORKING';
        case 'ConvoAiConversationMessage':
            // Only assistant messages reflect agent progress.
            if (message.role !== 'ASSISTANT') return null;
            // Pending actions mean the user has to respond; otherwise the result is ready.
            return message.actions && message.actions.length > 0 ? 'INPUT_REQUIRED' : 'ARTEFACT_READY';
        case 'ConvoAiErrorMessage':
            return 'FAILED';
        default:
            // ConvoAiEmptyConversation and any future/unknown member: no status change.
            return null;
    }
}
function $738882cc71046357$export$9d176b0fd4eccbae(_commentId, conversationId, initialState) {
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    // Live status observed from the subscription. null until a message arrives. We never set
    // this from a transport/connection error — only an explicit ConvoAiErrorMessage maps to
    // FAILED — so a transient blip is never mistaken for a failed chat.
    const [streamState, setStreamState] = (0, $42omo.useState)(null);
    // Reset observed state when the conversation changes, so a comment never briefly shows a
    // previous conversation's status.
    (0, $42omo.useEffect)(()=>{
        setStreamState(null);
    }, [
        conversationId
    ]);
    // Skip the subscription when there is nothing to observe, or when the backend snapshot is
    // already terminal (the agent finished in a prior session — show the snapshot directly).
    const snapshotIsTerminal = !!initialState && $738882cc71046357$var$TERMINAL_STATES.has(initialState);
    const skip = !cloudId || !conversationId || snapshotIsTerminal;
    (0, $fD0Uz.useSubscriptionInterop)($738882cc71046357$var$CommentAgentSessionStatusSubscription, {
        skip: skip,
        variables: {
            cloudId: cloudId ?? '',
            conversationId: conversationId ?? ''
        },
        onSubscriptionData: ({ subscriptionData: subscriptionData })=>{
            const next = $738882cc71046357$var$mapMessageToState(subscriptionData.data?.convoai_onAgentSessionUpdate);
            if (next) setStreamState(next);
        },
        __callerPackage__: "@confluence/agent-mention"
    });
    // Prefer the live subscription status, fall back to the backend snapshot, and finally to
    // WORKING while a conversation exists but has not reported a status yet.
    const state = streamState ?? initialState ?? (conversationId ? 'WORKING' : null);
    return {
        state: state,
        conversationId: conversationId
    };
}
module.exports["useCommentAgentSession"] = $738882cc71046357$export$9d176b0fd4eccbae;

});

parcelRegister("cHfPA", function(module, exports) {
const $c134991374be4fd0$export$bb41af86c5f312f1 = (comment)=>typeof comment === 'object' && comment !== null && 'contributors' in comment;
module.exports["hasContributors"] = $c134991374be4fd0$export$bb41af86c5f312f1;

});

parcelRegister("zkUcd", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $21K7m = parcelRequire("21K7m");


var $irVI7 = parcelRequire("irVI7");


var $24amZ = parcelRequire("24amZ");


var $3mVfX = parcelRequire("3mVfX");


var $8i27m = parcelRequire("8i27m");


var $7W8i8 = parcelRequire("7W8i8");


var $9FoVw = parcelRequire("9FoVw");


var $6mKj3 = parcelRequire("6mKj3");


var $9CnRS = parcelRequire("9CnRS");

const $6153444078ddb7dc$var$inlineReactionsI18n = (0, $aXWIB.defineMessages)({
    resolvedFlagText: {
        id: "inline-comments-common.reaction.resolved.flag.text",
        defaultMessage: "Reaction resolved"
    },
    goToReactionCTA: {
        id: "inline-comments-common.reaction.reopened.flag.cta.gotoreaction",
        defaultMessage: "Go to reaction"
    },
    undoCTA: {
        id: "inline-comments-common.reaction.reopened.flag.cta.undo",
        defaultMessage: "Undo"
    }
});
const $6153444078ddb7dc$var$logger = (0, $7W8i8.getLogger)('annotation-provider-inline-comment');
const $6153444078ddb7dc$export$ddce50f11b36de55 = (dependencies)=>{
    const { reopenInlineCommentFn: reopenInlineCommentFn, getUpdateFn: getUpdateFn, commentId: commentId, annotationId: annotationId, reopenParentComment: reopenParentComment, setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, highlightReopenedComment: highlightReopenedComment, onReopen: onReopen, isEditor: isEditor, eventEmitter: eventEmitter, setActiveHighlight: setActiveHighlight, experienceTracker: experienceTracker, isInlineReaction: isInlineReaction } = dependencies;
    const unresolveExperienceName = isInlineReaction ? (0, $irVI7.UNRESOLVE_INLINE_REACTION_EXPERIENCE) : (0, $irVI7.UNRESOLVE_INLINE_COMMENT_EXPERIENCE);
    return ()=>{
        return reopenInlineCommentFn({
            variables: {
                commentId: commentId,
                resolved: false
            },
            update: getUpdateFn?.((cacheError)=>{
                experienceTracker.stopOnError({
                    name: unresolveExperienceName,
                    error: cacheError
                });
            })
        }).then(()=>{
            reopenParentComment({
                threadKey: annotationId,
                commentType: (0, $8i27m.CommentType).INLINE,
                parentCommentId: commentId
            });
            setOrderedActiveAnnotationIdList([
                ...orderedActiveAnnotationIdList.map((status)=>status.threadKey),
                annotationId
            ]);
            highlightReopenedComment(annotationId);
            // Roll back caller-side optimistic state (e.g. optimisticResolvedMarkerRefs)
            // so the annotation highlight reappears after a successful Undo.
            onReopen?.();
            if (isEditor) {
                eventEmitter.emit('unresolve', annotationId);
                eventEmitter.emit('setselectedannotation', annotationId);
            } else {
                // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                const commentElement = document.getElementById(annotationId);
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                    annotationIds: [
                        annotationId
                    ],
                    eventTarget: commentElement
                });
                setActiveHighlight(annotationId);
            }
            experienceTracker.succeed({
                name: unresolveExperienceName
            });
        }).catch((err)=>{
            $6153444078ddb7dc$var$logger.error`An error occurred when reopening a comment ${err}`;
            experienceTracker.stopOnError({
                name: unresolveExperienceName,
                error: err
            });
        });
    };
};
const $6153444078ddb7dc$export$c71830b449cacdd = ({ commentId: commentId, experienceTracker: experienceTracker, flags: flags, mode: mode, annotationId: annotationId, handleReopenComment: handleReopenComment, formatMessage: formatMessage, showCommentsPanel: showCommentsPanel, setCurrentView: setCurrentView, isCommentsPanelShown: isCommentsPanelShown, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, isInlineReaction: isInlineReaction })=>{
    flags?.showSuccessCircleFlag({
        id: commentId,
        title: formatMessage(isInlineReaction ? $6153444078ddb7dc$var$inlineReactionsI18n.resolvedFlagText : (0, $9CnRS.i18n).resolvedFlagText),
        isAutoDismiss: true,
        actions: [
            {
                content: formatMessage(isInlineReaction ? $6153444078ddb7dc$var$inlineReactionsI18n.goToReactionCTA : (0, $9CnRS.i18n).goToCommentCTA),
                onClick: ()=>{
                    if (!isCommentsPanelShown) {
                        setCurrentlySelectedThreadKey(annotationId);
                        showCommentsPanel({
                            openWithView: (0, $3mVfX.ViewValues).RESOLVED
                        });
                    } else setCurrentView((0, $3mVfX.ViewValues).RESOLVED);
                    if ((0, $6mKj3.expValEquals)('confluence_comments_scrollto_resolve', 'isEnabled', true)) (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                        scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                        context: (0, $9FoVw.NavigationContext).PANEL,
                        block: 'center',
                        annotationId: annotationId,
                        commentType: 'INLINE',
                        annotationClicked: true,
                        expectedView: (0, $3mVfX.ViewValues).RESOLVED
                    });
                    flags.hideFlag(flags.state.flags[0]?.id);
                }
            },
            {
                content: formatMessage(isInlineReaction ? $6153444078ddb7dc$var$inlineReactionsI18n.undoCTA : (0, $9CnRS.i18n).undoCTA),
                onClick: ()=>{
                    experienceTracker.start({
                        name: isInlineReaction ? (0, $irVI7.UNRESOLVE_INLINE_REACTION_EXPERIENCE) : (0, $irVI7.UNRESOLVE_INLINE_COMMENT_EXPERIENCE),
                        id: commentId,
                        attributes: {
                            mode: mode,
                            framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                            annotationId: annotationId
                        }
                    });
                    handleReopenComment();
                    flags.hideFlag(flags.state.flags[0]?.id);
                }
            }
        ]
    });
};
module.exports["createHandleReopenComment"] = $6153444078ddb7dc$export$ddce50f11b36de55;
module.exports["showResolvedCommentFlag"] = $6153444078ddb7dc$export$c71830b449cacdd;

});

parcelRegister("h3RCY", function(module, exports) {
/**
 * @generated SignedSource<<6875765df09ca4798a4e0be95ca73743>>
 * @relayHash 7513d6c5923d1609915a8367260c74ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 632c56bba03c212eda7bcb6a40acb5c811be32c9f70880d703b72d84fe6cafdf
const $ffa2a1db328a73be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "resolved"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "commentId"
                },
                {
                    "kind": "Literal",
                    "name": "dangling",
                    "value": false
                },
                {
                    "kind": "Variable",
                    "name": "resolved",
                    "variableName": "resolved"
                }
            ],
            "concreteType": "ResolveInlineCommentPayload",
            "kind": "LinkedField",
            "name": "resolveInlineComment",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "concreteType": "InlineCommentResolveProperties",
                    "kind": "LinkedField",
                    "name": "resolveProperties",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resolved"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "resolvedUser"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isDangling"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "resolvedFriendlyDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "resolvedTime"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ResolveInlineCommentMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ResolveInlineCommentMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7513d6c5923d1609915a8367260c74ea",
            "id": "632c56bba03c212eda7bcb6a40acb5c811be32c9f70880d703b72d84fe6cafdf",
            "metadata": {},
            "name": "ResolveInlineCommentMutation",
            "operationKind": "mutation",
            "text": "mutation ResolveInlineCommentMutation($commentId:ID!,$resolved:Boolean!){resolveInlineComment(commentId:$commentId,resolved:$resolved,dangling:false){status,resolveProperties{resolved,resolvedUser,isDangling,resolvedFriendlyDate,resolvedTime}}}"
        }
    };
}();
$ffa2a1db328a73be$var$node.hash = "9130df4a8889632221ebe5fe5a847d62";
var $ffa2a1db328a73be$export$2e2bcd8739ae039 = $ffa2a1db328a73be$var$node;
module.exports["default"] = $ffa2a1db328a73be$export$2e2bcd8739ae039;

});

parcelRegister("5U5Co", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $eEJlK = parcelRequire("eEJlK");

const $e89c2dce08d13de9$var$messages = (0, $aXWIB.defineMessages)({
    reply: {
        id: "inline-comments-common.comments.replies.footer.reply",
        defaultMessage: "Reply"
    }
});
const $e89c2dce08d13de9$export$6310bd4b9bdb4fe0 = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { handleReplyButtonClick: handleReplyButtonClick, isOffline: isOffline, spacing: spacing } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($e89c2dce08d13de9$var$messages.reply);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== handleReplyButtonClick || $[3] !== isOffline || $[4] !== spacing || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            spacing: spacing,
            appearance: "subtle",
            isDisabled: isOffline,
            onClick: handleReplyButtonClick,
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($eEJlK)))
        }, t1);
        $[2] = handleReplyButtonClick;
        $[3] = isOffline;
        $[4] = spacing;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
module.exports["ReplyButton"] = $e89c2dce08d13de9$export$6310bd4b9bdb4fe0;

});

parcelRegister("cvKwQ", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

function $9dd4f54ac42e790d$export$e30f6438d916be51({ ari: ari, containerAri: containerAri, emojiId: emojiId, action: action }) {
    if (!(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true)) return undefined;
    if (action === 'add') return {
        __typename: 'Mutation',
        confluence_addReaction: {
            __typename: 'ConfluenceReactionPayload',
            ari: ari,
            containerAri: containerAri,
            emojiId: emojiId
        }
    };
    else return {
        __typename: 'Mutation',
        deleteReaction: {
            __typename: 'SaveReactionResponse',
            ari: ari,
            containerAri: containerAri,
            emojiId: emojiId
        }
    };
}
function $9dd4f54ac42e790d$export$c67071b423b9ef04({ commentId: commentId, adfString: adfString, sessionDisplayName: sessionDisplayName }) {
    return {
        updateComment: {
            __typename: 'Comment',
            id: commentId,
            body: {
                __typename: 'DocumentBody',
                value: adfString
            },
            version: {
                __typename: 'Version',
                number: 2,
                when: new Date().toISOString(),
                by: {
                    __typename: 'KnownUser',
                    displayName: sessionDisplayName
                }
            }
        }
    };
}
module.exports["getOptimisticResponse"] = $9dd4f54ac42e790d$export$e30f6438d916be51;
module.exports["getEditCommentOptimisticResponse"] = $9dd4f54ac42e790d$export$c67071b423b9ef04;

});


//# sourceMappingURL=CommentsPanelWrapper.dcd758ad.js.map
